/* ============================================================
   GetMyRugs storefront — vanilla interactions
   Mirrors js/desktop.jsx, js/pdp.jsx, js/mobile.jsx behaviors.
   No framework, no imports. Runs on DOMContentLoaded.
   build: track-your-rug live-fedex (2026-06-20)
   ============================================================ */
(function () {
  'use strict';

  /* ---------- helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); }
  function money(cents) {
    var n = (Number(cents) || 0) / 100;
    var s = (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));
    var dot = s.indexOf('.');
    var intp = dot === -1 ? s : s.slice(0, dot);
    var rest = dot === -1 ? '' : s.slice(dot);
    return '$' + intp.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + rest; // thousands separator to match Shopify's money filter
  }

  /* "Spend more, save more" cart progress — keeps every [data-tierprog] bar
     (cart drawer + cart page) in sync with the live cart. Thresholds (cents)
     come from the element's data-t1/t2/t3 and mirror the automatic discounts. */
  function updateTierProgress(cart) {
    var els = $all('[data-tierprog]');
    if (!els.length) return;
    // items_subtotal_price = subtotal before order discounts (mirrors the tier minimum).
    var sub = cart ? (Number(cart.items_subtotal_price) || Number(cart.total_price) || 0) : 0;
    els.forEach(function (el) {
      var t1 = Number(el.getAttribute('data-t1')) || 29900;
      var t2 = Number(el.getAttribute('data-t2')) || 49900;
      var t3 = Number(el.getAttribute('data-t3')) || 69900;
      var msg;
      if (sub >= t3)      msg = 'You’ve unlocked your best reward — <b>30% off</b>.';
      else if (sub >= t2) msg = '<b>20% off</b> unlocked — add <b>' + money(t3 - sub) + '</b> more for <b>30% off</b>.';
      else if (sub >= t1) msg = '<b>10% off</b> unlocked — add <b>' + money(t2 - sub) + '</b> more for <b>20% off</b>.';
      else                msg = 'Add <b>' + money(t1 - sub) + '</b> more to unlock <b>10% off</b>.';
      var msgEl = $('.tierprog__msg', el);
      var fillEl = $('.tierprog__fill', el);
      if (msgEl) msgEl.innerHTML = msg;
      if (fillEl) fillEl.style.width = Math.min(sub / t3, 1) * 100 + '%';
      if (sub >= t3) el.setAttribute('data-max', ''); else el.removeAttribute('data-max');
    });
  }

  /* Shows the ACTUAL reward discount applied to the cart (cart.total_discount) on every
     [data-cart-save] row. Truthful — reflects the live Shopify automatic discount, not the
     aspirational progress-bar tier. Hidden when nothing is discounted. */
  function updateCartSavings(cart) {
    var els = $all('[data-cart-save]');
    if (!els.length) return;
    var disc = (cart && Number(cart.total_discount)) || 0;
    var orig = (cart && Number(cart.original_total_price)) || 0;
    var pct = (disc > 0 && orig > 0) ? '(' + Math.round(disc / orig * 100) + '%)' : '';
    els.forEach(function (el) {
      el.hidden = disc <= 0;
      var amt = $('[data-cart-save-amt]', el);
      var pctEl = $('[data-cart-save-pct]', el);
      if (amt) amt.textContent = '−' + money(disc);
      if (pctEl) pctEl.textContent = pct;
    });
  }

  /* ---------- design-studio matching tables ----------
     Shared constants for the room→colour-family scorer, used by both the
     Design Studio page (initDesignStudio) and the listing "Match me" mode
     (initListingMatch) via createMatcher(). Pure data — no DOM, no state. */
  var DS_TOK = {
    wall: {
      'warm-white': ['warm white', 'soft cream', 'cream'],
      'cream': ['cream', 'soft cream', 'warm cream'],
      'greige': ['greige', 'beige', 'warm beige', 'warm taupe'],
      'soft-dove': ['soft dove', 'dove', 'pale gray', 'soft gray'],
      'cool-slate': ['cool slate', 'slate', 'steel', 'crisp mint'],
      'pale-sky': ['pale sky', 'sky', 'pale blue'],
      'soft-sage': ['soft sage', 'sage', 'deep forest', 'deep olive'],
      'warm-clay': ['warm clay', 'clay', 'terracotta', 'bronze', 'deep chocolate'],
      'mushroom-taupe': ['mushroom taupe', 'taupe', 'mushroom', 'soft taupe', 'warm sand'],
      'blush': ['blush', 'soft blush', 'pale mauve', 'deep burgundy'],
      'deep-navy': ['deep navy', 'classic navy', 'deep teal', 'deep plum'],
      'deep-charcoal': ['deep charcoal', 'charcoal', 'stark black']
    },
    floor: {
      'light-oak': ['light oak', 'natural oak', 'warm oak', 'light ash'],
      'dark-wood': ['walnut', 'espresso', 'dark ebony', 'smoke oak'],
      'whitewashed': ['whitewashed', 'whitewashed plank', 'whitewashed composite'],
      'concrete': ['polished concrete', 'warm concrete', 'industrial concrete'],
      'white-marble': ['white marble', 'porcelain'],
      'travertine': ['travertine', 'sandstone'],
      'jute': ['jute', 'sisal', 'cork'],
      'grey-vinyl': ['gray vinyl', 'gray luxury', 'cool gray', 'gray tile', 'silver travertine'],
      'terracotta-tile': ['terracotta tile', 'saltillo', 'terracotta'],
      'slate': ['slate', 'blue stone', 'blue slate']
    },
    furn: {
      'airy': ['cream', 'ivory', 'bright white', 'natural oak', 'rattan', 'boucle'],
      'warm-wood': ['walnut', 'cognac', 'caramel', 'camel leather', 'warm brass', 'caned'],
      'cool-moody': ['matte black', 'charcoal gray', 'soft gray', 'wrought iron', 'navy', 'smoked glass', 'black metal'],
      'mixed': []
    }
  };
  var DS_TEMP = {
    wall: { 'warm-white': 'warm', 'cream': 'warm', 'greige': 'neutral', 'soft-dove': 'cool', 'cool-slate': 'cool', 'pale-sky': 'cool', 'soft-sage': 'neutral', 'warm-clay': 'warm', 'mushroom-taupe': 'neutral', 'blush': 'warm', 'deep-navy': 'cool', 'deep-charcoal': 'neutral' },
    floor: { 'light-oak': 'warm', 'dark-wood': 'warm', 'whitewashed': 'neutral', 'concrete': 'cool', 'white-marble': 'cool', 'travertine': 'warm', 'jute': 'warm', 'grey-vinyl': 'cool', 'terracotta-tile': 'warm', 'slate': 'cool' },
    furn: { 'airy': 'neutral', 'warm-wood': 'warm', 'cool-moody': 'cool', 'mixed': 'neutral' }
  };
  var DS_STYLE = {
    modern: { temp: 'Cool', fams: ['grey', 'black', 'cream', 'navy', 'blue'] },
    scandi: { temp: 'Neutral', fams: ['cream', 'natural', 'grey', 'blue'] },
    boho: { temp: 'Warm', fams: ['multi', 'orange', 'red', 'teal', 'camel'] },
    traditional: { temp: 'Warm', fams: ['red', 'navy', 'brown', 'cream'] },
    farmhouse: { temp: 'Warm', fams: ['natural', 'camel', 'brown', 'cream'] },
    coastal: { temp: 'Cool', fams: ['blue', 'navy', 'teal', 'cream'] },
    glam: { temp: 'Cool', fams: ['navy', 'black', 'purple', 'grey'] }
  };
  var DS_NEIGH = {
    blue: ['navy', 'teal', 'grey'], navy: ['blue', 'teal', 'grey'], teal: ['blue', 'navy', 'green'],
    grey: ['blue', 'navy', 'black'], green: ['teal', 'natural'], purple: ['blue', 'grey', 'pink'],
    red: ['orange', 'pink', 'brown'], orange: ['red', 'camel', 'brown'], brown: ['camel', 'natural', 'cream'],
    camel: ['brown', 'natural', 'orange'], natural: ['cream', 'camel', 'brown'], cream: ['natural', 'camel'],
    black: ['grey'], pink: ['red', 'purple'], multi: ['orange', 'red', 'teal']
  };
  var DS_ROOM_LABEL = { living: 'living room', bedroom: 'bedroom', dining: 'dining room', office: 'home office', entryway: 'entryway' };
  var DS_WALL_LABEL = { 'warm-white': 'warm white', 'cream': 'cream', 'greige': 'greige', 'soft-dove': 'soft dove', 'cool-slate': 'slate', 'pale-sky': 'pale blue', 'soft-sage': 'sage', 'warm-clay': 'clay', 'mushroom-taupe': 'taupe', 'blush': 'blush', 'deep-navy': 'navy', 'deep-charcoal': 'charcoal' };
  var DS_FLOOR_LABEL = { 'light-oak': 'light oak', 'dark-wood': 'dark wood', 'whitewashed': 'whitewashed', 'concrete': 'concrete', 'white-marble': 'marble', 'travertine': 'warm-stone', 'jute': 'natural-fibre', 'grey-vinyl': 'grey', 'terracotta-tile': 'terracotta', 'slate': 'slate' };
  var DS_FURN_LABEL = { 'airy': 'light, airy', 'warm-wood': 'warm-wood', 'cool-moody': 'dark', 'mixed': 'mixed' };
  var DS_W = { desire: 6, wall: 2, floor: 2, furn: 1.5, temp: 1, style: 0.8 };

  function init() {
    initPromo();
    initHero();
    initStickyHeader();
    initMegaMenu();
    initSearch();
    initSearchBar();
    initRoomPhotoSearch();
    initMobileDrawer();
    initCartDrawer();
    initCartBar();
    initCartPage();
    initPdp();
    initValue();
    initSizeGuide();
    initSeoToggle();
    initFilters();
    initListingCways();
    initLoombar();
    initLbCue();
    var lbCueRz;
    on(window, 'resize', function () { clearTimeout(lbCueRz); lbCueRz = setTimeout(initLbCue, 150); });
    initDesignStudio();
    initListingMatch();
    initRails();
    initPhotoWall();
    initReviews();
    initRipple();
    initSmartSearch();
    initTrackRug();
    try { initFinder(); } catch (e) {}
    try { initSortDd(); } catch (e) {}
    try { initHeroVideo(); } catch (e) {}
    try { initSizeFold(); } catch (e) {}
    try { initFinderFold(); } catch (e) {}
  }

  /* mobile PDP: collapse the size tiles to one row + "+N sizes" expander */
  function initSizeFold() {
    var wrap = $('.opt__sizes');
    if (!wrap) return;
    var tiles = $all('.sizebtn', wrap);
    if (tiles.length <= 4 || !window.matchMedia('(max-width: 749px)').matches) return;
    wrap.classList.add('opt__sizes--folded');
    var more = document.createElement('button');
    more.type = 'button';
    more.className = 'sizebtn sizebtn--more';
    more.innerHTML = '<b>+' + (tiles.length - 3) + ' sizes</b><em>tap to see all</em>';
    on(more, 'click', function () { wrap.classList.remove('opt__sizes--folded'); more.remove(); });
    wrap.appendChild(more);
    // if the shopper's selected size is hidden in the fold, unfold immediately
    var onIdx = tiles.findIndex ? tiles.findIndex(function (t) { return t.classList.contains('sizebtn--on'); })
                                : tiles.map(function (t) { return t.classList.contains('sizebtn--on'); }).indexOf(true);
    if (onIdx > 2) { wrap.classList.remove('opt__sizes--folded'); more.remove(); }
  }

  /* homepage finder: folded <details> invitation card on mobile, open on desktop */
  function initFinderFold() {
    var d = $('[data-finder-fold]');
    if (!d) return;
    if (window.matchMedia('(min-width: 750px)').matches) d.setAttribute('open', '');
  }
/* ============================================================
   FINDER — "Find your rug in 3 taps" (room → colour → size).
   Anti-bounce homepage hero tool for cold mobile social traffic.
   Markup (authored in the section): a <section class="gmr-finder"
   data-finder> with three [data-finder-step="room|color|size"]
   panels, each holding <a class="gmr-finder__opt" data-finder-opt
   data-axis data-val href="<single-dimension fallback>"> options,
   a progress bar <div class="gmr-finder__bar"><i data-finder-bar></i>,
   a result <a data-finder-go>, and a no-JS [.gmr-finder__fallback].
   Works with JS off (each option/fallback is a real link); JS adds
   .is-ready (which hides the fallback via CSS) and upgrades the flow
   to a single combined-facet destination.
   Routing (validated live): /collections/{room||all} with appended
   filter.v.option.color={Color}&filter.v.option.size={url-enc size}.
   ============================================================ */
function initFinder() {
  var root = $('[data-finder]');
  if (!root) return;
  root.classList.add('is-ready'); // CSS hides the no-JS fallback once JS is live

  var go = $('[data-finder-go]', root);
  var preview = $('[data-finder-preview]', root);
  var goDefault = go ? go.innerHTML : '';
  var state = { room: '', color: '', size: '' };
  var started = false;
  var seq = 0, timer = null; // seq = race guard for out-of-order fetches

  // /collections/{room||all}?filter.v.option.color=…&filter.v.option.size=… (validated routing)
  function build() {
    var base = state.room ? '/collections/' + state.room : '/collections/all';
    var p = [];
    if (state.color) p.push('filter.v.option.color=' + state.color);
    if (state.size) p.push('filter.v.option.size=' + state.size);
    return base + (p.length ? '?' + p.join('&') : '');
  }
  function sync() { if (go) go.href = build(); }
  function fire(stage) {
    document.dispatchEvent(new CustomEvent('gmr:finder', {
      detail: { stage: stage, room: state.room, color: state.color, size: state.size }
    }));
  }
  function anySelected() { return !!(state.room || state.color || state.size); }
  function setGoLabel(count) {
    if (!go) return;
    go.innerHTML = (count == null)
      ? goDefault
      : 'See all ' + count + ' rug' + (count === 1 ? '' : 's') + ' <span aria-hidden="true">→</span>';
  }

  // Inline live preview — fetch the built collection URL via the Section Rendering API
  // and show the first matching rugs without leaving the page. Debounced + race-guarded.
  function schedulePreview() { if (timer) clearTimeout(timer); timer = setTimeout(loadPreview, 320); }
  function loadPreview() {
    if (!preview) return;
    if (!anySelected()) { preview.hidden = true; preview.innerHTML = ''; setGoLabel(null); return; }
    var token = ++seq;
    var url = build();
    url += (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=gmr-finder-results';
    preview.hidden = false;
    preview.innerHTML = '<p class="gmr-finder__pmsg">Finding your rugs…</p>';
    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (token !== seq) return; // a newer selection superseded this one
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var res = doc.querySelector('[data-finder-res]');
        var count = res ? parseInt(res.getAttribute('data-count'), 10) : NaN;
        var cards = $all('.pc', doc);
        if (!cards.length) {
          preview.innerHTML = '<p class="gmr-finder__pmsg">No exact match — try fewer filters.</p>';
          setGoLabel(null);
          return;
        }
        var grid = document.createElement('div');
        grid.className = 'gmr-finder__pgrid';
        cards.slice(0, 6).forEach(function (c) { grid.appendChild(document.importNode(c, true)); });
        preview.innerHTML = '';
        preview.appendChild(grid);
        setGoLabel(isNaN(count) ? null : count);
      })
      .catch(function () {
        if (token !== seq) return;
        preview.hidden = true; preview.innerHTML = ''; setGoLabel(null);
      });
  }

  // COLOUR swatches — tap to select, tap again to clear (single-select)
  on(root, 'click', function (e) {
    var c = e.target && e.target.closest ? e.target.closest('a.gmr-finder__c') : null;
    if (!c || !root.contains(c)) return;
    e.preventDefault();
    var val = c.getAttribute('data-val') || '';
    var was = c.getAttribute('aria-pressed') === 'true';
    $all('a.gmr-finder__c', root).forEach(function (x) {
      x.classList.remove('is-selected');
      x.setAttribute('aria-pressed', 'false');
    });
    if (was) {
      state.color = '';
    } else {
      state.color = val;
      c.classList.add('is-selected');
      c.setAttribute('aria-pressed', 'true');
    }
    if (!started) { started = true; fire('start'); }
    sync(); fire('step'); schedulePreview();
  });

  // ROOM + SIZE — custom <details> dropdowns (native <select> popups get
  // displaced by the global body{overflow-x:clip}; this list is ours to place).
  $all('[data-finder-dd]', root).forEach(function (dd) {
    var axis = dd.getAttribute('data-axis');
    var valEl = $('[data-dd-val]', dd);
    on(dd, 'click', function (e) {
      var opt = e.target && e.target.closest ? e.target.closest('.gmr-finder__ddopt') : null;
      if (!opt || !dd.contains(opt)) return;
      e.preventDefault();
      state[axis] = opt.getAttribute('data-val') || '';
      if (valEl) valEl.textContent = opt.textContent;
      $all('.gmr-finder__ddopt', dd).forEach(function (o) { o.classList.remove('is-active'); o.setAttribute('aria-selected', 'false'); });
      opt.classList.add('is-active'); opt.setAttribute('aria-selected', 'true');
      dd.open = false;
      if (!started) { started = true; fire('start'); }
      sync(); fire('step'); schedulePreview();
    });
  });
  // close any open dropdown on outside click / Escape
  on(document, 'click', function (e) {
    $all('[data-finder-dd][open]', root).forEach(function (dd) { if (!dd.contains(e.target)) dd.open = false; });
  });
  on(document, 'keydown', function (e) {
    if (e.key === 'Escape') $all('[data-finder-dd][open]', root).forEach(function (dd) { dd.open = false; });
  });

  if (go) on(go, 'click', function () { go.href = build(); fire('complete'); });
  sync();
}

/* ============================================================
   HERO VIDEO — loading indicator over the poster while the mp4
   buffers (and on mid-play stalls); auto-hides once it plays. The %
   is the fraction of the clip's duration that's buffered (native —
   keeps progressive playback). Markup: .hero__loader in gmr-home.liquid.
   ============================================================ */
function initHeroVideo() {
  var v = document.querySelector('.hero__video');
  var loader = document.querySelector('[data-hero-loader]');
  if (!v || !loader) return;
  var pctEl = loader.querySelector('[data-hero-pct]');
  function show() { loader.classList.remove('is-hidden'); }
  function hide() { loader.classList.add('is-hidden'); }
  function update() {
    var p = 0;
    try {
      if (v.duration && v.buffered && v.buffered.length) {
        p = Math.min(100, Math.round(v.buffered.end(v.buffered.length - 1) / v.duration * 100));
      }
    } catch (e) {}
    if (pctEl) pctEl.textContent = p + '%';
  }
  on(v, 'progress', update);
  on(v, 'loadeddata', update);
  on(v, 'playing', function () { update(); hide(); });
  on(v, 'waiting', function () { update(); show(); });   // mid-play stall → show again
  on(v, 'error', hide);
  var src = v.querySelector('source');                   // <source> errors don't bubble to <video>, so listen here too
  if (src) on(src, 'error', hide);
  // reveal only if it isn't already playing shortly after load (avoids a flash on fast connections)
  setTimeout(function () { if (v.paused || v.readyState < 3) { update(); show(); } }, 350);
  // safety net: always drop the loader after 12s — if the video never plays (e.g. the mp4 fails to load),
  // the poster is a perfectly good static hero, so never leave a spinner stuck over it.
  setTimeout(hide, 12000);
}

/* ============================================================
   SORT DROPDOWN — custom <details> sort control on collection/search.
   Native <select> popups are displaced by the page's overflow:clip, so
   gmr-sort.liquid keeps the native <select> as the form value + no-JS
   fallback and we drive a custom list. On pick: set the select + submit
   the form (the form carries hidden facet inputs, so facets persist).
   ============================================================ */
function initSortDd() {
  var forms = $all('.gmr-sortform');
  if (!forms.length) return;
  forms.forEach(function (form) {
    var dd = $('[data-gmr-sortdd]', form);
    var native = $('select[data-gmr-sort-native]', form);
    if (!dd || !native) return;
    form.classList.add('js-ready'); // CSS hides the native <select>, shows the custom UI
    on(dd, 'click', function (e) {
      var opt = e.target && e.target.closest ? e.target.closest('.gmr-finder__ddopt') : null;
      if (!opt || !dd.contains(opt)) return;
      e.preventDefault();
      native.value = opt.getAttribute('data-val') || '';
      dd.open = false;
      if (native.form) native.form.submit();
    });
  });
  on(document, 'click', function (e) {
    $all('[data-gmr-sortdd][open]').forEach(function (dd) { if (!dd.contains(e.target)) dd.open = false; });
  });
  on(document, 'keydown', function (e) {
    if (e.key === 'Escape') $all('[data-gmr-sortdd][open]').forEach(function (dd) { dd.open = false; });
  });
}

/* ============================================================
   SUB-NAV — sticky "Shop rugs" category strip that appears once the
   hero/finder scrolls out of view (keeps the catalogue one tap away
   for cold scrollers). Markup (authored in the section): a
   <nav class="catnav" data-catnav data-rail> with .catnav__link items.
   The swipe/arrow behaviour is already wired by initRails (catnav
   carries data-rail) — this only handles the show/hide on scroll.
   ============================================================ */
function initSubnav() {
  var bar = $('[data-catnav]');
  if (!bar) return;
  var hdr = document.querySelector('.hdr');

  // Reveal the catnav only AFTER the whole top cluster (hero → finder → feature/discount
  // bars) has scrolled past — so it NEVER overlays the finder. Threshold = absolute bottom
  // of the last top-cluster element (discount bar, else finder, else hero).
  function threshold() {
    var a = document.querySelector('.gmr-save') || document.querySelector('.gmr-finder') || document.querySelector('.hero');
    return a ? (a.getBoundingClientRect().bottom + window.pageYOffset - 56) : 600;
  }
  // Pin the bar directly below the sticky header so it never hides behind it.
  function place() { if (hdr) { var b = hdr.getBoundingClientRect().bottom; bar.style.top = (b > 0 ? b : 0) + 'px'; } }
  function update() {
    var show = window.pageYOffset > threshold();
    if (show) place();
    bar.classList.toggle('catnav--show', show);
    document.body.classList.toggle('gmr-catnav-on', show);
  }
  on(window, 'scroll', update, { passive: true });
  on(window, 'resize', update, { passive: true });
  update();

  on(bar, 'click', function (e) {
    var link = e.target && e.target.closest ? e.target.closest('a.catnav__link') : null;
    if (!link || !bar.contains(link)) return;
    document.dispatchEvent(new CustomEvent('gmr:subnav', {
      detail: { href: link.getAttribute('href'), label: (link.textContent || '').trim() }
    }));
    // it's an <a> — default navigation proceeds
  });
}

  /* ============================================================
     1) PROMO BAR — rotate messages, dismiss
     Markup: .promo with one .promo__msg[data-i] per message,
     a .promo__center wrapper, and a .promo__x close button.
     ============================================================ */
  function initPromo() {
    var promo = $('.promo');
    if (!promo) return;

    var msgs = $all('.promo__msg', promo);
    if (msgs.length > 1) {
      // show only the first, hide the rest
      msgs.forEach(function (m, i) { m.removeAttribute('hidden'); m.style.display = i === 0 ? '' : 'none'; });
      var cur = 0;
      setInterval(function () {
        msgs[cur].style.display = 'none';
        cur = (cur + 1) % msgs.length;
        var next = msgs[cur];
        next.style.display = '';
        // re-trigger the promoIn fade animation
        next.style.animation = 'none';
        // force reflow
        void next.offsetWidth;
        next.style.animation = '';
      }, 4200);
    }

    var x = $('.promo__x', promo);
    on(x, 'click', function () { promo.style.display = 'none'; });
  }

  /* ============================================================
     1b) HERO CAROUSEL — auto-rotating slides + dot nav.
     Markup: .hero[data-hero] with .hero__slide[data-hero-slide] (.is-active
     on the visible one), dots .hero__dot[data-hero-dot=i] (.is-on on active).
     Crossfade is CSS (opacity); JS just toggles classes on a timer.
     ============================================================ */
  function initHero() {
    var root = $('[data-hero]');
    if (!root) return;
    var slides = $all('[data-hero-slide]', root);
    var dots = $all('[data-hero-dot]', root);
    if (slides.length < 2) return;
    var i = 0, timer = null;
    var DURATION = 6000;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, si) { s.classList.toggle('is-active', si === i); });
      dots.forEach(function (d, di) {
        var on = di === i;
        d.classList.toggle('is-on', on);
        d.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() { if (reduce) return; stop(); timer = setInterval(function () { show(i + 1); }, DURATION); }
    dots.forEach(function (d) {
      on(d, 'click', function () { show(+d.getAttribute('data-hero-dot')); start(); });
    });
    on(root, 'mouseenter', stop);
    on(root, 'mouseleave', start);
    on(document, 'visibilitychange', function () { if (document.hidden) { stop(); } else { start(); } });
    show(0);
    start();
  }

  /* ============================================================
     2) STICKY HEADER — toggle .hdr--scrolled on window scroll
     ============================================================ */
  function initStickyHeader() {
    var hdr = $('.hdr');
    if (!hdr) return;
    /* mobile: fold the search band into an icon once scrolling starts (.hdr--slim);
       tapping the icon re-expands and focuses the input. Desktop never slims. */
    var slimMq = window.matchMedia('(max-width: 749px)');
    var searchInput = $('[data-search-input]');
    var slimToggle = $('[data-slim-search]');
    var slimHold = false; // user tapped the icon — stay expanded until the input blurs
    /* HYSTERESIS — do not collapse this to a single threshold again.
       .hdr sits in normal flow, so folding the search band makes the header 67px
       shorter and yanks every following element up by 67px. With one threshold at
       140 a finger resting near that point re-triggered on almost every movement
       (measured: 11 toggles in 12 small scrolls), and each toggle lurched the page
       67px — which reads as the header flickering or the page reloading.
       Folding at 140 but only unfolding below 80 gives a 60px dead band, so a
       crossing has to be deliberate. */
    var SLIM_ON = 140;
    var SLIM_OFF = 80;
    var onScroll = function () {
      if (window.scrollY > 12) hdr.classList.add('hdr--scrolled');
      else hdr.classList.remove('hdr--scrolled');
      var searching = searchInput && (document.activeElement === searchInput || (searchInput.value && searchInput.value.length));
      if (!slimMq.matches || slimHold || searching) { hdr.classList.remove('hdr--slim'); return; }
      var isSlim = hdr.classList.contains('hdr--slim');
      if (!isSlim && window.scrollY > SLIM_ON) hdr.classList.add('hdr--slim');
      else if (isSlim && window.scrollY < SLIM_OFF) hdr.classList.remove('hdr--slim');
    };
    if (slimToggle) on(slimToggle, 'click', function () {
      slimHold = true;
      hdr.classList.remove('hdr--slim');
      if (searchInput) setTimeout(function () { searchInput.focus(); }, 260);
    });
    if (searchInput) on(searchInput, 'blur', function () { slimHold = false; });
    on(window, 'scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ============================================================
     3) MEGA MENU — hover open/close with intent delay + scrim
     Nav items: [data-menu="rugs"|"collections"] inside .nav.
     Panels:    .mega[data-menu="..."] (rendered, hidden by default).
     ============================================================ */
  function initMegaMenu() {
    var hdr = $('.hdr');
    if (!hdr) return;
    var triggers = $all('[data-menu]', hdr).filter(function (el) {
      return !el.classList.contains('mega'); // exclude the panels themselves
    });
    var panels = $all('.mega[data-menu]', hdr);
    if (!triggers.length || !panels.length) return;

    var scrim = ensureScrim();
    var closeTimer = null;
    var openTimer = null;
    var OPEN_DELAY = 500; // RugsUSA-style hover-intent: wait before opening on hover
    var current = null;

    function panelFor(name) {
      for (var i = 0; i < panels.length; i++) {
        if (panels[i].getAttribute('data-menu') === name) return panels[i];
      }
      return null;
    }

    function show(name) {
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      // close search if open
      hideSearch();
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-menu') !== name; });
      triggers.forEach(function (t) {
        t.classList.toggle('nav__item--open', t.getAttribute('data-menu') === name);
      });
      scrim.hidden = false;
      current = name;
    }

    function hide() {
      clearTimeout(openTimer);
      panels.forEach(function (p) { p.hidden = true; });
      triggers.forEach(function (t) { t.classList.remove('nav__item--open'); });
      if (!isSearchOpen()) scrim.hidden = true;
      current = null;
    }

    triggers.forEach(function (t) {
      var name = t.getAttribute('data-menu');
      on(t, 'mouseenter', function () {
        clearTimeout(openTimer);
        if (current) {
          show(name); // a menu is already open → switch instantly (RugsUSA-style)
        } else {
          openTimer = setTimeout(function () { show(name); }, OPEN_DELAY);
        }
      });
      // cancel a pending open if the pointer leaves before the delay elapses
      on(t, 'mouseleave', function () { clearTimeout(openTimer); });
    });

    // keep open while hovering the panel
    panels.forEach(function (p) {
      on(p, 'mouseenter', function () { clearTimeout(closeTimer); });
    });

    // leaving the whole header closes after 140ms
    on(hdr, 'mouseleave', function () {
      closeTimer = setTimeout(hide, 140);
    });

    on(scrim, 'click', function () { hide(); hideSearch(); });

    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && current) hide();
    });

    // expose for search module
    megaHide = hide;
  }

  var megaHide = function () {};

  /* shared fixed scrim used by mega + search.
     Appended to <body> (NOT .hdr) so it sits below the header's stacking
     context — the page dims behind the menu while the header bar/search stay
     bright and keep receiving hover, so moving between tabs switches panels. */
  function ensureScrim() {
    var scrim = $('.scrim');
    if (!scrim) {
      scrim = document.createElement('div');
      scrim.className = 'scrim';
      scrim.hidden = true;
      document.body.appendChild(scrim);
    } else {
      scrim.hidden = true;
    }
    return scrim;
  }

  /* ============================================================
     4) SEARCH PANEL — toggle .search-panel + scrim, focus input
     Trigger: .util__btn that opens search (data-search-toggle, or
     the search button — identified by [aria-label="Search"]).
     ============================================================ */
  var searchPanelEl = null;
  function isSearchOpen() { return searchPanelEl && !searchPanelEl.hidden; }
  function hideSearch() {
    if (searchPanelEl) searchPanelEl.hidden = true;
    var scrim = $('.scrim');
    if (scrim && !$all('.mega[data-menu]').some(function (p) { return !p.hidden; })) {
      scrim.hidden = true;
    }
  }

  function initSearch() {
    var hdr = $('.hdr');
    if (!hdr) return;
    searchPanelEl = $('.search-panel', hdr);
    if (!searchPanelEl) return;
    searchPanelEl.hidden = true;

    var scrim = ensureScrim();
    var btn = $('[data-search-toggle]', hdr) || $('.util__btn[aria-label="Search"]', hdr);
    var closeBtn = $('.search-field .promo__x', searchPanelEl) || $('[data-search-close]', searchPanelEl);
    var input = $('input', searchPanelEl);

    function open() {
      megaHide();
      searchPanelEl.hidden = false;
      scrim.hidden = false;
      if (input) input.focus();
    }
    function close() {
      searchPanelEl.hidden = true;
      if (!$all('.mega[data-menu]').some(function (p) { return !p.hidden; })) scrim.hidden = true;
    }

    on(btn, 'click', function (e) {
      e.preventDefault();
      if (searchPanelEl.hidden) open(); else close();
    });
    on(closeBtn, 'click', function (e) { e.preventDefault(); close(); });
    on(scrim, 'click', close);
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && !searchPanelEl.hidden) close();
    });

    hideSearch = close; // rebind to the real closer
  }

  /* ------------------------------------------------------------
     4b) SEARCH BAR — live autosuggest on the always-on header input.
     Focus → curated empty state; type → Shopify predictive search
     (/search/suggest.json): matching rugs (thumb+name+price) + query
     completions + collections + "see all". Arrow/Enter keyboard nav.
     Idle: rotating placeholder. Graceful if predictive search is off.
     ------------------------------------------------------------ */
  function initSearchBar() {
    var input = $('[data-smart-placeholder]');
    if (!input) return;
    var wrap = input.closest('.sbar-wrap');
    var panel = wrap && $('[data-search-panel]', wrap);

    if (wrap && panel) {
      var emptyEl = $('[data-search-empty]', panel);
      var resEl = $('[data-search-results]', panel);
      var hlItems = [], hlIdx = -1, reqSeq = 0, debTimer = null;
      var ICON_SEARCH = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"></circle><path d="M21 21l-4.2-4.2"></path></svg>';
      var ICON_GRID = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1.5"></rect><rect x="14" y="3" width="7" height="7" rx="1.5"></rect><rect x="3" y="14" width="7" height="7" rx="1.5"></rect><rect x="14" y="14" width="7" height="7" rx="1.5"></rect></svg>';

      function esc(s) { var d = document.createElement('div'); d.textContent = (s == null ? '' : '' + s); return d.innerHTML; }
      function money(v) { var n = parseFloat(v); if (isNaN(n)) return ''; return '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2)); }
      function qHref(q) { return '/search?q=' + encodeURIComponent(q) + '&type=product'; }
      function clearHl() { hlItems.forEach(function (a) { a.classList.remove('is-hl'); }); hlItems = []; hlIdx = -1; }
      function showEmpty() { clearHl(); if (resEl) { resEl.hidden = true; resEl.innerHTML = ''; } if (emptyEl) emptyEl.hidden = false; }
      function openP() { megaHide(); panel.hidden = false; }
      function closeP() { panel.hidden = true; clearHl(); }

      on(input, 'focus', function () { openP(); var q = input.value.trim(); if (q) suggest(q); else showEmpty(); });
      on(input, 'click', function () { openP(); });
      on(document, 'click', function (e) { if (!wrap.contains(e.target)) closeP(); });
      on($('.nav'), 'mouseenter', closeP);

      on(document, 'keydown', function (e) {
        if (panel.hidden) return;
        if (e.key === 'Escape') { closeP(); input.blur(); return; }
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          hlItems = $all('a[href]', panel).filter(function (a) { return a.offsetParent !== null; });
          if (!hlItems.length) return;
          e.preventDefault();
          if (hlIdx >= 0 && hlItems[hlIdx]) hlItems[hlIdx].classList.remove('is-hl');
          hlIdx = e.key === 'ArrowDown' ? (hlIdx + 1) % hlItems.length : (hlIdx <= 0 ? hlItems.length - 1 : hlIdx - 1);
          hlItems[hlIdx].classList.add('is-hl');
          hlItems[hlIdx].scrollIntoView({ block: 'nearest' });
        } else if (e.key === 'Enter') {
          if (hlIdx >= 0 && hlItems[hlIdx]) { e.preventDefault(); window.location.href = hlItems[hlIdx].getAttribute('href'); }
        }
      });

      on(input, 'input', function () {
        var q = input.value.trim();
        clearHl();
        if (debTimer) clearTimeout(debTimer);
        if (!q) { showEmpty(); return; }
        if (emptyEl) emptyEl.hidden = true;
        debTimer = setTimeout(function () { suggest(q); }, 170);
      });

      // Shopify predictive suggest literal-matches the whole phrase, so a natural-language
      // query ("red rugs for living room") returns 0 products even though red rugs exist.
      // When the raw phrase finds nothing, retry with a keyword-only query (drop filler +
      // room words) so we SHOW the closest matching rugs instead of a contradictory dead end.
      var SB_STOP = {};
      ('for the a an my our your in on at with and or to of me i we want wants need needs looking look find show please near under over from is are some any that this these those home house ' +
       'living room rooms bedroom bed dining kitchen hallway hall entry entryway foyer mudroom office study nursery bathroom bath lounge family drawing sitting corridor passage space spaces')
        .split(' ').forEach(function (w) { SB_STOP[w] = 1; });
      function sbSimplify(q) {
        var toks = q.toLowerCase().replace(/[^a-z0-9'×x.\s-]/g, ' ').split(/\s+/)
          .filter(function (t) { return t && !SB_STOP[t]; });
        return toks.join(' ').trim() || 'rug';
      }
      function fetchSuggest(q, cb) {
        var url = '/search/suggest.json?q=' + encodeURIComponent(q)
          + '&resources[type]=product,query,collection&resources[limit]=6'
          + '&resources[options][unavailable_products]=last'
          // include variants.sku so a Design number (N00816 — the SKU prefix) or a full SKU
          // (N00816K0000A9G) surfaces the rug live in the dropdown (verified: normal word
          // queries behave the same with this field list, so it's on unconditionally)
          + '&resources[options][fields]=' + encodeURIComponent('title,product_type,vendor,tag,variants.sku,variants.title');
        fetch(url, { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (j) { cb((j.resources && j.resources.results) || {}); })
          .catch(function () { cb(null); });
      }
      function suggest(rawQ) {
        var seq = ++reqSeq;
        fetchSuggest(rawQ, function (r) {
          if (seq !== reqSeq || input.value.trim() !== rawQ) return;
          if (r === null) { renderAllOnly(rawQ); return; }
          if (!(r.products && r.products.length)) {
            var q2 = sbSimplify(rawQ);
            if (q2 && q2 !== rawQ.toLowerCase()) {
              fetchSuggest(q2, function (r2) {
                if (seq !== reqSeq || input.value.trim() !== rawQ) return;
                var ok = r2 && r2.products && r2.products.length;
                render(rawQ, ok ? r2 : (r2 || r), ok ? q2 : null);
              });
              return;
            }
          }
          render(rawQ, r, null);
        });
      }

      function render(q, r, hintTerm) {
        var prods = r.products || [], queries = r.queries || [], colls = r.collections || [];
        var h = '<div class="sg-cols"><div class="sg-side"><div class="sg-lbl">Suggestions</div><div class="sg-list">';
        h += '<a class="sg-row sg-row--go" href="' + qHref(q) + '">' + ICON_SEARCH + '<span>' + esc(q) + '</span></a>';
        queries.forEach(function (qq) {
          var t = (qq && qq.text) || '';
          if (t && t.toLowerCase() !== q.toLowerCase()) h += '<a class="sg-row" href="' + qHref(t) + '">' + ICON_SEARCH + '<span>' + esc(t) + '</span></a>';
        });
        h += '</div>';
        if (colls.length) {
          h += '<div class="sg-lbl" style="margin-top:13px">Collections</div><div class="sg-list">';
          colls.slice(0, 3).forEach(function (c) { h += '<a class="sg-row" href="' + esc(c.url) + '">' + ICON_GRID + '<span>' + esc(c.title) + '</span></a>'; });
          h += '</div>';
        }
        h += '</div><div class="sg-main">';
        if (prods.length) {
          h += '<div class="sg-lbl">' + (hintTerm ? 'Closest matches' : 'Rugs') + '</div><div class="sg-prods">';
          prods.slice(0, 6).forEach(function (p) {
            var img = p.image || (p.featured_image && p.featured_image.url) || '';
            if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=140';
            var price = (p.price_min && p.price_max && p.price_min !== p.price_max) ? ('From ' + money(p.price_min)) : money(p.price_min || p.price);
            h += '<a class="sg-prod" href="' + esc(p.url) + '">'
              + '<span class="sg-prod__img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</span>'
              + '<span class="sg-prod__txt"><span class="sg-prod__name">' + esc(p.title) + '</span>'
              + '<span class="sg-prod__meta">' + esc(p.type || 'Rug') + (price ? ' &middot; ' + price : '') + '</span></span></a>';
          });
          h += '</div>';
        } else {
          h += '<div class="sg-msg">Browse all matches for &ldquo;' + esc(q) + '&rdquo; below &darr;</div>';
        }
        h += '</div></div>';
        h += '<a class="sg-all" href="' + qHref(q) + '">See all results for &ldquo;' + esc(q) + '&rdquo; <span aria-hidden="true">&rarr;</span></a>';
        resEl.innerHTML = h; resEl.hidden = false; if (emptyEl) emptyEl.hidden = true;
        clearHl();
      }

      function renderAllOnly(q) {
        resEl.innerHTML = '<a class="sg-all" style="border:0;margin:0;padding:8px 2px" href="' + qHref(q) + '">See all results for &ldquo;' + esc(q) + '&rdquo; <span aria-hidden="true">&rarr;</span></a>';
        resEl.hidden = false; if (emptyEl) emptyEl.hidden = true;
      }
    }

    /* Design/SKU lookup on submit — a code-shaped query (Design number like N00816, or a full
       SKU like N00816K0000A9G) prefix-matches variants.sku in predictive search, but the /search
       RESULTS page only whole-word-matches (a bare design prefix finds nothing there). So on
       submit we resolve the code via suggest.json and jump straight to the rug; no match (or
       fetch failure) falls through to the normal search page. Wired on both header forms
       (desktop .sbar + mobile .m-search). */
    function sbIsCode(q) { return /^[a-z]{1,2}\d{3,}[a-z0-9]*$/i.test(q); }
    $all('form[action="/search"]').forEach(function (f) {
      on(f, 'submit', function (e) {
        var qi = f.querySelector('input[name="q"]');
        var q = qi ? qi.value.trim() : '';
        if (!sbIsCode(q)) return;
        e.preventDefault();
        var fallback = '/search?q=' + encodeURIComponent(q) + '&type=product';
        fetch('/search/suggest.json?q=' + encodeURIComponent(q)
          + '&resources[type]=product&resources[limit]=1'
          + '&resources[options][fields]=' + encodeURIComponent('variants.sku,title'),
          { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (j) {
            var p = j.resources && j.resources.results && j.resources.results.products && j.resources.results.products[0];
            window.location.href = (p && p.url) ? p.url : fallback;
          })
          .catch(function () { window.location.href = fallback; });
      });
    });

    /* idle: rotating "smart search" placeholder (pauses while focused/typing) */
    var examples = [
      'Search 1,000+ handmade rugs…',
      '“blue rug for the bedroom”',
      '“a 9×12 wool rug in green”',
      '“runner for the hallway”',
      '“round jute rug under $149”',
      '“something soft for the living room”'
    ];
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var i = 0;
    setInterval(function () {
      if (document.hidden || input.value || document.activeElement === input) return;
      input.classList.add('is-swapping');
      setTimeout(function () {
        i = (i + 1) % examples.length;
        input.placeholder = examples[i];
        input.classList.remove('is-swapping');
      }, 280);
    }, 3400);
  }

  /* ------------------------------------------------------------
     4c) ROOM-PHOTO SEARCH — the camera button in the header search bar
     (desktop .sbar + mobile .m-search). Snap/upload a room photo → we read
     the wall band (upper part of the frame) and floor band (bottom) off a
     small canvas, classify each against the Design Studio's wall/floor
     options (DS_TOK keys), stash the result in sessionStorage and land on
     /pages/design-studio, where initDesignStudio() applies it and reveals
     scored matches immediately — same engine as the app's "Point your
     camera at a room".
     ------------------------------------------------------------ */
  var ROOM_WALL_REF = { 'warm-white': [245, 239, 226], 'cream': [241, 231, 206], 'greige': [214, 204, 187], 'soft-dove': [217, 217, 214], 'cool-slate': [174, 182, 187], 'pale-sky': [203, 220, 231], 'soft-sage': [183, 196, 173], 'warm-clay': [192, 135, 107], 'mushroom-taupe': [183, 167, 148], 'blush': [229, 195, 192], 'deep-navy': [46, 62, 85], 'deep-charcoal': [74, 74, 72] };
  var ROOM_FLOOR_REF = { 'light-oak': [201, 168, 118], 'dark-wood': [92, 69, 49], 'whitewashed': [228, 221, 209], 'concrete': [173, 170, 164], 'white-marble': [233, 231, 226], 'travertine': [216, 196, 164], 'jute': [199, 176, 137], 'grey-vinyl': [159, 161, 163], 'terracotta-tile': [176, 106, 74], 'slate': [110, 122, 130] };
  function initRoomPhotoSearch() {
    function nearest(rgb, refs) {
      var best = null, bd = Infinity;
      Object.keys(refs).forEach(function (k) {
        var r = refs[k];
        // green weighted up, blue slightly down — closer to perceived colour distance
        var d = (rgb[0] - r[0]) * (rgb[0] - r[0]) + 1.2 * (rgb[1] - r[1]) * (rgb[1] - r[1]) + 0.9 * (rgb[2] - r[2]) * (rgb[2] - r[2]);
        if (d < bd) { bd = d; best = k; }
      });
      return best;
    }
    function region(cx, w, h, x0, y0, x1, y1) {
      var d = cx.getImageData(Math.round(w * x0), Math.round(h * y0), Math.max(1, Math.round(w * (x1 - x0))), Math.max(1, Math.round(h * (y1 - y0)))).data;
      var r = 0, g = 0, b = 0, n = 0;
      for (var i = 0; i < d.length; i += 4) { r += d[i]; g += d[i + 1]; b += d[i + 2]; n++; }
      return [r / n, g / n, b / n];
    }
    $all('[data-room-cam]').forEach(function (btn) {
      var scope = btn.closest('form') || btn.parentNode;
      var input = scope.querySelector('[data-room-cam-input]');
      if (!input) return;
      on(btn, 'click', function (e) { e.preventDefault(); input.click(); });
      on(input, 'change', function () {
        var f = input.files && input.files[0];
        if (!f) return;
        btn.classList.add('is-busy');
        var url = URL.createObjectURL(f);
        var img = new Image();
        function go() { window.location.href = '/pages/design-studio'; }
        img.onload = function () {
          try {
            var w = 160, h = Math.max(1, Math.round(img.naturalHeight * (w / img.naturalWidth)));
            var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
            var cx = cv.getContext('2d', { willReadFrequently: true });
            cx.drawImage(img, 0, 0, w, h);
            var wall = nearest(region(cx, w, h, 0.15, 0.08, 0.85, 0.38), ROOM_WALL_REF);
            var floor = nearest(region(cx, w, h, 0.15, 0.80, 0.85, 0.98), ROOM_FLOOR_REF);
            sessionStorage.setItem('gmrRoomShot', JSON.stringify({ wall: wall, floor: floor }));
          } catch (err) { /* analysis failed -> plain Design Studio */ }
          URL.revokeObjectURL(url);
          go();
        };
        img.onerror = function () { URL.revokeObjectURL(url); go(); };
        img.src = url;
      });
    });
  }

  /* ============================================================
     5) MOBILE DRAWER — hamburger toggles drawer; accordion rows
     Classes (mobile.css): .m-drawer, .m-scrim, .m-acc / .m-acc--open
     Hamburger: [data-mobile-toggle] or .m-iconbtn[aria-label="Menu"]
     ============================================================ */
  function initMobileDrawer() {
    var drawer = $('.m-drawer');
    var toggle = $('[data-drawer-toggle]') || $('[data-mobile-toggle]') || $('.util__btn[aria-label="Menu"]') || $('.m-iconbtn[aria-label="Menu"]');

    if (drawer) {
      var scrim = $('.m-scrim');
      if (!scrim) {
        scrim = document.createElement('div');
        scrim.className = 'm-scrim';
        if (drawer.parentNode) drawer.parentNode.insertBefore(scrim, drawer);
      }
      var closeBtn = $('.m-drawer__head .m-iconbtn', drawer) || $('[data-mobile-close]', drawer);

      function openDrawer() { drawer.hidden = false; scrim.hidden = false; }
      function closeDrawer() { drawer.hidden = true; scrim.hidden = true; }

      drawer.hidden = true;
      scrim.hidden = true;

      on(toggle, 'click', function (e) { e.preventDefault(); openDrawer(); });
      on(closeBtn, 'click', function (e) { e.preventDefault(); closeDrawer(); });
      on(scrim, 'click', closeDrawer);
      on(document, 'keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) closeDrawer(); });

      // accordion rows
      $all('.m-acc', drawer).forEach(function (acc) {
        var btn = $('.m-acc__btn', acc);
        // only rows that actually have a panel are toggleable
        if (btn && $('.m-acc__panel', acc)) {
          on(btn, 'click', function (e) {
            e.preventDefault();
            acc.classList.toggle('m-acc--open');
          });
        }
      });
    }
  }

  /* ============================================================
     6) CART DRAWER — open .drawer (+ .drawer-scrim), fetch /cart.js,
     render line items, qty change via /cart/change.js, checkout.
     No free-shipping threshold bar (free shipping on every order).
     ============================================================ */
  var openCartDrawer = function () {}; // exposed so PDP add-to-cart can reuse
  var cartNotice = function () {};     // exposed so PDP add-to-cart can show cart errors

  function initCartDrawer() {
    var drawer = $('.drawer');
    var scrim = $('.drawer-scrim');
    var cartBtn = $('[data-cart-toggle]') ||
                  $('.util__btn[aria-label="Cart"]') ||
                  $('.m-iconbtn[aria-label="Cart"]');

    if (!drawer) return;

    if (!scrim) {
      scrim = document.createElement('div');
      scrim.className = 'drawer-scrim';
      if (drawer.parentNode) drawer.parentNode.insertBefore(scrim, drawer);
    }
    drawer.hidden = true;
    scrim.hidden = true;

    var body = $('.drawer__body', drawer);
    var head = $('.drawer__head h3', drawer);
    var subtotalEl = $('.subtotal b', drawer);
    var upsellEl = $('gmr-cart-upsell', drawer);
    var closeBtn = $('.drawer__x', drawer) || $('[data-cart-close]', drawer);
    var checkoutBtn = $('.btn-checkout', drawer);

    // Third-party launchers (RepAI chat, etc.) sit fixed in the bottom-right
    // corner — exactly where the drawer footer (subtotal + checkout) lives, so
    // they overlap it. Hide any such corner widget while the drawer is open,
    // then restore it on close.
    var stashedWidgets = [];
    function hideCornerWidgets() {
      stashedWidgets = [];
      try { if (window.rep && typeof window.rep.hide === 'function') window.rep.hide(); } catch (e) {}
      var vw = window.innerWidth, vh = window.innerHeight;
      Array.prototype.forEach.call(document.body.children, function (el) {
        if (el === drawer || el === scrim || el.nodeType !== 1) return;
        if (el.tagName === 'SCRIPT' || el.tagName === 'STYLE' || el.tagName === 'LINK') return;
        var cs = window.getComputedStyle(el);
        if (cs.position !== 'fixed' || cs.display === 'none' || cs.visibility === 'hidden') return;
        var r = el.getBoundingClientRect();
        if (r.width < 24 || r.height < 24 || r.width > 380 || r.height > 460) return;
        if ((vw - r.right) > 90 || (vh - r.bottom) > 90) return; // not pinned bottom-right
        el.style.setProperty('visibility', 'hidden', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
        stashedWidgets.push(el);
      });
    }
    function showCornerWidgets() {
      try { if (window.rep && typeof window.rep.show === 'function') window.rep.show(); } catch (e) {}
      stashedWidgets.forEach(function (el) {
        el.style.removeProperty('visibility');
        el.style.removeProperty('pointer-events');
      });
      stashedWidgets = [];
    }

    function open() {
      drawer.hidden = false;
      scrim.hidden = false;
      document.body.classList.add('gmr-drawer-on');
      hideCornerWidgets();
      load();
    }
    function close() { drawer.hidden = true; scrim.hidden = true; document.body.classList.remove('gmr-drawer-on'); showCornerWidgets(); }

    function load() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () {});
    }

    function render(cart) {
      if (!cart || cart.status >= 400 || typeof cart.item_count === 'undefined') return;
      document.dispatchEvent(new CustomEvent('gmr:cart', { detail: cart }));
      if (head) head.textContent = 'Cart · ' + cart.item_count;
      if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
      updateTierProgress(cart);
      updateCartSavings(cart);

      // cross-sell carousel — related rugs for the first cart item
      if (upsellEl && typeof upsellEl.load === 'function') {
        if (cart.items && cart.items.length) {
          upsellEl.load(cart.items[0].product_id);
        } else {
          upsellEl.hidden = true;
          upsellEl.removeAttribute('data-loaded-for');
        }
      }

      // badge in the header
      var badge = $('.util__badge') || $('.m-badge');
      if (badge) {
        badge.textContent = cart.item_count;
        badge.style.display = cart.item_count > 0 ? '' : 'none';
      }

      if (!body) return;
      // empty cart: no subtotal/checkout footer — .drawer--empty hides .drawer__foot (gmr.css)
      var drawerEl = body.closest('.drawer');
      if (drawerEl) drawerEl.classList.toggle('drawer--empty', !cart.items || !cart.items.length);
      if (!cart.items || !cart.items.length) {
        body.innerHTML =
          '<div class="empty"><p>Your cart is empty</p>' +
          '<button class="btn-checkout" data-cart-close style="max-width:220px;margin:0 auto">Continue Shopping</button></div>';
        var cont = $('[data-cart-close]', body);
        on(cont, 'click', close);
        return;
      }

      body.innerHTML = cart.items.map(function (it, idx) {
        var opts = (it.options_with_values || [])
          .map(function (o) { return o.value; })
          .filter(function (v) { return v && v !== 'Default Title'; })
          .join(' · ');
        var thumbSrc = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=148' : '';
        var imgInner = it.image
          ? '<img class="ph" src="' + thumbSrc + '" alt="' + escapeHtml(it.product_title || it.title) +
            '" width="74" height="74" loading="lazy" style="object-fit:cover">'
          : '<div class="ph weave"><span class="weave__tag" style="font-size:8px;left:5px;bottom:4px">' +
            escapeHtml(it.product_title || it.title) + '</span></div>';
        var img = '<a class="cart-item__media" href="' + (it.url || '#') + '">' + imgInner + '</a>';
        return '' +
          '<div class="cart-item" data-line="' + (idx + 1) + '" data-key="' + it.key + '">' +
            img +
            '<div class="info">' +
              '<a class="cart-item__name" href="' + (it.url || '#') + '"><b>' + escapeHtml(it.product_title || it.title) + '</b></a>' +
              (opts ? '<span>' + escapeHtml(opts) + '</span>' : '') +
              '<div class="qty">' +
                '<button type="button" data-qty-down aria-label="Decrease">–</button>' +
                '<span data-qty>' + it.quantity + '</span>' +
                '<button type="button" data-qty-up aria-label="Increase">+</button>' +
              '</div>' +
            '</div>' +
            '<div style="display:flex;flex-direction:column;align-items:flex-end;gap:8px">' +
              '<div class="price">' + money(it.original_line_price) + '</div>' +
              '<button class="promo__x" data-qty-remove style="color:var(--ink-3);font-size:11px">Remove</button>' +
            '</div>' +
          '</div>';
      }).join('');

      $all('.cart-item', body).forEach(function (row) {
        var line = Number(row.getAttribute('data-line'));
        var qty = Number($('[data-qty]', row).textContent);
        on($('[data-qty-down]', row), 'click', function () { change(line, qty - 1); });
        on($('[data-qty-up]', row), 'click', function () { change(line, qty + 1); });
        on($('[data-qty-remove]', row), 'click', function () { change(line, 0); });
      });
    }

    function change(line, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: Math.max(0, quantity) })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res && res.status && res.status >= 400) {
            cartNotice(res.description || res.message || "That's the maximum quantity available.");
            load(); // re-sync drawer with the real (unchanged) cart
            return;
          }
          render(res);
        })
        .catch(function () {});
    }

    on(cartBtn, 'click', function (e) { e.preventDefault(); open(); });
    on(closeBtn, 'click', close);
    on(scrim, 'click', close);
    on(document, 'keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) close(); });
    on(checkoutBtn, 'click', function (e) {
      // empty-state Continue Shopping button reuses .btn-checkout but has data-cart-close
      if (checkoutBtn.hasAttribute('data-cart-close')) return;
      e.preventDefault();
      window.location.href = '/checkout';
    });

    // toast for cart errors (e.g. inventory max reached) — reused by the
    // drawer qty steppers and the PDP add-to-cart intercept.
    var noticeTimer;
    cartNotice = function (msg) {
      var el = $('.gmr-cart-toast');
      if (!el) {
        el = document.createElement('div');
        el.className = 'gmr-cart-toast';
        el.setAttribute('role', 'status');
        el.style.cssText = 'position:fixed;top:18px;left:50%;transform:translateX(-50%) translateY(-12px);' +
          'max-width:90vw;background:var(--ink-1,#2b2622);color:#fff;padding:11px 18px;border-radius:10px;' +
          'font-size:14px;line-height:1.35;box-shadow:0 8px 28px rgba(0,0,0,.22);z-index:100000;' +
          'opacity:0;pointer-events:none;transition:opacity .22s ease,transform .22s ease;text-align:center';
        document.body.appendChild(el);
      }
      el.textContent = msg;
      el.style.opacity = '0';
      el.style.transform = 'translateX(-50%) translateY(-12px)';
      void el.offsetWidth; // force reflow so the transition plays (not reliant on rAF/tab focus)
      el.style.opacity = '1';
      el.style.transform = 'translateX(-50%) translateY(0)';
      clearTimeout(noticeTimer);
      noticeTimer = setTimeout(function () {
        el.style.opacity = '0';
        el.style.transform = 'translateX(-50%) translateY(-12px)';
      }, 2600);
    };

    openCartDrawer = open;
  }

  /* ============================================================
     STICKY CART BAR — bottom strip shown whenever the cart has items.
     Markup: [data-cartbar] in gmr-header.liquid. Content updates live via
     the 'gmr:cart' event dispatched from the cart drawer's render(), plus
     an initial /cart.js fetch on page load. Hides itself when empty.
     ============================================================ */
  function initCartBar() {
    var bar = document.querySelector('[data-cartbar]');
    if (!bar) return;
    var imgEl = $('[data-cartbar-img]', bar);
    var totalEl = $('[data-cartbar-total]', bar);
    var openBtn = $('[data-cartbar-open]', bar);

    function sized(url) {
      if (!url) return '';
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=120';
    }

    function render(cart) {
      if (!cart || !cart.item_count) { bar.classList.remove('is-show'); return; }
      var items = cart.items || [];
      var last = items[items.length - 1] || items[0]; // most recently added

      var textEl = $('.cartbar__text', bar);
      var nameEl = $('[data-cartbar-name]', bar);
      var variantEl = $('[data-cartbar-variant]', bar);
      var countEl = $('[data-cartbar-count]', bar);

      if (last) {
        if (imgEl) {
          var src = last.image || (last.featured_image && last.featured_image.url) || '';
          imgEl.src = sized(src);
          imgEl.alt = last.product_title || last.title || '';
        }
        if (nameEl) nameEl.textContent = last.product_title || last.title || 'Your rug';

        // Colour · Shape · Size — same source as the cart drawer's variant string,
        // rendered with clay separator dots (<b>·</b>) for an editorial cadence.
        var optVals = (last.options_with_values || [])
          .map(function (o) { return o.value; })
          .filter(function (v) { return v && v !== 'Default Title'; });
        if (variantEl) {
          if (optVals.length) {
            variantEl.innerHTML = optVals.map(escapeHtml).join('<b>·</b>');
            variantEl.hidden = false;
          } else {
            variantEl.innerHTML = '';
            variantEl.hidden = true;
          }
        }
        // give the name more room / vertical centring when there's no variant line
        if (textEl) textEl.classList.toggle('is-solo', !optVals.length);
      }

      // "+N" badge on the thumb for multi-item carts (N = units beyond the most-recent line)
      if (countEl) {
        var extra = cart.item_count - (last ? (last.quantity || 1) : 1);
        if (extra > 0) { countEl.textContent = '+' + extra; countEl.hidden = false; }
        else { countEl.textContent = ''; countEl.hidden = true; }
      }

      if (totalEl) totalEl.textContent = money(cart.total_price);
      bar.hidden = false;
      requestAnimationFrame(function () { bar.classList.add('is-show'); });
    }

    if (openBtn) on(openBtn, 'click', function () {
      if (typeof openCartDrawer === 'function') openCartDrawer();
    });

    document.addEventListener('gmr:cart', function (e) { render(e.detail); });

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {});
  }

  /* ============================================================
     CART PAGE — /cart route (section gmr-cart). The qty +/-/remove are
     plain <a href="/cart/change?..."> links (no-JS fallback). Without JS a
     "+" past available stock does a full navigation to /cart/change and
     Shopify renders a raw HTTP 422 page. This intercepts those links:
       • caps "+" at the line's available inventory (data-max) with a notice,
       • routes changes through /cart/change.js (graceful — no error page),
       • updates the page in place from the returned cart JSON (qty, line
         price, subtotal, tier bar, savings) — no reload, no error page.
     Rows are matched by line-item key (robust to re-indexing on removal).
     Delegated on document so it keeps working as rows are added/removed.
     ============================================================ */
  function initCartPage() {
    if (!$('.gmr-cartform')) return; // only on a non-empty cart page
    var busy = false;
    var selfUpdate = false; // true while this page applies its OWN change, so its gmr:cart dispatch is ignored by the re-sync listener

    function applyCaps() {
      $all('.gmr-cartform .cart-item[data-max]').forEach(function (row) {
        var max = parseInt(row.getAttribute('data-max'), 10);
        var qEl = $('[data-qty]', row);
        var up = $('[data-qty-up]', row);
        if (!up || !qEl || isNaN(max)) return;
        var atMax = Number(qEl.textContent) >= max;
        up.classList.toggle('qty--max', atMax);
        up.setAttribute('aria-disabled', atMax ? 'true' : 'false');
      });
    }
    applyCaps();

    // Reflect a cart object in the page rows by POSITION (not line key: the
    // automatic order discount re-allocates per line on every change, which
    // mutates each line item's key, so keys are unreliable here). Rows render
    // in cart order, so DOM row order mirrors cart.items order.
    function syncRows(cart) {
      $all('.gmr-cartform .cart-item').forEach(function (row, i) {
        var it = cart.items[i];
        if (!it) { row.remove(); return; }
        row.setAttribute('data-line', i + 1);
        var qEl = $('[data-qty]', row);
        var pEl = $('.price', row);
        if (qEl) qEl.textContent = it.quantity;
        if (pEl) pEl.textContent = money(it.original_line_price);
      });
      var sub = $('.gmr-cartform .subtotal b');
      if (sub) sub.textContent = money(cart.total_price);
      updateTierProgress(cart);
      updateCartSavings(cart);
      applyCaps();
    }

    // a change made through THIS page's steppers — drop the removed row first
    // (so positional matching stays aligned), then re-sync the rest.
    function updateCartPage(cart, changedLine, removed) {
      if (removed) {
        var gone = $('.gmr-cartform .cart-item[data-line="' + changedLine + '"]');
        if (gone) gone.remove();
      }
      syncRows(cart);
    }

    function change(line, quantity, isIncrease, row) {
      if (busy) return;
      if (isIncrease && row) {
        var max = parseInt(row.getAttribute('data-max'), 10);
        if (!isNaN(max) && quantity > max) {
          cartNotice(max <= 0 ? 'This item is out of stock.' : 'Only ' + max + ' available — that\'s the maximum.');
          return;
        }
      }
      var qn = Math.max(0, quantity);
      busy = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qn })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          busy = false;
          if (res && res.status && res.status >= 400) {
            cartNotice(res.description || res.message || 'That\'s the maximum quantity available.');
            return;
          }
          if (!res.items || !res.items.length) { window.location.reload(); return; } // empty -> show empty state
          selfUpdate = true;
          document.dispatchEvent(new CustomEvent('gmr:cart', { detail: res })); // keep the sticky cart bar in sync
          selfUpdate = false;
          updateCartPage(res, line, qn === 0);
        })
        .catch(function () { busy = false; window.location.reload(); });
    }

    // delegated — matches the cart-page qty links even as rows change
    on(document, 'click', function (e) {
      if (!e.target || !e.target.closest) return;
      var btn = e.target.closest('[data-qty-up],[data-qty-down],[data-qty-remove]');
      if (!btn || !btn.closest('.gmr-cartform')) return;
      e.preventDefault();
      var row = btn.closest('.cart-item');
      if (!row) return;
      var line = Number(row.getAttribute('data-line'));
      var qEl = $('[data-qty]', row);
      var cur = qEl ? Number(qEl.textContent) : 1;
      if (btn.hasAttribute('data-qty-remove')) change(line, 0, false, row);
      else if (btn.hasAttribute('data-qty-up')) change(line, cur + 1, true, row);
      else change(line, cur - 1, false, row);
    });

    // A cart change made elsewhere while on this page (e.g. via the still-
    // reachable cart drawer) fires 'gmr:cart'. Re-sync the page rows so they
    // can't go stale; if a line was added/removed (count changed) positional
    // matching can't safely realign, so reload.
    on(document, 'gmr:cart', function (e) {
      if (selfUpdate) return; // our own dispatch — updateCartPage handles it
      var cart = e.detail;
      if (!cart || !$('.gmr-cartform')) return;
      if (!cart.items || $all('.gmr-cartform .cart-item').length !== cart.items.length) {
        window.location.reload();
        return;
      }
      syncRows(cart);
    });
  }

  /* ============================================================
     SIZE GUIDE — open/close the PDP size-guide popup.
     Trigger: [data-sizeguide-open]; panel: [data-sizeguide-modal];
     scrim: [data-sizeguide-scrim]; close: [data-sizeguide-close].
     ============================================================ */
  function initSizeGuide(){
    var __sgRoot = document.querySelector(".sgx-overlay");
    /* Runs for BOTH the modal (.sgx-overlay) and the full guide page, which
       embeds the same visualizer markup. Each block guards on its own elements. */
/* ============ DATA ============ */
  var SIZES = [
    {ft:"2′ × 3′",          cm:"61 × 91 cm",   w:2,   h:3,   tag:"Accent",     shape:"rect",   bf:["Thresholds & basins","Entryways, by the kitchen sink, bedside steps."]},
    {ft:"3′ × 5′",          cm:"91 × 152 cm",  w:3,   h:5,   tag:"Small",      shape:"rect",   bf:["Reading nook","An armchair, a foyer, a soft landing."]},
    {ft:"5′ × 8′",          cm:"152 × 244 cm", w:5,   h:8,   tag:"Medium",     shape:"rect",   bf:["Compact living","Apartments, sitting rooms, the foot of a bed."]},
    {ft:"6′ × 9′",          cm:"183 × 274 cm", w:6,   h:9,   tag:"Medium +",   shape:"rect",   bf:["Anchored seating","Front legs of the sofa on, balanced & calm."]},
    {ft:"8′ × 10′",         cm:"244 × 305 cm", w:8,   h:10,  tag:"Large",      shape:"rect",   bf:["Full living room","All furniture on, the room's true centre."]},
    {ft:"9′ × 12′",         cm:"274 × 366 cm", w:9,   h:12,  tag:"Grand",      shape:"rect",   bf:["Open plan","Queen / king beds, generous lounges."]},
    {ft:"10′ × 13′",        cm:"305 × 396 cm", w:10,  h:13,  tag:"Statement",  shape:"rect",   bf:["Great rooms","Lofty spaces, king beds, dining for eight."]},
    {ft:"2′6″ × 8′",        cm:"76 × 244 cm",  w:2.5, h:8,   tag:"Runner",     shape:"runner", bf:["Hallways & galleys","Leave 4–5″ of floor on each side."]},
    {ft:"Round 6′7″",       cm:"Ø 200 cm",     w:6.6, h:6.6, tag:"Round",      shape:"round",  bf:["Soft corners","Round tables, nurseries, breakfast nooks."]}
  ];

  /* ============ LADDER (section II) ============ */
  var LADDER_PPF = 9;
  var ladder = document.getElementById("ladder");
  var ladUnit = "ft";
  var rugSrcEl = document.getElementById("rugImg");
  var RUG_SRC = rugSrcEl ? rugSrcEl.getAttribute("href") : "";

  function renderLadder(){
    var html = "";
    for(var i=0;i<SIZES.length;i++){
      var s = SIZES[i];
      var dim  = ladUnit==="ft" ? s.ft : s.cm;
      var sub  = ladUnit==="ft" ? s.cm : s.ft;
      var cls = "swatch" + (s.shape==="runner"?" runner":"") + (s.shape==="round"?" round":"");
      var lng = Math.max(s.w, s.h), sht = Math.min(s.w, s.h);
      var style = "width:"+Math.round(lng*LADDER_PPF)+"px;height:"+Math.round(sht*LADDER_PPF)+"px;";
      if(s.shape==="round"){ var d = Math.round(s.w*LADDER_PPF); style = "width:"+d+"px;height:"+d+"px;"; }
      html += '<div class="rung">'
        + '<div class="dims"><span class="ft">'+dim+'</span><span class="cm">'+sub+'</span><span class="tag">'+s.tag+'</span></div>'
        + '<div class="bar"><div class="'+cls+'" style="'+style+'">'+(RUG_SRC?'<img class="swatch__rug" src="'+RUG_SRC+'" alt="">':'')+'</div></div>'
        + '<div class="bestfor"><b>'+s.bf[0]+'</b>'+s.bf[1]+'</div>'
        + '</div>';
    }
    ladder.innerHTML = html;
  }
  function setLadderUnit(u){
    ladUnit = u;
    var ft = document.getElementById("ladFtBtn"), cm = document.getElementById("ladCmBtn");
    ft.classList.toggle("active", u==="ft"); ft.setAttribute("aria-pressed", u==="ft");
    cm.classList.toggle("active", u==="cm"); cm.setAttribute("aria-pressed", u==="cm");
    renderLadder();
  }
  if(ladder){
    document.getElementById("ladFtBtn").addEventListener("click", function(){ setLadderUnit("ft"); });
    document.getElementById("ladCmBtn").addEventListener("click", function(){ setLadderUnit("cm"); });
    renderLadder();
  }

  /* ============ INTERACTIVE VISUALIZER (section I) ============ */
  var SCALE = 24;
  var rug   = document.getElementById("rugRect");
  var inner = document.getElementById("rugInner");
  var rugImg = document.getElementById("rugImg");
  var clipR  = document.getElementById("rugClipRect");
  var hasRugImg = !!(rugImg && clipR);
  var roVal = document.getElementById("roVal");
  var roCm  = document.getElementById("roCm");
  var ruleText = document.getElementById("ruleText");

  var rooms = {
    living:  document.getElementById("furnLiving"),
    bedroom: document.getElementById("furnBedroom"),
    dining:  document.getElementById("furnDining")
  };

  /* Per-room rug anchor. cx = horizontal centre; the rug grows from a FIXED TOP
     edge so geometry stays truthful: a small rug catches only the sofa front
     edge / table, never the armchairs floating ambiguously. */
  var roomCfg = {
    living:  { cx:320, top:100, label:"Living room",
      rule:"Anchor the seating with the rug under at least the <b>front legs</b> of the sofa and chairs, so the whole grouping reads as one connected island." },
    bedroom: { cx:320, top:128, label:"Bedroom",
      rule:"Slide the rug under the <b>lower two-thirds</b> of the bed — it should reach 18–24&nbsp;in past each side for that step-out softness." },
    dining:  { cx:320, cy:220, label:"Dining room",
      rule:"Go large enough that chairs stay <b>on the rug</b> when pulled out — about <b>24&nbsp;in past the table</b> on every side." }
  };

  var currentRoom = "living";
  var sel = document.querySelector('.chip[aria-pressed="true"]');
  var unit = "ft";

  function setRug(w, h, shape){
    var pw = w*SCALE, ph = h*SCALE;
    if(shape==="round"){ var d = Math.min(pw,ph); pw = ph = d; }
    var cfg = roomCfg[currentRoom];
    var x = cfg.cx - pw/2;
    var y = (cfg.cy != null) ? Math.round(cfg.cy - ph/2) : cfg.top;
    /* keep the rug inside the room frame (roomline spans x 14–626, y 14–426) even
       at the largest sizes — true scale is preserved, only the anchor is nudged. */
    x = Math.max(14, Math.min(x, 626 - pw));
    y = Math.max(14, Math.min(y, 426 - ph));
    var radius = (shape==="round") ? pw/2 : 3;

    rug.setAttribute("x", x);     rug.setAttribute("y", y);
    rug.setAttribute("width", pw);rug.setAttribute("height", ph);
    rug.setAttribute("rx", radius);

    if(hasRugImg){
      /* Overscan the image ~20% past the clip rect so the studio white border
         around the rug in the _2 photo gets cropped out; the clip stays at the
         true footprint so scale/shape are unaffected. */
      var f = 1.2, ox = pw*(f-1)/2, oy = ph*(f-1)/2;
      rugImg.setAttribute("x", x-ox);    rugImg.setAttribute("y", y-oy);
      rugImg.setAttribute("width", pw*f);rugImg.setAttribute("height", ph*f);
      clipR.setAttribute("x", x);        clipR.setAttribute("y", y);
      clipR.setAttribute("width", pw);   clipR.setAttribute("height", ph);
      clipR.setAttribute("rx", radius);
      inner.style.display = "none";
      return;
    }

    var inset = 14;
    if(pw > inset*2+10 && ph > inset*2+10){
      inner.style.display = "";
      inner.setAttribute("x", x+inset); inner.setAttribute("y", y+inset);
      inner.setAttribute("width", pw-inset*2); inner.setAttribute("height", ph-inset*2);
      inner.setAttribute("rx", (shape==="round") ? (pw-inset*2)/2 : 2);
    } else {
      inner.style.display = "none";
    }
  }

  function chipLabel(chip){ return chip.childNodes[0].textContent.trim(); }
  function chipCm(chip){ return chip.dataset.cm; }

  function selectChip(chip){
    if(sel) sel.removeAttribute("aria-pressed");
    sel = chip; chip.setAttribute("aria-pressed","true");
    setRug(parseFloat(chip.dataset.w), parseFloat(chip.dataset.h), chip.dataset.shape);
    updateReadout();
  }
  function updateReadout(){
    if(!sel) return;
    if(unit==="ft"){ roVal.textContent = chipLabel(sel); roCm.textContent = chipCm(sel); }
    else { roVal.textContent = chipCm(sel); roCm.textContent = chipLabel(sel); }
  }
  function selectRoom(room){
    currentRoom = room;
    var tabs = document.querySelectorAll(".tab");
    for(var i=0;i<tabs.length;i++){ tabs[i].setAttribute("aria-selected", tabs[i].dataset.room===room ? "true":"false"); }
    for(var k in rooms){ if(rooms.hasOwnProperty(k)) rooms[k].style.display = (k===room)?"":"none"; }
    var cfg = roomCfg[room];
    ruleText.innerHTML = "<b>"+cfg.label+" —</b> "+cfg.rule;
    if(sel) setRug(parseFloat(sel.dataset.w), parseFloat(sel.dataset.h), sel.dataset.shape);
  }

  function setVizUnit(u){
    unit = u;
    var ft = document.getElementById("ftBtn"), cm = document.getElementById("cmBtn");
    ft.classList.toggle("active", u==="ft"); ft.setAttribute("aria-pressed", u==="ft");
    cm.classList.toggle("active", u==="cm"); cm.setAttribute("aria-pressed", u==="cm");
    updateReadout();
  }
  if(rug){
    document.getElementById("chips").addEventListener("click", function(e){
      var chip = e.target.closest(".chip"); if(chip) selectChip(chip);
    });
    var tabEls = document.querySelectorAll(".tab");
    for(var t=0;t<tabEls.length;t++){
      (function(el){ el.addEventListener("click", function(){ selectRoom(el.dataset.room); }); })(tabEls[t]);
    }
    document.getElementById("ftBtn").addEventListener("click", function(){ setVizUnit("ft"); });
    document.getElementById("cmBtn").addEventListener("click", function(){ setVizUnit("cm"); });
    selectChip(sel);
  }

  /* ============ CTA / SHOP HOOKS + OPEN/CLOSE — modal only ============ */
  if(__sgRoot){
    var SHOP = {
      living:  "/collections/all?filter.v.option.size=8'+x+10'",
      bedroom: "/collections/all?filter.v.option.size=9'+x+12'",
      dining:  "/collections/all?filter.v.option.size=8'+x+10'"
    };
    __sgRoot.querySelectorAll("[data-shop]").forEach(function(b){
      b.addEventListener("click", function(){ window.location.href = SHOP[b.dataset.shop] || "/collections/all"; });
    });
    var fullBtn = __sgRoot.querySelector('[data-action="full-guide"]');
    if(fullBtn) fullBtn.addEventListener("click", function(){ window.location.href = "/pages/rugs-selection"; });
    var sbsBtn = __sgRoot.querySelector('[data-action="shop-by-size"]');
    if(sbsBtn) sbsBtn.addEventListener("click", function(){ window.location.href = "/collections/all"; });

    var opener = null;
    var openSG = function(e){ if(e) opener = e.currentTarget; __sgRoot.classList.add("is-open"); document.body.style.overflow="hidden"; var x=__sgRoot.querySelector("[data-sizeguide-close]"); if(x) x.focus(); };
    var closeSG = function(){ __sgRoot.classList.remove("is-open"); document.body.style.overflow=""; if(opener && opener.focus) opener.focus(); };
    document.querySelectorAll("[data-sizeguide-open]").forEach(function(b){ b.addEventListener("click", openSG); });
    __sgRoot.querySelectorAll("[data-sizeguide-close]").forEach(function(b){ b.addEventListener("click", closeSG); });
    __sgRoot.addEventListener("click", function(e){ if(e.target===__sgRoot) closeSG(); });
    document.addEventListener("keydown", function(e){ if(e.key==="Escape" && __sgRoot.classList.contains("is-open")) closeSG(); });
  }

  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ============================================================
     7) PDP — gallery, variants, quantity, accordions, add-to-cart
     ============================================================ */
  function initPdp() {
    initGallery();
    initThumbScroll();
    initGalleryCarousel();
    initStickyAtc();
    initPdpAccordions();
    initVariants(); // also wires quantity steppers + add-to-cart
    initArButton();
    initColorways();
    initColorwaySwap();
  }

  /* VALUE — presentation-only. Eligibility + tier ship in assets/gmr-value.json
     -> { p: { "<productId>": "K"|"T"|"H" } } (the genuinely-below-market wool tiers).
     PDP: reveals the price-match guarantee (any eligible product) AND, when the selected size has
     a captured comparable that beats our price, a "Comparable retail / You save" line. The real
     comparable-retail figures (captured 2026-06-26 from live major-US-retailer listings) live here
     and are documented on /pages/best-price-guarantee. Cards: subtle guarantee badge. */
  var GMR_COMP = {
    K: { "3' x 5'": 450, "4' x 6'": 600, "5' x 8'": 799, "6' x 9'": 950, "8' x 10'": 1200, "9' x 12'": 1500, "10' x 13'": 1600, "10' x 14'": 1600 },
    T: { "3' x 5'": 185, "4' x 6'": 290, "5' x 8'": 399, "6' x 9'": 475, "8' x 10'": 699, "9' x 12'": 899, "10' x 13'": 949, "10' x 14'": 949 },
    H: { "3' x 5'": 249, "4' x 6'": 299, "5' x 8'": 349, "6' x 9'": 549, "8' x 10'": 599, "9' x 12'": 799, "10' x 13'": 999, "10' x 14'": 999 }
  };
  var _valMap = null, _valFetching = false;
  function initValue() {
    var pdp = $('[data-gmr-value]');
    var cards = $all('[data-pc-deal]');
    if (!pdp && !cards.length) return;
    if (_valMap) { valApply(_valMap); return; }
    if (_valFetching) return;
    var src = (pdp && pdp.getAttribute('data-src')) || (cards[0] && cards[0].getAttribute('data-src'));
    if (!src) return;
    _valFetching = true;
    fetch(src).then(function (r) { return r.json(); }).then(function (data) {
      _valMap = (data && data.p) ? data.p : {};
      valApply(_valMap);
    }).catch(function () {});
  }

  function valApply(P) {
    /* PDP: guarantee (presence) + per-size savings */
    var box = $('[data-gmr-value]');
    if (box) {
      var pe = P[String(box.getAttribute('data-pid'))];
      var tier = pe && pe[0];
      window.gmrValueUpdate = null;
      if (!tier) { box.hidden = true; }
      else {
        box.hidden = false;
        var comps = GMR_COMP[tier] || {};
        var json = null, sizeIdx = -1, dataEl = $('#gmr-product-json');
        if (dataEl) { try { json = JSON.parse(dataEl.textContent); } catch (e) {} }
        if (json && json.options) sizeIdx = json.options.indexOf('Size');
        var saveRow = box.querySelector('[data-gmr-save]');
        var compEl = box.querySelector('[data-gmr-comp]');
        var amtEl = box.querySelector('[data-gmr-saveamt]');
        var pctEl = box.querySelector('[data-gmr-savepct]');
        var paint = function (v) {
          if (!saveRow) return;
          var sz = (v && sizeIdx >= 0 && v.options) ? v.options[sizeIdx] : null;
          var comp = (sz && comps[sz]) ? comps[sz] : null;
          if (!comp || !v || comp * 100 <= v.price) { saveRow.hidden = true; return; }
          var compC = comp * 100, saveC = compC - v.price;
          if (compEl) compEl.textContent = money(compC);
          if (amtEl) amtEl.textContent = money(saveC);
          if (pctEl) pctEl.textContent = Math.round(saveC * 100 / compC) + '%';
          saveRow.hidden = false;
        };
        window.gmrValueUpdate = paint;
        var v0 = window.gmrCurrentVariant;
        if (!v0 && json && json.variants && json.variants.length) {
          for (var i = 0; i < json.variants.length; i++) { if (json.variants[i].available) { v0 = json.variants[i]; break; } }
          if (!v0) v0 = json.variants[0];
        }
        paint(v0);
      }
    }
    /* cards: struck comparable + "Save X%" (at the from-size) + price-match guarantee */
    var cards = $all('[data-pc-deal]');
    for (var c = 0; c < cards.length; c++) {
      var el = cards[c];                      // el = .pc__price — the selling price inside it is ALWAYS shown
      var cmpEl = el.querySelector('[data-pc-cmp]');
      var offEl = el.querySelector('[data-pc-off]');
      var ent = P[String(el.getAttribute('data-pid'))];
      var fromComp = ent ? (ent[1] || 0) : 0;
      var nowC = parseInt(el.getAttribute('data-now') || '0', 10);
      if (fromComp && nowC && fromComp * 100 > nowC) {
        if (cmpEl) { cmpEl.textContent = money(fromComp * 100); cmpEl.hidden = false; }
        if (offEl) { offEl.textContent = 'Save ' + Math.round((fromComp * 100 - nowC) * 100 / (fromComp * 100)) + '%'; offEl.hidden = false; }
      } else {
        /* not eligible, or cheapest size is a runner/odd size with no verified comp:
           just hide the marketplace comp + savings chip; the price line stays. */
        if (cmpEl) cmpEl.hidden = true;
        if (offEl) offEl.hidden = true;
      }
    }
  }

  /* COLOURWAY CIRCLES — show every colour a design comes in (each colour is its own
     product) as hero-colour dots under COLOR; clicking one opens that colour's page.
     Also fills the Colour-palette card from the same data when the product has no
     hero_color metafield. Data: assets/gmr-colorways.json -> { designCode: [colourways] }. */
  function initColorways() {
    var host = $('[data-gmr-cways]');
    var palHost = $('[data-gmr-pal-host]');
    if (!host && !palHost) return;
    var src = (host && host.getAttribute('data-src')) || (palHost && palHost.getAttribute('data-src'));
    if (!src) return;
    fetch(src).then(function (r) { return r.json(); }).then(function (map) {
      if (host) cwaysRender(host, map);
      if (palHost) cwaysPalette(palHost, map);
    }).catch(function () {});
  }

  // index the map by product id so a card/PDP only needs its data-pid (no design-code parsing in
  // the theme) — this is what lets coverage = whatever the Python grouping put in gmr-colorways.json.
  var _cwIdx = null;
  function cwaysIndex(map) {
    if (_cwIdx) return _cwIdx;
    _cwIdx = {};
    for (var k in map) { var g = map[k]; for (var i = 0; i < g.length; i++) _cwIdx[String(g[i].id)] = { group: g, entry: g[i] }; }
    return _cwIdx;
  }
  function cwaysFind(map, el) {
    var hit = cwaysIndex(map)[String(el.getAttribute('data-pid'))];
    if (!hit) return null;
    return { group: hit.group, cur: hit.entry, pid: String(el.getAttribute('data-pid')) };
  }

  function cwaysRender(host, map) {
    var f = cwaysFind(map, host);
    if (!f || f.group.length < 2) return; // single-colour design -> keep the native swatch
    var LIMIT = 18, frag = document.createDocumentFragment();
    f.group.forEach(function (e, i) {
      var isCur = String(e.id) === f.pid;
      var node = document.createElement(isCur ? 'span' : 'a');
      node.className = 'cway' + (isCur ? ' cway--on' : '') + (i >= LIMIT ? ' cway--extra' : '');
      if (!isCur) { node.href = e.u; node.setAttribute('data-cway-swap', ''); } // intercepted by initColorwaySwap (falls back to navigation)
      var lbl = e.label ? (e.label + (e.name && e.name !== e.label ? ' (' + e.name + ')' : '')) : e.name; // catalogue colour first, AI shade in brackets
      node.title = lbl; node.setAttribute('aria-label', lbl);
      var sw = document.createElement('span');
      sw.className = 'cway__sw'; sw.style.background = e.hex;
      node.appendChild(sw);
      frag.appendChild(node);
    });
    host.appendChild(frag);
    if (f.group.length > LIMIT) {
      var more = document.createElement('button');
      more.type = 'button'; more.className = 'cway-more';
      more.textContent = 'Show all ' + f.group.length + ' colours';
      on(more, 'click', function () { host.classList.add('opt__cways--all'); more.remove(); });
      host.appendChild(more);
    }
    host.hidden = false;
    var orig = $('[data-gmr-cway-orig]');
    if (orig) orig.hidden = true;
    var optWrap = host.closest('[data-gmr-single-color]'); // COLOR row hidden by Liquid for single-colour rugs -> show it, this design has colourway dots
    if (optWrap) optWrap.hidden = false;
  }

  function cwaysPalette(palHost, map) {
    var f = cwaysFind(map, palHost);
    if (!f || !f.cur) return;
    var e = f.cur, und = '';
    if (e.unds && e.unds.length) {
      var items = e.unds.map(function (u) {
        return '<span class="gmrpal__und"><span class="gmrpal__sw" style="background:' + u[1] + '"></span>' + u[0] + '</span>';
      }).join('');
      und = '<span class="gmrpal__div" aria-hidden="true"></span><div class="gmrpal__unds"><span class="gmrpal__lbl">Undertones</span><div class="gmrpal__undrow">' + items + '</div></div>';
    }
    palHost.innerHTML =
      '<div class="gmrpal__h">Color palette</div>' +
      '<div class="gmrpal__row"><div class="gmrpal__hero">' +
        '<span class="gmrpal__sw gmrpal__sw--hero" style="background:' + (palHost.getAttribute('data-catbg') || e.hex) + '"></span>' + // same swatch as the COLOR selector (Liquid gmr-catswatch)
        '<span class="gmrpal__htxt"><b>' + (palHost.getAttribute('data-catcolor') || e.label || e.name) + '</b><i>Hero color</i></span>' + // catalogue colour = what the receipt says
      '</div>' + und + '</div>' +
      (e.sent ? '<p class="gmrpal__note">' + e.sent + '</p>' : '');
    palHost.hidden = false;
  }

  /* COLOURWAY IN-PLACE SWAP — clicking a colour dot fetches that colour's product via the
     Section Rendering API (?section_id=main) and swaps the gallery + buy box + breadcrumb + URL
     in place, no full reload — so a design's separate colour products behave like Amazon/rugs.com
     colour variants. Reuses the proven initLoombar idiom (fetch → DOMParser → swap innerHTML →
     re-init → pushState → popstate → navigate-fallback).
     v1 SCOPE: only [data-gmr-pdp-swap] (= .pdp: gallery + buy box) is swapped. The reviews /
     customer-photos section sits OUTSIDE it and is intentionally NOT swapped, so it keeps the
     originally-loaded colour's reviews until a full navigation. */
  function initColorwaySwap() {
    var root = $('[data-gmr-pdp-swap]');
    if (!root) return;
    var busy = false;

    function rebind() {
      // re-run the element-scoped PDP behaviours against the freshly-swapped DOM. Old per-node
      // listeners die with the replaced nodes; the few window-level binders (thumb arrows, accordions)
      // leave harmless stale closures on detached nodes — acceptable for a handful of swaps.
      initGallery(); initThumbScroll(); initGalleryCarousel();
      initArButton(); initPdpAccordions(); initVariants(); initColorways(); initValue();
      var sp = $('#gmr-sticky-price'), pr = $('#gmr-price'); if (sp && pr) sp.textContent = pr.textContent;
      var ttl = root.querySelector('.buybox__title'); if (ttl) document.title = ttl.textContent.trim();
      // Scripts that arrive inside swapped innerHTML never auto-execute, and per-product
      // binders that live OUTSIDE the swap root (Magic Carpet module) still point at the
      // replaced nodes. Re-create every [data-gmr-rebind]-tagged script as a fresh element
      // so the browser executes it again against the new DOM (RugInRoom "See in Your Room"
      // loader + Magic Carpet reel). Document-wide on purpose.
      $all('script[data-gmr-rebind]').forEach(function (old) {
        var s = document.createElement('script');
        for (var i = 0; i < old.attributes.length; i++) { var a = old.attributes[i]; s.setAttribute(a.name, a.value); }
        s.text = old.text;
        old.parentNode.replaceChild(s, old);
      });
    }
    function apply(url, push) {
      if (busy) return; busy = true;
      root.classList.add('is-swapping');
      // Fetch the sibling colour's full page and lift out its [data-gmr-pdp-swap] region. We do NOT
      // use Section Rendering (?section_id) because a product's section id is page-specific
      // (template--<id>__main) and can't be reused across products; the full page is product-agnostic.
      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-gmr-pdp-swap]');
          if (!fresh) throw 0;
          root.innerHTML = fresh.innerHTML;
          rebind();
          root.classList.remove('is-swapping');
          busy = false;
          if (push !== false) history.pushState({ gmrCway: 1 }, '', url);
        })
        .catch(function () { window.location.href = url; }); // any failure → real navigation (also JS-off/crawlers via the <a href>)
    }

    on(document, 'click', function (e) {
      var a = e.target.closest ? e.target.closest('a[data-cway-swap]') : null;
      if (!a || !root.contains(a)) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || a.target === '_blank') return; // let new-tab / modified clicks navigate
      e.preventDefault();
      apply(a.getAttribute('href'), true);
    });
    on(window, 'popstate', function () {
      if (!$('[data-gmr-pdp-swap]')) return;
      apply(location.pathname + location.search, false);
    });
  }

  /* LISTING colourway dots — on collection/search cards, show up to 4 hero-colour dots
     for the design's colourways + a "+N more" count (each colour is its own product;
     the card itself still links to its rug, whose PDP carries the full circle picker).
     Indicators only (not links). Data: same assets/gmr-colorways.json. */
  function initListingCways() {
    var hosts = $all('[data-pc-cways]');
    if (!hosts.length) return;
    var src = hosts[0].getAttribute('data-src');
    if (!src) return;
    fetch(src).then(function (r) { return r.json(); }).then(function (map) {
      hosts.forEach(function (h) {
        var hit = cwaysIndex(map)[String(h.getAttribute('data-pid'))];
        if (!hit || hit.group.length < 2) return; // single-colour design -> no dots
        var g = hit.group, cur = hit.entry, SHOWN = 4;
        var others = g.filter(function (e) { return e !== cur; });
        var pick = cur ? [cur] : [];
        for (var i = 0; i < others.length && pick.length < SHOWN; i++) pick.push(others[i]);
        var frag = document.createDocumentFragment();
        pick.forEach(function (e) {
          var d = document.createElement('span');
          d.className = 'cway cway--sm' + (e === cur ? ' cway--on' : '');
          d.title = e.name + (e.label ? ' (' + e.label + ')' : '');
          var sw = document.createElement('span');
          sw.className = 'cway__sw'; sw.style.background = e.hex;
          d.appendChild(sw); frag.appendChild(d);
        });
        var moreN = g.length - pick.length;
        if (moreN > 0) {
          var m = document.createElement('span');
          m.className = 'pc__cways-more';
          m.textContent = '+' + moreN + ' more';
          frag.appendChild(m);
        }
        h.appendChild(frag);
        h.hidden = false;
      });
    }).catch(function () {});
  }

  /* vertical thumbnail rail — up/down arrows scroll the track, disabled at bounds */
  function initThumbScroll() {
    var track = $('[data-thumb-track]');
    if (!track) return;
    var up = $('[data-thumb-prev]');
    var down = $('[data-thumb-next]');
    function refresh() {
      var overflow = track.scrollHeight > track.clientHeight + 2;
      [up, down].forEach(function (b) { if (b) b.style.display = overflow ? '' : 'none'; });
      if (up) up.disabled = track.scrollTop <= 1;
      if (down) down.disabled = track.scrollTop + track.clientHeight >= track.scrollHeight - 1;
    }
    function step() { return Math.max(160, Math.round(track.clientHeight * 0.7)); }
    on(up, 'click', function () { track.scrollBy({ top: -step(), behavior: 'smooth' }); });
    on(down, 'click', function () { track.scrollBy({ top: step(), behavior: 'smooth' }); });
    on(track, 'scroll', refresh, { passive: true });
    on(window, 'resize', refresh, { passive: true });
    refresh();
  }

  /* gallery "See in Your Room" overlay button forwards to the RugInRoom app button */
  function initArButton() {
    var arBtn = $('.gallery__ar .ar-btn');
    if (!arBtn) return;
    on(arBtn, 'click', function (e) {
      e.preventDefault();
      var rir = $('.ruginroom-btn') || $('.ruginroom-block button') || $('[id*="ruginroom"] button');
      if (rir) rir.click();
    });
  }

  /* --- gallery thumbnails --- */
  function initGallery() {
    var main = $('#gmr-main-img');
    var thumbs = $all('.gthumb');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (t, i) {
      on(t, 'click', function () {
        var full = t.getAttribute('data-full');
        if (full) main.setAttribute('src', full);
        thumbs.forEach(function (o) { o.classList.remove('gthumb--on'); });
        t.classList.add('gthumb--on');
        t.focus({ preventScroll: true });    // keep focus so arrows work after a mouse click (Safari)
      });
      on(t, 'keydown', function (e) {
        var dir = (e.key === 'ArrowDown' || e.key === 'ArrowRight') ? 1
                : (e.key === 'ArrowUp'   || e.key === 'ArrowLeft')  ? -1 : 0;
        if (!dir) return;
        e.preventDefault();
        var next = thumbs[(i + dir + thumbs.length) % thumbs.length];
        next.click();                        // reuse click handler (src swap + highlight + mobile sync)
        next.focus({ preventScroll: true });
        if (next.scrollIntoView) next.scrollIntoView({ block: 'nearest' });
      });
    });
  }

  /* mobile swipeable carousel — sync dots + thumbs to the active slide, tap to navigate.
     Inert on desktop (slides/dots are display:none; no scroll events fire). */
  function initGalleryCarousel() {
    var slides = $('[data-gmr-slides]');
    if (!slides) return;
    var dots = $all('[data-gmr-dot]');
    var thumbs = $all('.gthumb');
    function setActive(i) {
      dots.forEach(function (d, di) { d.classList.toggle('gdot--on', di === i); });
      thumbs.forEach(function (t, ti) { t.classList.toggle('gthumb--on', ti === i); });
    }
    function goTo(i) { slides.scrollTo({ left: i * slides.clientWidth, behavior: 'smooth' }); }
    var raf;
    on(slides, 'scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        setActive(Math.round(slides.scrollLeft / slides.clientWidth));
      });
    }, { passive: true });
    dots.forEach(function (d) { on(d, 'click', function () { goTo(+d.getAttribute('data-gmr-dot')); }); });
    // on mobile, tapping a thumbnail scrolls the carousel (desktop keeps initGallery's src-swap)
    thumbs.forEach(function (t, ti) {
      on(t, 'click', function () { if (window.matchMedia('(max-width: 749px)').matches) goTo(ti); });
    });
  }

  /* mobile sticky add-to-cart bar — mirrors the price, forwards clicks to the real .btn-add,
     reveals once the real button scrolls off-screen. Inert on desktop (bar is display:none). */
  function initStickyAtc() {
    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar) return;
    var realBtn = $('.btn-add');
    var priceEl = $('#gmr-price');
    var stickyPrice = $('#gmr-sticky-price');
    var stickyBtn = bar.querySelector('[data-sticky-add]');
    function syncPrice() { if (priceEl && stickyPrice) stickyPrice.textContent = priceEl.textContent; }
    syncPrice();
    if (priceEl && window.MutationObserver) {
      new MutationObserver(syncPrice).observe(priceEl, { childList: true, characterData: true, subtree: true });
    }
    if (stickyBtn && realBtn) on(stickyBtn, 'click', function () { realBtn.click(); });
    // ONE-BAR RULE: the bottom edge belongs to the cart bar (initCartBar) whenever the cart
    // has items. This sticky Add-to-Cart shows only in the EMPTY-cart state, on mobile, after
    // the shopper has scrolled PAST the real button — then hands over to the cart bar on add.
    if (!realBtn) return;
    var mqM = window.matchMedia('(max-width: 749px)');
    var cartbarEl = document.querySelector('[data-cartbar]');
    function cartHasItems() { return !!(cartbarEl && cartbarEl.classList.contains('is-show')); }
    // computed straight from the button's position (no IntersectionObserver — it is
    // unreliable in the in-app webviews a lot of mobile social traffic arrives in)
    function updateBar() {
      var past = realBtn.getBoundingClientRect().bottom < 0; // scrolled beyond the real button
      bar.classList.toggle('sticky-atc--show', mqM.matches && past && !cartHasItems());
    }
    // slight delay so the cart bar's own gmr:cart listener toggles .is-show first
    on(document, 'gmr:cart', function () { setTimeout(updateBar, 80); });
    on(window, 'scroll', updateBar, { passive: true });
    on(window, 'resize', updateBar, { passive: true });
    updateBar();
  }

  /* --- pdp accordions --- */
  function initPdpAccordions() {
    var accs = $all('.pdp-acc');
    // expand an open panel to its real content height (overrides the CSS max-height cap so long
    // content — full description, the 14-row measurements table — is never clipped mid-way)
    function refresh(acc) {
      var p = $('.pdp-acc__panel', acc);
      if (p) p.style.maxHeight = acc.classList.contains('pdp-acc--open') ? p.scrollHeight + 'px' : '';
    }
    accs.forEach(function (acc) {
      var btn = $('.pdp-acc__btn', acc);
      refresh(acc); // size any default-open panel to its full height
      on(btn, 'click', function (e) {
        e.preventDefault();
        acc.classList.toggle('pdp-acc--open');
        refresh(acc);
      });
    });
    function refreshOpen() { accs.forEach(function (acc) { if (acc.classList.contains('pdp-acc--open')) refresh(acc); }); }
    on(window, 'load', refreshOpen);
    on(window, 'resize', refreshOpen);
  }

  /* --- variant selection + quantity + add-to-cart --- */
  function initVariants() {
    var form = $('form[data-gmr-product-form]') || $('form[action*="/cart/add"]');
    var dataEl = $('#gmr-product-json');

    // quantity steppers work even with a single-variant product
    var qtyInput = form ? $('input[name="quantity"]', form) : null;
    $all('.qty--lg').forEach(function (q) {
      var span = $('span', q);
      var btns = $all('button', q);
      if (!span || btns.length < 2) return;
      var down = btns[0], up = btns[1];
      function setQ(v) {
        v = Math.max(1, v);
        span.textContent = v;
        if (qtyInput) qtyInput.value = v;
      }
      on(down, 'click', function (e) { e.preventDefault(); setQ(Number(span.textContent) - 1); });
      on(up, 'click', function (e) { e.preventDefault(); setQ(Number(span.textContent) + 1); });
    });

    var product = null;
    if (dataEl) {
      try { product = JSON.parse(dataEl.textContent); } catch (e) { product = null; }
    }

    var idInput = form ? $('input[name="id"]', form) : null;
    var priceEl = $('.buybox__price b');
    var addBtn = form ? $('.btn-add', form) : $('.btn-add');

    if (product && product.variants && form) {
      var selected = []; // selected value per option index
      // seed selected from currently-on buttons, else first available variant
      var groups = $all('[data-option-index]', form);
      var optionCount = (product.options && product.options.length) ||
        (product.variants[0] && product.variants[0].options && product.variants[0].options.length) || 0;

      // initialize selected[] from the active variant (idInput) or first variant
      var initVariant = null;
      if (idInput && idInput.value) {
        initVariant = product.variants.filter(function (v) { return String(v.id) === String(idInput.value); })[0];
      }
      if (!initVariant) initVariant = product.variants[0];
      if (initVariant) selected = (initVariant.options || []).slice();

      function syncButtons() {
        groups.forEach(function (btn) {
          var idx = Number(btn.getAttribute('data-option-index'));
          var val = btn.getAttribute('data-value');
          var isOn = selected[idx] === val;
          // toggle whatever "on" class the control uses
          btn.classList.toggle('opt__color--on', isOn && btn.classList.contains('opt__color'));
          btn.classList.toggle('pill-btn--on', isOn && btn.classList.contains('pill-btn'));
          btn.classList.toggle('sizebtn--on', isOn && btn.classList.contains('sizebtn'));
          if (btn.getAttribute('aria-pressed') !== null) btn.setAttribute('aria-pressed', isOn ? 'true' : 'false');
        });
        // keep hidden native selects in sync (fallback)
        $all('select[data-option-index]', form).forEach(function (sel) {
          var idx = Number(sel.getAttribute('data-option-index'));
          if (selected[idx] != null) sel.value = selected[idx];
        });
        // also the no-JS fallback selects keyed by data-gmr-select
        $all('select[data-gmr-select]', form).forEach(function (sel) {
          var idx = Number(sel.getAttribute('data-gmr-select'));
          if (selected[idx] != null) sel.value = selected[idx];
        });
        // update the option value labels in each .opt__head
        $all('[data-gmr-opt-label]', form).forEach(function (el) {
          var idx = Number(el.getAttribute('data-gmr-opt-label'));
          if (selected[idx] != null) el.textContent = selected[idx];
        });
      }

      function matchVariant() {
        return product.variants.filter(function (v) {
          for (var i = 0; i < optionCount; i++) {
            if (v.options[i] !== selected[i]) return false;
          }
          return true;
        })[0] || null;
      }

      // per-product sizes ranked by real units sold (most-popular first), stored '|'-joined on the
      // product's gmr.popular_size metafield and emitted on the size container. The badge lands on
      // the first one that's available for the current colour/shape, so a sold-out top size falls
      // back to the next-most-popular. Empty => no badge.
      var popularSizes = (function () { var w = $('.opt__sizes', form); var v = w ? (w.getAttribute('data-popular-size') || '') : ''; return v ? v.split('|') : []; })();
      // for the current colour/shape: show each size's real price, mark sold-out, hide
      // sizes not offered for that shape, and badge the most-popular available size.
      function updateSizes() {
        var availPop = {};   // available size value -> its .sizebtn__pop element
        $all('.sizebtn[data-option-index]', form).forEach(function (btn) {
          var idx = Number(btn.getAttribute('data-option-index'));
          var val = btn.getAttribute('data-value');
          var match = null, anyForSize = false;
          product.variants.forEach(function (v) {
            if (v.options[idx] !== val) return;
            for (var i = 0; i < optionCount; i++) {
              if (i !== idx && selected[i] != null && v.options[i] !== selected[i]) return;
            }
            anyForSize = true;
            if (!match || (v.available && !match.available)) match = v;
          });
          var priceEl = $('[data-size-price]', btn);
          var popEl = $('.sizebtn__pop', btn);
          if (popEl) popEl.hidden = true;
          if (!anyForSize || !match) {
            btn.classList.add('sizebtn--hidden');
            btn.classList.remove('sizebtn--out');
            return;
          }
          btn.classList.remove('sizebtn--hidden');
          if (match.available) {
            btn.classList.remove('sizebtn--out');
            if (priceEl) priceEl.textContent = money(match.price);
            if (popEl) availPop[val] = popEl;
          } else {
            btn.classList.add('sizebtn--out');
            // sold-out sizes still show their price (for customer reference), with a "Sold out" note
            if (priceEl) priceEl.textContent = (match.price != null ? money(match.price) + ' · Sold out' : 'Sold out');
          }
        });
        // badge the most-popular size that's actually available now (falls back down the ranked list)
        for (var i = 0; i < popularSizes.length; i++) {
          var el = availPop[popularSizes[i]];
          if (el) { el.hidden = false; break; }
        }
      }

      // Liquid-style capitalize: first char upper, rest lower (matches the server-rendered spec rows)
      function capWord(s) { s = String(s); return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase(); }
      // re-render the Specifications/Measurements table for the chosen variant (same data the live site shows)
      function updateSpecs(v) {
        var ul = document.querySelector('[data-gmr-specs]');
        if (!ul || !v || !v.specs) return; // no per-variant specs -> keep the server-rendered fallback
        var frag = document.createDocumentFragment(), any = false;
        Object.keys(v.specs).forEach(function (k) {
          var val = v.specs[k];
          if (val == null || val === '') return;
          var li = document.createElement('li');
          var s = document.createElement('span'); s.textContent = capWord(k);
          var b = document.createElement('b'); b.textContent = capWord(val);
          li.appendChild(s); li.appendChild(b); frag.appendChild(li); any = true;
        });
        if (any) { ul.innerHTML = ''; ul.appendChild(frag); }
      }

      // map shape -> option index, and each image filename-base -> the shape that owns it.
      // A shape's images all share the base of that shape's variant featured_image
      // (e.g. L00585L0015C_1, _2, _3 ... all share base "L00585L0015C"), so we learn
      // base -> shape straight from the variant JSON — no hardcoded letters, self-calibrating.
      function baseOf(url) {
        if (!url) return '';
        // SKU+shape token = the leading run of the filename (minus path/query/ext) up to the first
        // "_" or "-". What follows is a per-photo index/suffix that varies between a shape's hero and
        // its detail shots (e.g. "HM0015L0113A_1_Model.webp", "…A_2.jpg", "K00216T0412A-3-_8.jpg") —
        // all must collapse to the same base ("…A") so a shape's photos group together.
        var f = url.split('?')[0].split('/').pop().replace(/\.[a-z0-9]+$/i, '');
        var m = f.match(/^[^_-]+/);   // leading run, stop at the first "_" or "-"
        return m ? m[0] : f;
      }
      var shapeIdx = -1;
      var opts = product.options || [];
      for (var oi = 0; oi < opts.length; oi++) {
        if (String(opts[oi]).toLowerCase() === 'shape') { shapeIdx = oi; break; }
      }
      var baseShape = {}; // image base -> shape value (only bases owned by a shape)
      if (shapeIdx >= 0) {
        product.variants.forEach(function (v) {
          if (v.img) baseShape[baseOf(v.img)] = v.options[shapeIdx];
        });
      }

      // Amazon/rugs.com style: keep EVERY variation's photo browsable — never hide.
      // This just un-hides everything and scrolls the strip back to the top; the per-thumb
      // ordering (active → this shape → other shapes) is set in showVariantImage's loop, which
      // is the single owner of `style.order` so the two passes can't fight over it.
      function filterThumbsByShape(shape) {
        if (shapeIdx < 0) return;
        $all('.gthumb').forEach(function (t) { t.classList.remove('gthumb--hide'); });
        var track = $('[data-thumb-track]');
        if (track) {
          track.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
          track.dispatchEvent(new Event('scroll')); // refresh up/down arrow disabled state
        }
      }

      // swap the gallery to the selected variant's image (matches the live site). Only acts when the
      // variant's image actually changes, so bumping size within one shape doesn't yank a thumbnail
      // the shopper opened by hand; switching shape (different photo) does swap it.
      var lastImgId = null;
      function showVariantImage(v) {
        if (!v || v.imgId == null || String(v.imgId) === String(lastImgId)) return;
        lastImgId = v.imgId;
        var shapeVal = shapeIdx >= 0 ? v.options[shapeIdx] : null;
        filterThumbsByShape(shapeVal);
        var thumbs = $all('.gthumb');
        var idx = -1;
        thumbs.forEach(function (t, ti) {
          var on = String(t.getAttribute('data-img-id')) === String(v.imgId);
          t.classList.toggle('gthumb--on', on);
          // show all, never hide: the selected variant photo leads (-1), then the rest of THIS shape
          // (+ shared/generic) at 0, then the OTHER shapes at 1 — so switching shape visibly brings the
          // new shape's photos to the top. flex `order` is visual-only, so the dot/slide indices below hold.
          var owner = baseShape[baseOf(t.getAttribute('data-full'))];
          t.style.order = on ? '-1' : (shapeVal == null || owner == null || owner === shapeVal) ? '0' : '1';
          if (on) idx = ti;
        });
        if (idx < 0) return; // variant image isn't in the gallery — leave it alone
        var main = $('#gmr-main-img');
        if (main && v.img) main.setAttribute('src', v.img);
        $all('[data-gmr-dot]').forEach(function (d, di) { d.classList.toggle('gdot--on', di === idx); });
        var slides = $('[data-gmr-slides]');
        if (slides && window.matchMedia('(max-width: 749px)').matches) {
          slides.scrollTo({ left: idx * slides.clientWidth, behavior: 'smooth' });
        }
      }

      function update() {
        syncButtons();
        updateSizes();
        var v = matchVariant();
        if (!v) {
          if (addBtn) { addBtn.textContent = 'Unavailable'; addBtn.disabled = true; }
          return;
        }
        if (idInput) {
          idInput.value = v.id;
          // the native Shop Pay installments banner ({{ form | payment_terms }}) re-computes
          // its amount by listening for change on the form's variant input
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        // Keep the RugInRoom block pointed at the selected variant so "See in Your Room" renders the
        // chosen shape/size — loader.js reads these data attributes fresh on every click.
        var rir = document.querySelector('[data-ruginroom]');
        if (rir) {
          var pid = rir.getAttribute('data-product-id');
          var rirBase = '/apps/ruginroom/asset?product=' + pid + '&variant=' + v.id;
          rir.setAttribute('data-glb', rirBase + '&type=glb&v=4');
          rir.setAttribute('data-usdz', rirBase + '&type=usdz&v=4');
          if (v.img) rir.setAttribute('data-image', v.img);
        }
        showVariantImage(v);
        updateSpecs(v);
        var priceStr = money(v.price);
        if (priceEl) priceEl.textContent = priceStr;
        var skuEl = document.querySelector('[data-gmr-sku]');
        if (skuEl && v.sku) skuEl.textContent = v.sku;
        window.gmrCurrentVariant = v;
        if (window.gmrValueUpdate) window.gmrValueUpdate(v);
        if (addBtn) {
          if (v.available) {
            addBtn.disabled = false;
            addBtn.textContent = 'Add to Cart · ' + priceStr;
          } else {
            addBtn.disabled = true;
            addBtn.textContent = 'Sold out';
          }
        }
      }

      groups.forEach(function (btn) {
        on(btn, 'click', function (e) {
          e.preventDefault();
          var idx = Number(btn.getAttribute('data-option-index'));
          var val = btn.getAttribute('data-value');
          selected[idx] = val;
          // if this combo doesn't exist, snap to the first (available) variant carrying this value
          if (!matchVariant()) {
            var snap = product.variants.filter(function (v) { return v.options[idx] === val && v.available; })[0] ||
                       product.variants.filter(function (v) { return v.options[idx] === val; })[0];
            if (snap && snap.options) selected = snap.options.slice();
          }
          update();
        });
      });
      $all('select[data-option-index]', form).forEach(function (sel) {
        on(sel, 'change', function () {
          var idx = Number(sel.getAttribute('data-option-index'));
          selected[idx] = sel.value;
          update();
        });
      });

      update();
    }

    // add-to-cart intercept
    if (form) {
      on(form, 'submit', function (e) {
        e.preventDefault();
        if (addBtn && addBtn.disabled) return;
        var fd = new FormData(form);
        fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res && res.status && res.status >= 400) { // sold out / max reached
              cartNotice(res.description || res.message || "That's the maximum quantity available.");
              return;
            }
            if (addBtn) {
              var label = addBtn.textContent;
              addBtn.classList.add('btn-add--done');
              addBtn.textContent = 'Added to cart ✓';
              setTimeout(function () {
                addBtn.classList.remove('btn-add--done');
                addBtn.textContent = label;
              }, 1600);
            }
            setTimeout(function () { openCartDrawer(); }, 280);
          })
          .catch(function () {});
      });
    }
  }

  /* ============================================================
     8) SEO READ-MORE — toggle .seo__body--open + button label
     ============================================================ */
  function initSeoToggle() {
    $all('[data-seo-toggle]').forEach(function (btn) {
      var body = $('[data-seo-body]') || $('.seo__body');
      if (!body) return;
      on(btn, 'click', function (e) {
        e.preventDefault();
        var open = body.classList.toggle('seo__body--open');
        btn.textContent = open ? 'Read less' : 'Read more';
      });
    });
  }

  /* ============================================================
     9) PLP FILTERS — collapsible groups + mobile filter sheet
     Facet values are native links (filter.values url_to_add/remove),
     so filtering needs no JS; this only handles open/close UI.
     ============================================================ */
  function initFilters() {
    // Mobile filter sheet — open/close + accordion groups. Delegated on document so it
    // keeps working after the Loom Bar swaps the #plp-swap region in (AJAX re-renders the sheet).
    function sheet() { return $('.fsheet'); }
    function openSheet() {
      var s = sheet(); if (!s) return;
      /* the sheet lives in the Browse region, which Match me hides — "All filters" must still work from Match me:
         flip back to Browse first, then open (owner 2026-09-24) */
      var bb = document.querySelector('[data-mlm-mode="browse"]');
      if (s.closest('[hidden]') && bb) bb.click();
      /* desktop: filters live in the Loom Bar's Refine panel, not the phone sheet */
      if (window.matchMedia('(min-width: 900px)').matches) { var rf = document.querySelector('[data-lb-refine]'); if (rf && rf.getAttribute('aria-expanded') !== 'true') rf.click(); return; }
      s.classList.add('fsheet--open'); document.body.style.overflow = 'hidden';
    }
    function closeSheet() { var s = sheet(); if (s) { s.classList.remove('fsheet--open'); document.body.style.overflow = ''; } }
    on(document, 'click', function (e) {
      var t = e.target;
      if (!t.closest) return;
      if (t.closest('[data-filter-open]')) { e.preventDefault(); openSheet(); return; }
      if (t.closest('[data-filter-close]')) { e.preventDefault(); closeSheet(); return; }
      var head = t.closest('.fsheet .fgroup__head');
      if (head) { e.preventDefault(); head.parentNode.classList.toggle('fgroup--open'); }
    });
    on(document, 'keydown', function (e) {
      var s = sheet();
      if (e.key === 'Escape' && s && s.classList.contains('fsheet--open')) closeSheet();
    });
  }

  /* ============================================================
     10) PREMIUM CLICK RIPPLE — soft terracotta ripple on tap
     ============================================================ */
  /* review wall — 3-row MARQUEE (bulletin) of visible-text review tiles from REAL reviews
     (assets/gmr-reviews.json). Rows scroll alternating directions (CSS); hovering the wall pauses ALL
     rows (CSS :hover) and the hovered tile zooms + reveals its full quote. setOrigin keeps edge tiles
     on-screen. Touch: tap a tile → pause all + zoom; tap again / a gap → resume. */
  function initReviewWall() {
    var wall = document.querySelector('[data-reviewwall]');
    if (!wall) return;
    var src = wall.getAttribute('data-src');
    if (!src) return;
    var touch = window.matchMedia && window.matchMedia('(hover: none)').matches;

    function esc(s) { var d = document.createElement('div'); d.textContent = (s == null ? '' : '' + s); return d.innerHTML; }
    function setOrigin(card) {
      var b = card.getBoundingClientRect(), W = window.innerWidth, H = window.innerHeight;
      var ox = b.left < W * 0.16 ? 'left' : (b.right > W * 0.84 ? 'right' : 'center');
      var oy = b.top < 150 ? 'top' : (b.bottom > H - 120 ? 'bottom' : 'center');
      card.style.transformOrigin = ox + ' ' + oy;
    }
    function cardHTML(rv) {
      var stars = '★★★★★'.slice(0, Math.max(1, Math.min(5, rv.r || 5)));
      return '<figure class="rw-card">'
        + (rv.img ? '<img class="rw-card__img" src="' + esc(rv.img) + '" loading="lazy" alt="">' : '')
        + '<span class="rw-card__grad"></span>'
        + '<figcaption class="rw-card__meta">'
        + '<span class="rw-card__stars" aria-hidden="true">' + stars + '</span>'
        + '<p class="rw-card__quote">“' + esc(rv.q) + '”</p>'
        + '<span class="rw-card__name">' + esc(rv.n) + ' · Verified</span>'
        + '</figcaption></figure>';
    }
    function build(reviews) {
      if (!reviews || !reviews.length) return;
      var groups = [[], [], []];
      reviews.forEach(function (rv, i) { groups[i % 3].push(rv); });
      groups.forEach(function (group) {
        if (!group.length) return;
        var cards = group.map(cardHTML).join('');
        var row = document.createElement('div');
        row.className = 'rwm-row';
        row.innerHTML = '<div class="rwm-track">' + cards + cards + '</div>'; // echo ×2 → seamless loop
        wall.appendChild(row);
      });
      if (!touch) {
        $all('.rw-card', wall).forEach(function (c) { on(c, 'mouseenter', function () { setOrigin(c); }); });
      } else {
        on(wall, 'click', function (e) {
          var card = e.target.closest ? e.target.closest('.rw-card') : null;
          var wasOpen = card && card.classList.contains('rw-card--open');
          $all('.rw-card', wall).forEach(function (c) { c.classList.remove('rw-card--open'); });
          if (card && !wasOpen) { setOrigin(card); card.classList.add('rw-card--open'); wall.classList.add('is-paused'); }
          else { wall.classList.remove('is-paused'); }
        });
      }
    }
    fetch(src).then(function (r) { return r.json(); }).then(build).catch(function () {});
  }

  /* ============================================================
     PHOTO WALL — STATIC grid of REAL customer review photos.
     No auto-scroll. Hover zooms a tile ON TOP of its neighbours
     (.pg-cell). Each tile links to that rug. Data:
     assets/gmr-customer-photos.json [{img, h(handle), t(title)}].
     ============================================================ */
  function initPhotoWall() {
    var wall = document.querySelector('[data-photowall]');
    if (!wall) return;
    var src = wall.getAttribute('data-src');
    if (!src) return;
    var touch = window.matchMedia && window.matchMedia('(hover: none)').matches;

    function esc(s) { var d = document.createElement('div'); d.textContent = (s == null ? '' : '' + s); return d.innerHTML; }
    function sizeImg(url, w) {
      if (!url) return url;
      return /[?&]w=\d+/.test(url) ? url.replace(/([?&]w=)\d+/, '$1' + w) : url + (url.indexOf('?') > -1 ? '&' : '?') + 'w=' + w;
    }
    function setOrigin(card) {
      var b = card.getBoundingClientRect(), W = window.innerWidth, H = window.innerHeight;
      var ox = b.left < W * 0.16 ? 'left' : (b.right > W * 0.84 ? 'right' : 'center');
      var oy = b.top < 150 ? 'top' : (b.bottom > H - 120 ? 'bottom' : 'center');
      card.style.transformOrigin = ox + ' ' + oy;
    }
    function tile(p) {
      if (!p || !p.img) return '';
      var img = '<img class="pg-cell__img" src="' + esc(sizeImg(p.img, 500)) + '" loading="lazy" alt="' + esc(p.t || 'Customer photo') + '">';
      return p.h
        ? '<a class="pg-cell" href="/products/' + esc(p.h) + '" title="' + esc(p.t || '') + '">' + img + '</a>'
        : '<figure class="pg-cell">' + img + '</figure>';
    }
    function build(items) {
      if (!items || !items.length) return;
      wall.insertAdjacentHTML('beforeend', items.map(tile).join('')); // static grid (laid out by CSS)
      if (!touch) {
        $all('.pg-cell', wall).forEach(function (c) { on(c, 'mouseenter', function () { setOrigin(c); }); });
      }
    }
    fetch(src).then(function (r) { return r.json(); }).then(build).catch(function () {});
  }

  /* horizontal scroll-rails with arrow buttons (desktop "Shop by category" / "Shop by color") */
  function initRails() {
    $all('[data-rail]').forEach(function (rail) {
      var sec = rail.closest('.home-sec') || rail.parentElement;
      var prev = sec ? $('[data-rail-prev]', sec) : null;
      var next = sec ? $('[data-rail-next]', sec) : null;
      if (!prev && !next) return;
      function step() { return Math.max(240, Math.round(rail.clientWidth * 0.8)); }
      function refresh() {
        var overflow = rail.scrollWidth > rail.clientWidth + 2;
        [prev, next].forEach(function (b) { if (b) b.style.visibility = overflow ? '' : 'hidden'; });
        if (prev) prev.disabled = rail.scrollLeft <= 1;
        if (next) next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 1;
      }
      if (prev) on(prev, 'click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) on(next, 'click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
      on(rail, 'scroll', refresh, { passive: true });
      on(window, 'resize', refresh, { passive: true });
      refresh();
    });
  }

  function initRipple() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var sel = 'button, .btn, .pill-btn, .sizebtn, .fchip, .chip, .swatch, .opt__color,' +
      ' .pager__b, .btn-add, .btn-checkout, .btn-buynow, .ar-btn, .promo-tile, .catpill,' +
      ' .tile, .color-tile, .room, .nav__link, .util__btn, .m-iconbtn';
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest(sel) : null;
      if (!t) return;
      var rip = document.createElement('span');
      rip.className = 'gmr-ripple';
      rip.style.left = e.clientX + 'px';
      rip.style.top = e.clientY + 'px';
      document.body.appendChild(rip);
      setTimeout(function () { if (rip.parentNode) rip.parentNode.removeChild(rip); }, 660);
    }, true);
  }

  /* ============================================================
     REVIEWS — real per-product reviews from Judge.me's public API,
     rendered in the theme's own .wreview cards (incl. customer photos
     + "show more"). The server-rendered cards inside the container are
     the no-JS / API-down fallback; they're replaced on first success.
     ============================================================ */
  function initReviews() {
    var box = $('[data-gmr-reviews]');
    if (!box) return;
    var pid = box.getAttribute('data-pid');
    var shop = box.getAttribute('data-shop');
    var total = parseInt(box.getAttribute('data-total'), 10) || 0;
    if (!pid || !shop) return;

    var cbox = document.querySelector('[data-gmr-cphotos]');   // top "Customer photos" strip host
    var moreBtn = $('[data-gmr-reviews-more]');
    var moreWrap = moreBtn ? moreBtn.parentNode : null;
    var PER_BATCH = 6, API_PER = 30, SCAN_PAGE_CAP = 5, STRIP_TILES = 14;
    var reviews = [], photos = [], shown = 0, nextPage = 1, exhausted = false, started = false, busy = false;

    function api(page) {
      var u = 'https://api.judge.me/reviews/reviews_for_widget?url=' + encodeURIComponent(shop) +
        '&shop_domain=' + encodeURIComponent(shop) + '&platform=shopify&per_page=' + API_PER +
        '&page=' + page + '&product_id=' + encodeURIComponent(pid);
      return fetch(u).then(function (r) { return r.json(); });
    }
    function txt(ctx, sel) { var e = ctx.querySelector(sel); return e ? e.textContent.trim() : ''; }
    function attr(ctx, sel, name) { var e = ctx.querySelector(sel); return e ? (e.getAttribute(name) || '') : ''; }
    function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
    function sizeImg(url, w) {
      if (!url) return url;
      return /[?&]w=\d+/.test(url) ? url.replace(/([?&]w=)\d+/, '$1' + w) : url + (url.indexOf('?') > -1 ? '&' : '?') + 'w=' + w;
    }

    function parse(html) {
      var doc = new DOMParser().parseFromString(html || '', 'text/html');
      return $all('.jdgm-rev', doc).map(function (rv) {
        var pics = $all('.jdgm-rev__pics img', rv).map(function (img) {
          return img.getAttribute('data-src') || img.getAttribute('src') || '';
        }).filter(Boolean);
        return {
          author: txt(rv, '.jdgm-rev__author') || 'Verified buyer',
          score: parseFloat(attr(rv, '.jdgm-rev__rating', 'data-score')) || 5,
          date: attr(rv, '.jdgm-rev__timestamp', 'data-content'),
          title: txt(rv, '.jdgm-rev__title'),
          body: txt(rv, '.jdgm-rev__body'),
          verified: rv.getAttribute('data-verified-buyer') === 'true',
          pics: pics
        };
      });
    }

    function stars(score) {
      var full = Math.floor(score);
      var frac = score - full;
      var half = frac >= 0.25 && frac <= 0.75;
      var off = 5 - full - (half ? 1 : 0); if (off < 0) off = 0;
      return '<span class="starrow" style="font-size:14px" aria-label="' + score + ' out of 5 stars">' +
        '★★★★★'.slice(0, full) + (half ? '<span class="starrow__half">★</span>' : '') +
        '<span class="starrow__off">' + '★★★★★'.slice(0, off) + '</span></span>';
    }
    function fmtDate(s) {
      if (!s) return '';
      var d = new Date(String(s).replace(' UTC', 'Z').replace(' ', 'T'));
      if (isNaN(d.getTime())) return '';
      return d.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
    }
    function card(r) {
      var pics = r.pics.length ? '<div class="gmr-jreview__pics">' + r.pics.map(function (src) {
        return '<button type="button" class="gmr-jreview__pic" data-gmr-pic="' + esc(sizeImg(src, 1600)) +
          '"><img src="' + esc(sizeImg(src, 320)) + '" loading="lazy" alt="Customer photo from ' + esc(r.author) + '"></button>';
      }).join('') + '</div>' : '';
      return '<article class="wreview">' +
        '<div class="wreview__top"><div class="wreview__who">' + stars(r.score) + ' <b>' + esc(r.author) + '</b>' +
        (r.verified ? ' <span class="wreview__verified">✓ Verified</span>' : '') + '</div>' +
        (r.date ? '<span class="wreview__date">' + esc(fmtDate(r.date)) + '</span>' : '') + '</div>' +
        (r.title ? '<h5>' + esc(r.title) + '</h5>' : '') +
        (r.body ? '<p>' + esc(r.body) + '</p>' : '') + pics + '</article>';
    }

    /* ---- aggregate every customer photo across the loaded reviews ---- */
    function rebuild() {
      var prev = photos.length;
      photos = [];
      for (var i = 0; i < reviews.length; i++) {
        var pics = reviews[i].pics || [];
        for (var k = 0; k < pics.length; k++) {
          photos.push({ full: sizeImg(pics[k], 1600), thumb: sizeImg(pics[k], 420), ri: i });
        }
      }
      if (photos.length !== prev) renderStrip();
    }
    function renderStrip() {
      if (!cbox) return;
      var n = photos.length;
      if (!n) { cbox.hidden = true; cbox.innerHTML = ''; return; }
      var show = Math.min(n, STRIP_TILES);
      var h = '<div class="gmr-cphotos__head">' +
        '<h3 class="gmr-cphotos__title">Customer photos<span class="gmr-cphotos__count">' + n + '</span></h3>' +
        (n > show ? '<button type="button" class="gmr-cphotos__all" data-cphoto-all>See all ' + n + ' photos</button>' : '') +
        '</div><div class="gmr-cphotos__strip">';
      for (var i = 0; i < show; i++) {
        var isMore = (i === show - 1 && n > show);
        h += '<button type="button" class="gmr-cphotos__tile' + (isMore ? ' is-more' : '') + '" data-cphoto-idx="' + i + '" aria-label="View customer photo ' + (i + 1) + '">' +
          '<img src="' + esc(photos[i].thumb) + '" loading="lazy" alt="Customer photo">' +
          (isMore ? '<span class="gmr-cphotos__more">+' + (n - show + 1) + '</span>' : '') +
          '</button>';
      }
      cbox.innerHTML = h + '</div>';
      cbox.hidden = false;
    }

    function updateMore() {
      if (!moreBtn || !moreWrap) return;
      var hasMore = shown < reviews.length || !exhausted;
      moreWrap.hidden = !hasMore;
    }
    function ensure(need) {
      if (reviews.length >= need || exhausted) return Promise.resolve();
      return api(nextPage).then(function (j) {
        var batch = parse(j && j.html);
        reviews = reviews.concat(batch);
        nextPage++;
        if (!batch.length || batch.length < API_PER || reviews.length >= (j.total_count || total || reviews.length)) exhausted = true;
        rebuild();
        if (reviews.length < need && !exhausted) return ensure(need);
      });
    }
    function renderBatch() {
      if (busy) return; busy = true;
      return ensure(shown + PER_BATCH).then(function () {
        var slice = reviews.slice(shown, shown + PER_BATCH);
        if (!slice.length) { busy = false; updateMore(); return; }
        if (shown === 0) box.innerHTML = '';
        slice.forEach(function (r) { box.insertAdjacentHTML('beforeend', card(r)); });
        shown += slice.length;
        busy = false;
        updateMore();
      }).catch(function () { busy = false; /* keep whatever is shown */ });
    }
    // proactively pull a few pages so the photo strip reflects more than just the first batch
    function scan() {
      if (exhausted || nextPage > SCAN_PAGE_CAP) return;
      ensure(reviews.length + 1).then(scan).catch(function () {});
    }
    function startOnce() { if (started) return; started = true; var p = renderBatch(); if (p && p.then) p.then(scan); else scan(); }

    on(moreBtn, 'click', renderBatch);

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (ents) {
        ents.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); startOnce(); } });
      }, { rootMargin: '700px' });
      io.observe(box);
    } else { startOnce(); }

    /* ============================================================
       Amazon-style photo gallery lightbox — big image + prev/next +
       the review it came from + a thumbnail strip. Swipeable on touch,
       arrow-keys + Esc on desktop. Operates over the aggregated photos[].
       ============================================================ */
    var gEl = null, gArr = null, gIdx = 0, gPrevOverflow = '';
    function panelHTML(p) {
      var r = (p && p.ri >= 0) ? reviews[p.ri] : null;
      if (!r) return '<p class="gmr-gallery__pannote">Customer photo</p>';
      return '<div class="gmr-gallery__panhead">' + stars(r.score) + ' <b>' + esc(r.author) + '</b>' +
        (r.verified ? ' <span class="wreview__verified">✓ Verified</span>' : '') + '</div>' +
        (r.date ? '<span class="gmr-gallery__pandate">' + esc(fmtDate(r.date)) + '</span>' : '') +
        (r.title ? '<h4 class="gmr-gallery__pantitle">' + esc(r.title) + '</h4>' : '') +
        (r.body ? '<p class="gmr-gallery__panbody">' + esc(r.body) + '</p>' : '');
    }
    function gShow(i) {
      var n = gArr.length; gIdx = ((i % n) + n) % n;
      var p = gArr[gIdx];
      gEl.querySelector('[data-gal-img]').src = p.full;
      gEl.querySelector('[data-gal-panel]').innerHTML = panelHTML(p);
      var ctr = gEl.querySelector('[data-gal-counter]'); if (ctr) ctr.textContent = (gIdx + 1) + ' / ' + n;
      var thumbs = $all('[data-gthumb]', gEl);
      thumbs.forEach(function (t, ti) { t.classList.toggle('is-active', ti === gIdx); });
      var act = thumbs[gIdx]; if (act && act.scrollIntoView) act.scrollIntoView({ inline: 'center', block: 'nearest' });
      [gIdx - 1, gIdx + 1].forEach(function (k) { var q = gArr[((k % n) + n) % n]; if (q) { var im = new Image(); im.src = q.full; } });
    }
    function gClose() {
      if (gEl && gEl.parentNode) gEl.parentNode.removeChild(gEl);
      document.removeEventListener('keydown', gKey);
      document.body.style.overflow = gPrevOverflow;
      gEl = null; gArr = null;
    }
    function gKey(e) {
      if (!gEl) return;
      if (e.key === 'Escape') gClose();
      else if (e.key === 'ArrowRight') gShow(gIdx + 1);
      else if (e.key === 'ArrowLeft') gShow(gIdx - 1);
    }
    function openGallery(i, arr) {
      if (gEl) gClose();   // never stack overlays (e.g. re-entry via a focused tile behind an open gallery)
      gArr = arr || photos;
      if (!gArr || !gArr.length) return;
      var single = gArr.length < 2, thumbsHTML = '';
      for (var t = 0; t < gArr.length; t++) {
        thumbsHTML += '<button type="button" class="gmr-gallery__thumb" data-gthumb="' + t + '"><img src="' + esc(gArr[t].thumb || gArr[t].full) + '" loading="lazy" alt=""></button>';
      }
      gEl = document.createElement('div');
      gEl.className = 'gmr-gallery';
      gEl.setAttribute('role', 'dialog');
      gEl.setAttribute('aria-modal', 'true');
      gEl.setAttribute('aria-label', 'Customer photos');
      gEl.innerHTML =
        '<button type="button" class="gmr-gallery__x" data-gal-close aria-label="Close">×</button>' +
        '<div class="gmr-gallery__card">' +
          '<div class="gmr-gallery__main">' +
            (single ? '' : '<button type="button" class="gmr-gallery__nav gmr-gallery__nav--prev" data-gal-prev aria-label="Previous photo">‹</button>') +
            '<div class="gmr-gallery__imgwrap" data-gal-imgwrap><img data-gal-img src="" alt="Customer photo"></div>' +
            (single ? '' : '<button type="button" class="gmr-gallery__nav gmr-gallery__nav--next" data-gal-next aria-label="Next photo">›</button>') +
            (single ? '' : '<span class="gmr-gallery__counter" data-gal-counter></span>') +
          '</div>' +
          '<aside class="gmr-gallery__panel" data-gal-panel></aside>' +
          (single ? '' : '<div class="gmr-gallery__thumbs">' + thumbsHTML + '</div>') +
        '</div>';
      gPrevOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      document.body.appendChild(gEl);
      gEl.addEventListener('click', function (e) {
        if (e.target === gEl || e.target.closest('[data-gal-close]')) { gClose(); return; }
        if (e.target.closest('[data-gal-prev]')) { gShow(gIdx - 1); return; }
        if (e.target.closest('[data-gal-next]')) { gShow(gIdx + 1); return; }
        var th = e.target.closest('[data-gthumb]');
        if (th) gShow(parseInt(th.getAttribute('data-gthumb'), 10) || 0);
      });
      var wrap = gEl.querySelector('[data-gal-imgwrap]'), sx = 0, sy = 0, mv = false;
      wrap.addEventListener('touchstart', function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; mv = false; }, { passive: true });
      wrap.addEventListener('touchmove', function () { mv = true; }, { passive: true });
      wrap.addEventListener('touchend', function (e) {
        if (mv && gArr.length > 1) {
          var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) gShow(gIdx + (dx < 0 ? 1 : -1));
        }
      });
      document.addEventListener('keydown', gKey);
      gShow(i || 0);
    }

    // open the gallery from the top strip
    if (cbox) on(cbox, 'click', function (e) {
      if (e.target.closest('[data-cphoto-all]')) { openGallery(0); return; }
      var tile = e.target.closest('[data-cphoto-idx]');
      if (tile) openGallery(parseInt(tile.getAttribute('data-cphoto-idx'), 10) || 0);
    });

    // open the gallery from an inline review photo (find it in the aggregated set; fall back to a single-photo view)
    on(box, 'click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-gmr-pic]') : null;
      if (!t) return;
      var src = t.getAttribute('data-gmr-pic'), gi = -1;
      for (var k = 0; k < photos.length; k++) { if (photos[k].full === src) { gi = k; break; } }
      if (gi >= 0) openGallery(gi);
      else openGallery(0, [{ full: src, thumb: src, ri: -1 }]);
    });
  }

  /* ============================================================
     MATCHER — shared room→colour-family scoring engine + result rendering.
     Reused by the Design Studio page (initDesignStudio) and the listing-page
     "Match me" mode (initListingMatch). Each caller gets its OWN instance, so
     the two pages never share answer state. Pure tables live at module scope
     (DS_TOK / DS_TEMP / …). Reads the 15-family table from #gmr-style-data and
     pulls matched rugs live from the per-colour collections (Section Rendering API).
     ============================================================ */
  function createMatcher(FAM) {
    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
    function clamp(n, lo, hi) { return Math.max(lo, Math.min(hi, n)); }

    var answers = { room: null, wall: null, floor: null, furn: null, style: null, color: null };

    /* ---- scoring ---- */
    function listHit(tokens, list) {
      if (!tokens || !tokens.length || !list) return false;
      for (var i = 0; i < list.length; i++) {
        var lab = list[i].toLowerCase();
        for (var j = 0; j < tokens.length; j++) { if (lab.indexOf(tokens[j]) > -1) return true; }
      }
      return false;
    }
    function axisScore(tokens, good, avoid) {
      if (!tokens || !tokens.length) return 0;
      if (listHit(tokens, avoid)) return -1.5;
      if (listHit(tokens, good)) return 1;
      return 0;
    }
    function computeTemp() {
      var warm = 0, cool = 0;
      function add(v) { if (v === 'warm') warm++; else if (v === 'cool') cool++; }
      if (answers.wall) add(DS_TEMP.wall[answers.wall]);
      if (answers.floor) add(DS_TEMP.floor[answers.floor]);
      if (answers.furn) add(DS_TEMP.furn[answers.furn]);
      if (answers.style) add(DS_STYLE[answers.style].temp.toLowerCase());
      if (!warm && !cool) return null;
      if (warm > cool) return 'Warm';
      if (cool > warm) return 'Cool';
      return 'Neutral';
    }
    function tempScore(fam, roomTemp) {
      if (!roomTemp) return 0;
      if (fam.temp === roomTemp) return 1;
      if (fam.temp === 'Neutral' || roomTemp === 'Neutral') return 0.3;
      return -0.5;
    }
    function desireScore(fk) {
      if (!answers.color) return 0;
      if (fk === answers.color) return 1;
      return (DS_NEIGH[answers.color] || []).indexOf(fk) > -1 ? 0.4 : -0.2;
    }
    function activeMax() {
      var m = 0;
      if (answers.wall) m += DS_W.wall;
      if (answers.floor) m += DS_W.floor;
      if (answers.furn && answers.furn !== 'mixed') m += DS_W.furn;
      if (answers.color) m += DS_W.desire;
      if (computeTemp()) m += DS_W.temp;
      if (answers.style) m += DS_W.style;
      return m;
    }
    function scoreAll() {
      var anyInput = answers.wall || answers.floor || answers.furn || answers.color || answers.style;
      if (!anyInput) { return ['natural', 'blue', 'grey'].map(function (fk) { return { fk: fk, pct: 72, raw: 0 }; }); }
      var roomTemp = computeTemp();
      var maxRaw = activeMax();
      var out = Object.keys(FAM).map(function (fk) {
        var fam = FAM[fk];
        var raw = DS_W.wall * axisScore(DS_TOK.wall[answers.wall], fam.wallRec, fam.wallAvoid)
          + DS_W.floor * axisScore(DS_TOK.floor[answers.floor], fam.floorWorks, fam.floorAvoid)
          + DS_W.furn * axisScore(DS_TOK.furn[answers.furn], fam.furnWorks, fam.furnAvoid)
          + DS_W.desire * desireScore(fk)
          + DS_W.temp * tempScore(fam, roomTemp)
          + DS_W.style * (answers.style && DS_STYLE[answers.style].fams.indexOf(fk) > -1 ? 1 : 0);
        var pct = maxRaw > 0 ? Math.round(55 + (clamp(raw, 0, maxRaw) / maxRaw) * 44) : 72;
        return { fk: fk, raw: raw, pct: pct };
      });
      out.sort(function (a, b) { return b.raw - a.raw; });
      var positive = out.filter(function (o) { return o.raw > 0; });
      return positive.length >= 3 ? positive : out;
    }
    // Best colour family for the room so far (ignores any colour pick) — pre-suggested on the colour step.
    function suggestedFamily() {
      var saved = answers.color; answers.color = null;
      var ranked = scoreAll(); answers.color = saved;
      return (ranked[0] && ranked[0].fk) || 'natural';
    }

    /* ---- reason copy ---- */
    function joinNice(arr) {
      if (arr.length === 1) return arr[0];
      if (arr.length === 2) return arr[0] + ' and ' + arr[1];
      return arr.slice(0, -1).join(', ') + ' and ' + arr[arr.length - 1];
    }
    function reasonFor(fk) {
      var fam = FAM[fk], name = fam.pal[0].n, bits = [];
      if (answers.wall && listHit(DS_TOK.wall[answers.wall], fam.wallRec)) bits.push('your ' + DS_WALL_LABEL[answers.wall] + ' walls');
      if (answers.floor && listHit(DS_TOK.floor[answers.floor], fam.floorWorks)) bits.push('your ' + DS_FLOOR_LABEL[answers.floor] + ' floor');
      if (answers.furn && answers.furn !== 'mixed' && listHit(DS_TOK.furn[answers.furn], fam.furnWorks)) bits.push('your ' + DS_FURN_LABEL[answers.furn] + ' furniture');
      if (bits.length) return name + ' pairs beautifully with ' + joinNice(bits) + '.';
      if (answers.color === fk) return 'The ' + name.toLowerCase() + ' tone you love, set off for your space.';
      return 'A versatile ' + fam.temp.toLowerCase() + ' palette that suits almost any room.';
    }

    /* ---- result rendering ---- */
    function colorHex(fk) { return fk === 'multi' ? '#C2A24E' : (FAM[fk] ? FAM[fk].pal[0].h : '#C9BBA3'); }
    function chip(label, hex) {
      return '<span class="ds-chip">' + (hex ? '<span class="ds-chip__dot" style="background:' + hex + '"></span>' : '') + esc(label) + '</span>';
    }
    function summaryHTML() {
      var chips = [];
      if (answers.wall) chips.push(chip(DS_WALL_LABEL[answers.wall] + ' walls', null));
      if (answers.floor) chips.push(chip(DS_FLOOR_LABEL[answers.floor] + ' floor', null));
      if (answers.color) chips.push(chip(FAM[answers.color].pal[0].n, colorHex(answers.color)));
      return '<div class="ds-summary__chips">' + (chips.join('') || '<span class="ds-chip">A room like yours</span>') + '</div>';
    }
    function buildGroup(fk, pct, rank) {
      var fam = FAM[fk], name = fam.pal[0].n;
      var pal = fam.pal.map(function (p) {
        return '<span class="ds-pal__sw"><span class="ds-pal__dot" style="background:' + p.h + '"></span><span class="ds-pal__n">' + esc(p.n) + '</span></span>';
      }).join('');
      var g = document.createElement('div');
      g.className = 'ds-group';
      g.innerHTML =
        '<div class="ds-group__head">' +
          '<div class="ds-group__meta">' +
            '<span class="ds-group__rank">' + (rank === 0 ? 'Your best match' : 'Also beautiful in your room') + '</span>' +
            '<h3 class="ds-group__name">' + esc(name) + '</h3>' +
            '<p class="ds-group__reason">' + esc(reasonFor(fk)) + '</p>' +
          '</div>' +
          '<div class="ds-group__score"><span class="ds-group__pct" data-target="' + pct + '">' + (prefersReduced ? pct : 0) + '<i>%</i></span><span class="ds-group__pctlabel">match</span></div>' +
        '</div>' +
        '<div class="ds-pal">' + pal + '</div>' +
        '<div class="ds-group__grid" data-ds-grid><div class="ds-group__loading">Finding your ' + esc(name.toLowerCase()) + ' rugs…</div></div>' +
        '<a class="ds-group__all" href="/collections/' + fam.col + '">Browse all rugs in this palette →</a>';
      return g;
    }
    function fetchCards(fk, gridEl, pct) {
      var col = FAM[fk].col;
      var fallback = '<a class="ds-group__fallback" href="/collections/' + col + '">See these rugs →</a>';
      fetch('/collections/' + col + '?section_id=gmr-studio-results')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var cards = $all('.pc', doc);
          if (!cards.length) { gridEl.innerHTML = fallback; return; }
          gridEl.innerHTML = '';
          cards.slice(0, 8).forEach(function (c) {
            var node = document.importNode(c, true);
            var img = node.querySelector('.pc__img');
            if (img) {
              var badge = document.createElement('span');
              badge.className = 'ds-pc-badge';
              badge.textContent = pct + '% match';
              img.appendChild(badge);
            }
            gridEl.appendChild(node);
          });
        })
        .catch(function () { gridEl.innerHTML = fallback; });
    }
    function animatePct(scope) {
      if (prefersReduced) return;
      $all('.ds-group__pct', scope).forEach(function (el) {
        var target = parseInt(el.getAttribute('data-target'), 10) || 0;
        var start = null;
        function tick(ts) {
          if (start === null) start = ts;
          var p = Math.min(1, (ts - start) / 700);
          el.firstChild.nodeValue = String(Math.round(target * p));
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      });
    }

    return {
      answers: answers, prefersReduced: prefersReduced, esc: esc, colorHex: colorHex,
      scoreAll: scoreAll, suggestedFamily: suggestedFamily, reasonFor: reasonFor,
      buildGroup: buildGroup, fetchCards: fetchCards, animatePct: animatePct, summaryHTML: summaryHTML
    };
  }

  /* ============================================================
     DESIGN STUDIO — guided room → matched-rug recommender.
     Markup: sections/gmr-design-studio.liquid. Uses createMatcher() for all
     scoring + result rendering; this function owns only the stepper/intro DOM.
     ============================================================ */
  function initDesignStudio() {
    var root = $('[data-ds]');
    if (!root) return;
    var dataEl = $('#gmr-style-data');
    var FAM = {};
    try { FAM = JSON.parse(dataEl.textContent).families || {}; } catch (e) { return; }

    var M = createMatcher(FAM);
    var answers = M.answers;
    var prefersReduced = M.prefersReduced;
    function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
    function clamp(n, lo, hi) { return Math.max(lo, Math.min(hi, n)); }
    var colorIsManual = false; // true once the customer picks a colour themselves (vs. our suggestion)

    /* ---- DOM refs ---- */
    var intro = $('[data-ds-intro]', root);
    var stage = $('[data-ds-stage]', root);
    var stepsWrap = $('[data-ds-steps]', root);
    var steps = $all('.ds-step', stepsWrap);
    var bar = $('[data-ds-bar]', root);
    var backBtn = $('[data-ds-back]', root);
    var skipBtn = $('[data-ds-skip]', root);
    var revealEl = $('[data-ds-reveal]', root);
    var mixing = $('[data-ds-mixing]', root);
    var revealInner = $('[data-ds-revealinner]', root);
    var summary = $('[data-ds-summary]', root);
    var results = $('[data-ds-results]', root);
    var cur = 0;

    /* ---- build the colour ring from the family palettes ---- */
    var ring = $('[data-ds-color-ring]', root);
    if (ring) {
      Object.keys(FAM).forEach(function (fk) {
        var p = FAM[fk].pal[0];
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ds-tile ds-tile--sw';
        b.setAttribute('data-val', fk);
        var bg = fk === 'multi' ? 'linear-gradient(135deg,#9E4A40,#C2A24E,#5B7C99)' : p.h;
        b.innerHTML = '<span class="ds-tile__dot" style="background:' + bg + '"></span><span class="ds-tile__label">' + esc(p.n) + '</span>';
        ring.appendChild(b);
      });
    }

    /* ---- stepper ---- */
    function showStep(i) {
      cur = clamp(i, 0, steps.length - 1);
      steps.forEach(function (s, idx) { s.classList.toggle('is-active', idx === cur); });
      var key = steps[cur].getAttribute('data-step');
      // Step 6 (colour): pre-suggest the best family from the room answers, unless the
      // customer has already chosen a colour themselves. They can still tap another shade.
      if (key === 'color' && !colorIsManual) { answers.color = M.suggestedFamily(); }
      if (window.gmrDsRoom) { gmrDsRoom.focus(key); if (key === 'color' && answers.color) gmrDsRoom.paint('color', answers); }
      $all('.ds-tile', steps[cur]).forEach(function (t) {
        var sel = t.getAttribute('data-val') === answers[key];
        t.classList.toggle('is-selected', sel);
        if (key === 'color') {
          var isSugg = sel && !colorIsManual;
          t.classList.toggle('is-suggested', isSugg);
          var pill = t.querySelector('.ds-tile__sugg');
          if (isSugg && !pill) { pill = document.createElement('span'); pill.className = 'ds-tile__sugg'; pill.textContent = 'Suggested'; t.appendChild(pill); }
          else if (!isSugg && pill) { pill.remove(); }
        }
      });
      if (bar) bar.style.width = Math.round(((cur + 1) / steps.length) * 100) + '%';
      if (skipBtn) skipBtn.textContent = cur === steps.length - 1 ? 'Show my matches →' : 'Skip this';
      if (backBtn) backBtn.style.visibility = cur === 0 ? 'hidden' : 'visible';
      // On phones, bring the new question to the top so the flow stays one-tap.
      if (window.innerWidth <= 640 && stage && !stage.hidden) {
        stage.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'start' });
      }
    }
    function advance() {
      if (cur >= steps.length - 1) { reveal(); return; }
      showStep(cur + 1);
    }
    on(stepsWrap, 'click', function (ev) {
      var tile = ev.target.closest ? ev.target.closest('.ds-tile') : null;
      if (!tile || !stepsWrap.contains(tile)) return;
      var key = steps[cur].getAttribute('data-step');
      answers[key] = tile.getAttribute('data-val');
      if (window.gmrDsRoom) gmrDsRoom.paint(key, answers);
      if (key === 'color') {
        colorIsManual = true; // customer overrode our suggestion
        $all('.ds-tile', steps[cur]).forEach(function (t) { t.classList.remove('is-suggested'); var p = t.querySelector('.ds-tile__sugg'); if (p) p.remove(); });
      }
      $all('.ds-tile', steps[cur]).forEach(function (t) { t.classList.toggle('is-selected', t === tile); });
      setTimeout(advance, prefersReduced ? 0 : 260);
    });
    on(backBtn, 'click', function () {
      if (cur === 0) { stage.hidden = true; intro.hidden = false; if (window.gmrDsRoom) gmrDsRoom.hide(); return; }
      showStep(cur - 1);
    });
    on(skipBtn, 'click', function () {
      var key = steps[cur].getAttribute('data-step');
      // On the colour step we keep the suggested (or chosen) colour; other steps clear.
      if (key !== 'color') answers[key] = null;
      if (window.gmrDsRoom) gmrDsRoom.paint(key, answers);
      advance();
    });
    on($('[data-ds-start]', root), 'click', function () {
      intro.hidden = true; stage.hidden = false; revealEl.hidden = true;
      if (window.gmrDsRoom) gmrDsRoom.show();
      showStep(0);
    });

    /* ---- reveal ---- */
    function chip(label, hex) {
      return '<span class="ds-chip">' + (hex ? '<span class="ds-chip__dot" style="background:' + hex + '"></span>' : '') + esc(label) + '</span>';
    }
    function renderSummary() {
      var chips = [];
      if (answers.room) chips.push(chip('For your ' + DS_ROOM_LABEL[answers.room]));
      if (answers.wall) chips.push(chip(DS_WALL_LABEL[answers.wall] + ' walls', null));
      if (answers.floor) chips.push(chip(DS_FLOOR_LABEL[answers.floor] + ' floor', null));
      if (answers.furn && answers.furn !== 'mixed') chips.push(chip(DS_FURN_LABEL[answers.furn] + ' furniture', null));
      if (answers.style) chips.push(chip(answers.style + ' look', null));
      if (answers.color) chips.push(chip(FAM[answers.color].pal[0].n, M.colorHex(answers.color)));
      summary.innerHTML = '<div class="ds-summary__chips">' + (chips.join('') || '<span class="ds-chip">A room like yours</span>') + '</div>' +
        '<button class="ds-summary__edit" type="button" data-ds-edit>Edit my room</button>';
      on($('[data-ds-edit]', summary), 'click', function () {
        revealEl.hidden = true; stage.hidden = false; showStep(0);
        stage.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'start' });
      });
    }
    function reveal() {
      intro.hidden = true; stage.hidden = true; revealEl.hidden = false;
      mixing.hidden = false; revealInner.hidden = true;
      var dots = $('[data-ds-mixing-dots]', root);
      if (dots) {
        dots.innerHTML = '';
        [answers.wall && '#C9BBA3', answers.color && M.colorHex(answers.color), answers.floor && '#C8A97E', '#B0613C'].forEach(function (h, i) {
          if (!h) return;
          var d = document.createElement('i');
          d.style.background = h; d.style.animationDelay = (i * 0.12) + 's';
          dots.appendChild(d);
        });
      }
      var ranked = M.scoreAll();
      var picks = [], usedCols = {};
      for (var i = 0; i < ranked.length && picks.length < 3; i++) {
        var col = FAM[ranked[i].fk].col;
        if (usedCols[col]) continue;
        usedCols[col] = true; picks.push(ranked[i]);
      }
      // the room celebrates: repaint from the final answers (covers the camera hand-off
      // path where the stepper never ran) and land the winning family's rug on the floor
      if (window.gmrDsRoom) { gmrDsRoom.paintAll(answers); gmrDsRoom.reveal(picks[0] && picks[0].fk); }
      setTimeout(function () {
        mixing.hidden = true; revealInner.hidden = false;
        renderSummary();
        results.innerHTML = '';
        picks.forEach(function (p, idx) {
          var g = M.buildGroup(p.fk, p.pct, idx);
          results.appendChild(g);
          M.fetchCards(p.fk, $('[data-ds-grid]', g), p.pct);
        });
        M.animatePct(results);
        revealEl.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'start' });
      }, prefersReduced ? 0 : 1100);
    }

    /* ---- camera hand-off: a room photo snapped in the header search bar
       (initRoomPhotoSearch) lands here via sessionStorage — apply the detected
       wall/floor, pre-suggest the colour family, and jump straight to the
       reveal, exactly as if the customer had finished the quiz. ---- */
    try {
      var shot = sessionStorage.getItem('gmrRoomShot');
      if (shot) {
        sessionStorage.removeItem('gmrRoomShot');
        shot = JSON.parse(shot);
        if (shot.wall && DS_TOK.wall[shot.wall]) answers.wall = shot.wall;
        if (shot.floor && DS_TOK.floor[shot.floor]) answers.floor = shot.floor;
        if (answers.wall || answers.floor) {
          answers.color = M.suggestedFamily();
          reveal();
        }
      }
    } catch (e) { /* corrupt hand-off -> normal intro */ }
  }

  /* ============================================================
     LISTING "MATCH ME" — the Design Studio engine inline on the collection
     page. A compact 3-question flow (walls → floor → colour) runs createMatcher()
     and replaces the grid in place with scored colour-family groups, without
     leaving the page. Markup lives in sections/gmr-collection.liquid.
     ============================================================ */
  function initListingMatch() {
    var switchEl = $('[data-mlm-switch]');
    var panel = $('[data-mlm-panel]');
    var browse = $('[data-mlm-browse]');
    var resultsWrap = $('[data-mlm-results]');
    if (!switchEl || !panel || !browse || !resultsWrap) return;
    var dataEl = $('#gmr-style-data');
    if (!dataEl) return;
    var FAM = {};
    try { FAM = JSON.parse(dataEl.textContent).families || {}; } catch (e) { return; }

    var M = createMatcher(FAM);
    var answers = M.answers;
    var prefersReduced = M.prefersReduced;
    function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

    var steps = $all('.ds-step', panel);
    var barFill = $('[data-mlm-bar]', panel);
    var backBtn = $('[data-mlm-back]', panel);
    var skipBtn = $('[data-mlm-skip]', panel);
    var summary = $('[data-mlm-summary]', resultsWrap);
    var mixing = $('[data-mlm-mixing]', resultsWrap);
    var grid = $('[data-mlm-grid]', resultsWrap);
    var cur = 0;
    var colorIsManual = false;

    /* colour ring built from the family palettes */
    var ring = $('[data-mlm-color-ring]', panel);
    if (ring && !ring.children.length) {
      Object.keys(FAM).forEach(function (fk) {
        var p = FAM[fk].pal[0];
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ds-tile ds-tile--sw';
        b.setAttribute('data-val', fk);
        var bg = fk === 'multi' ? 'linear-gradient(135deg,#9E4A40,#C2A24E,#5B7C99)' : p.h;
        b.innerHTML = '<span class="ds-tile__dot" style="background:' + bg + '"></span><span class="ds-tile__label">' + esc(p.n) + '</span>';
        ring.appendChild(b);
      });
    }

    function showStep(i) {
      cur = Math.max(0, Math.min(steps.length - 1, i));
      steps.forEach(function (s, idx) { s.classList.toggle('is-active', idx === cur); });
      var key = steps[cur].getAttribute('data-step');
      if (key === 'color' && !colorIsManual) { answers.color = M.suggestedFamily(); }
      $all('.ds-tile', steps[cur]).forEach(function (t) {
        var sel = t.getAttribute('data-val') === answers[key];
        t.classList.toggle('is-selected', sel);
        if (key === 'color') {
          var isSugg = sel && !colorIsManual;
          t.classList.toggle('is-suggested', isSugg);
          var pill = t.querySelector('.ds-tile__sugg');
          if (isSugg && !pill) { pill = document.createElement('span'); pill.className = 'ds-tile__sugg'; pill.textContent = 'Suggested'; t.appendChild(pill); }
          else if (!isSugg && pill) { pill.remove(); }
        }
      });
      if (barFill) barFill.style.width = Math.round(((cur + 1) / steps.length) * 100) + '%';
      if (skipBtn) skipBtn.textContent = cur === steps.length - 1 ? 'Show my matches →' : 'Skip';
      if (backBtn) backBtn.style.visibility = 'visible';
    }
    function advance() { if (cur >= steps.length - 1) { runMatch(); return; } showStep(cur + 1); }

    function setMode(match) {
      $all('[data-mlm-mode]', switchEl).forEach(function (b) {
        var on = b.getAttribute('data-mlm-mode') === (match ? 'match' : 'browse');
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      browse.hidden = match;
      panel.hidden = !match;
      var plpEl = switchEl.closest('.plp'); if (plpEl) plpEl.classList.toggle('is-match', match); /* desktop shows "All filters" beside the switch in Match me */
      resultsWrap.hidden = true;
      if (match) { cur = 0; showStep(0); }
    }

    on(switchEl, 'click', function (ev) {
      var b = ev.target.closest ? ev.target.closest('[data-mlm-mode]') : null;
      if (!b) return;
      setMode(b.getAttribute('data-mlm-mode') === 'match');
      /* The switch is sticky, so it can be tapped from deep in the grid. Swapping the grid for the quiz (or back)
         shortens the page and the browser clamps scrollY to the new bottom — the quiz ended up ABOVE the viewport
         with only the footer showing (owner 2026-09-24). Bring the switch back under the header. */
      var hero = (switchEl.closest('.plp__mrow') || switchEl).previousElementSibling, hdrEl = document.querySelector('.hdr'); /* switch now shares a row wrapper with All filters (2026-09-24) — measure from the hero above that row */
      var flowTop = (hero ? hero.getBoundingClientRect().bottom : switchEl.getBoundingClientRect().top) + window.scrollY;
      var target = Math.max(0, flowTop - (hdrEl ? hdrEl.offsetHeight : 0) - 12);
      if (window.scrollY > target) window.scrollTo({ top: target, behavior: prefersReduced ? 'auto' : 'smooth' });
    });
    on(panel, 'click', function (ev) {
      var tile = ev.target.closest ? ev.target.closest('.ds-tile') : null;
      if (!tile || !panel.contains(tile)) return;
      var key = steps[cur].getAttribute('data-step');
      answers[key] = tile.getAttribute('data-val');
      if (key === 'color') {
        colorIsManual = true;
        $all('.ds-tile', steps[cur]).forEach(function (t) { t.classList.remove('is-suggested'); var p = t.querySelector('.ds-tile__sugg'); if (p) p.remove(); });
      }
      $all('.ds-tile', steps[cur]).forEach(function (t) { t.classList.toggle('is-selected', t === tile); });
      setTimeout(advance, prefersReduced ? 0 : 240);
    });
    on(backBtn, 'click', function () { if (cur === 0) { setMode(false); return; } showStep(cur - 1); });
    on(skipBtn, 'click', function () {
      var key = steps[cur].getAttribute('data-step');
      if (key !== 'color') answers[key] = null;
      advance();
    });
    $all('[data-mlm-exit]').forEach(function (b) { on(b, 'click', function () { setMode(false); }); });

    function runMatch() {
      panel.hidden = true; resultsWrap.hidden = false;
      if (mixing) mixing.hidden = false;
      if (summary) summary.innerHTML = '';
      if (grid) grid.innerHTML = '';
      var ranked = M.scoreAll();
      var picks = [], usedCols = {};
      for (var i = 0; i < ranked.length && picks.length < 3; i++) {
        var col = FAM[ranked[i].fk].col;
        if (usedCols[col]) continue;
        usedCols[col] = true; picks.push(ranked[i]);
      }
      setTimeout(function () {
        if (mixing) mixing.hidden = true;
        if (summary) summary.innerHTML = M.summaryHTML();
        grid.innerHTML = '';
        picks.forEach(function (p, idx) {
          var g = M.buildGroup(p.fk, p.pct, idx);
          grid.appendChild(g);
          M.fetchCards(p.fk, $('[data-ds-grid]', g), p.pct);
        });
        M.animatePct(grid);
        resultsWrap.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'start' });
      }, prefersReduced ? 0 : 900);
    }
  }

  /* ============================================================
     LOOM BAR — instant, no-reload filtering for the collection grid.
     Every Loom Bar / chip / pager link carries data-plp-link; clicking one
     fetches the collection section (Section Rendering API) and swaps the
     #plp-swap region in place, keeping the URL, counts and active states in
     sync. Falls back to a normal navigation if the fetch fails or JS is off.
     ============================================================ */
  function initLoombar() {
    var swap = document.getElementById('plp-swap');
    if (!swap) return;
    var sid = swap.getAttribute('data-section-id') || 'gmr-collection';
    var live = $('[data-plp-live]');
    var busy = false;

    function announce() {
      if (!live) return;
      var c = $('.lb__count', swap);
      live.textContent = c ? ('Showing ' + c.textContent) : '';
    }
    function applyTo(url, push) {
      if (busy) return;
      busy = true;
      swap.classList.add('is-loading');
      var u = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sid;
      fetch(u, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById('plp-swap');
          if (fresh) { swap.innerHTML = fresh.innerHTML; }
          var freshBar = doc.querySelector('.plp__mbar'), curBar = document.querySelector('.plp .plp__mbar'); // mobile bar lives outside #plp-swap (above the switch) — keep its count/active-filter label current
          if (freshBar && curBar && !swap.contains(curBar)) curBar.innerHTML = freshBar.innerHTML;
          initLbCue(swap);
          /* the swap replaced every card with fresh DOM, so re-run the per-card
             enhancers that init() runs on a full page load — otherwise the
             price-match deals and colourway dots stay blank on the new page
             until a hard refresh. Both target hosts that live entirely inside
             #plp-swap, so re-running is idempotent (nothing to double-render). */
          initValue();
          initListingCways();
          swap.classList.remove('is-loading');
          busy = false;
          if (push !== false) history.pushState({ plp: 1 }, '', url);
          announce();
        })
        .catch(function () { window.location.href = url; });
    }

    on(document, 'click', function (e) {
      var a = e.target.closest ? e.target.closest('a[data-plp-link]') : null;
      if (!a || !swap.contains(a)) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || a.target === '_blank') return;
      e.preventDefault();
      applyTo(a.getAttribute('href'));
    });
    on(window, 'popstate', function () {
      if (!document.getElementById('plp-swap')) return;
      applyTo(location.pathname + location.search, false);
    });
  }

  /* The mobile colour rail (.lb-yarns) scrolls sideways but its scrollbar is
     hidden, so shoppers can't tell more colours exist. Toggle is-start / is-more
     on the .lb-scroll wrapper by scroll position so CSS can show the edge fades
     + swipe chevron. Re-run after each Loom Bar swap and on resize. */
  function initLbCue(root) {
    $all('.lb-scroll', root || document).forEach(function (wrap) {
      var sc = $('.lb-yarns, .lb-sizes, .lb-shapes', wrap);
      if (!sc) return;
      function update() {
        var max = sc.scrollWidth - sc.clientWidth;
        wrap.classList.toggle('is-start', sc.scrollLeft > 4);
        wrap.classList.toggle('is-more', max > 4 && sc.scrollLeft < max - 4);
      }
      if (!sc._cueBound) { on(sc, 'scroll', update, { passive: true }); sc._cueBound = 1; }
      update();
    });
  }

  /* ============================================================
     SMART SEARCH — reads the natural-language query intent (colour,
     room→size, shape, material, pattern) from a hardcoded lexicon, then
     surfaces "Your result" (the rug that nails every part of the query,
     with a one-line why) + "You may also like" above the normal grid.
     Data: sections/gmr-search.liquid emits #gmr-search-pool (per-product
     hay/sizes/shapes for the current results page). Pure client-side; if no
     intent is detected it does nothing and the normal grid stands.
     ============================================================ */
  function initSmartSearch() {
    var poolEl = document.getElementById('gmr-search-pool');
    if (!poolEl) return;
    var terms = (poolEl.getAttribute('data-terms') || '').toLowerCase();
    if (!terms) return;
    var pool;
    try { pool = JSON.parse(poolEl.textContent); } catch (e) { return; }
    if (!pool || !pool.length) return;
    var swap = document.getElementById('plp-swap');
    if (!swap || !swap.parentNode) return;

    /* ---- lexicons (hardcoded brain) ---- */
    var COLORS = {
      blue: ['blue', 'navy', 'indigo', 'teal', 'turquoise', 'denim', 'cobalt', 'sky', 'aqua', 'peacock'],
      green: ['green', 'sage', 'olive', 'emerald', 'mint', 'forest', 'moss', 'fern', 'pistachio'],
      red: ['red', 'crimson', 'burgundy', 'maroon', 'wine', 'scarlet', 'brick'],
      grey: ['grey', 'gray', 'silver', 'charcoal', 'slate', 'ash', 'pewter', 'smoke'],
      beige: ['beige', 'cream', 'ivory', 'tan', 'sand', 'taupe', 'natural', 'neutral', 'oatmeal', 'greige', 'wheat'],
      brown: ['brown', 'chocolate', 'coffee', 'mocha', 'walnut', 'espresso', 'camel', 'caramel'],
      black: ['black', 'onyx', 'ebony'],
      white: ['white', 'snow'],
      pink: ['pink', 'blush', 'rose', 'salmon', 'mauve'],
      purple: ['purple', 'lavender', 'lilac', 'plum', 'violet', 'eggplant'],
      orange: ['orange', 'rust', 'terracotta', 'copper', 'amber', 'apricot'],
      gold: ['gold', 'yellow', 'mustard', 'ochre', 'saffron', 'honey'],
      multi: ['multi', 'multicolor', 'multicolour', 'colorful', 'colourful', 'rainbow']
    };
    var COLOR_HEX = {
      blue: '#5B7C99', green: '#6E7A5B', red: '#9E4A40', grey: '#9B9588', beige: '#D8C7A8',
      brown: '#7C5A3C', black: '#33302B', white: '#F3EDE0', pink: '#C58794', purple: '#6E5A78',
      orange: '#C58A3D', gold: '#C2A24E', multi: 'linear-gradient(135deg,#9E4A40,#C2A24E,#5B7C99)'
    };
    var COLOR_NAME = {
      blue: 'blue', green: 'green', red: 'red', grey: 'grey', beige: 'neutral', brown: 'brown',
      black: 'black', white: 'white', pink: 'pink', purple: 'purple', orange: 'terracotta',
      gold: 'gold', multi: 'multicolour'
    };
    // room → the size tokens that fit it (matched against normalized size options)
    var ROOMS = {
      bedroom: { tokens: ['bedroom', 'master', 'guest room'], sizes: ['5x8', '5x7', '6x9'], label: 'a bedroom', size: "5'×8'" },
      dining: { tokens: ['dining'], sizes: ['9x12', '8x10'], label: 'a dining room', size: "9'×12'" },
      kitchen: { tokens: ['kitchen'], sizes: ['runner', '2x', '26x', '2.6x', '25x'], label: 'a kitchen', size: 'runner' },
      entry: { tokens: ['entry', 'entryway', 'foyer', 'hallway', 'hall', 'corridor', 'passage', 'mudroom'], sizes: ['runner', '2x', '26x', '2.6x', '25x'], label: 'an entryway', size: 'runner' },
      office: { tokens: ['office', 'study'], sizes: ['5x8', '6x9', '5x7'], label: 'a home office', size: "5'×8'" },
      accent: { tokens: ['accent', 'doormat', 'bathroom', ' bath', 'nursery', 'kids', 'children', 'small'], sizes: ['3x5', '2x3', '4x6', '2x4'], label: 'a small space', size: "3'×5'" },
      living: { tokens: ['living', 'lounge', 'family room', 'drawing room', 'great room', 'sitting room'], sizes: ['8x10', '9x12'], label: 'a living room', size: "8'×10'" }
    };
    var SHAPES = {
      round: ['round', 'circle', 'circular'], runner: ['runner'], square: ['square'],
      oval: ['oval'], octagon: ['octagon', 'octagonal']
    };
    var MATERIALS = {
      wool: ['wool'], silk: ['silk'], jute: ['jute', 'sisal', 'natural fibre', 'natural fiber'],
      cotton: ['cotton'], viscose: ['viscose', 'art silk'],
      'hand-knotted': ['hand knotted', 'hand-knotted', 'handknotted'],
      'hand-tufted': ['hand tufted', 'hand-tufted', 'tufted'],
      flatweave: ['flatweave', 'flat weave', 'kilim', 'dhurrie'], shag: ['shag', 'shaggy'],
      leather: ['leather'], hemp: ['hemp']
    };
    var PATTERNS = {
      oriental: ['oriental', 'persian'], abstract: ['abstract'], geometric: ['geometric'],
      floral: ['floral'], tribal: ['tribal'], moroccan: ['moroccan', 'beni ourain', 'beni'],
      bohemian: ['boho', 'bohemian'], vintage: ['vintage', 'distressed', 'antique'],
      traditional: ['traditional'], modern: ['modern', 'contemporary'],
      southwestern: ['southwestern', 'aztec'], medallion: ['medallion'], striped: ['striped', 'stripe']
    };

    /* ---- matching helpers (word-boundary, no substring false-positives) ---- */
    function escRe(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
    var reCache = {};
    function reFor(list) {
      var key = list.join('|');
      if (!reCache[key]) reCache[key] = new RegExp('\\b(' + list.map(escRe).join('|') + ')\\b');
      return reCache[key];
    }
    function hit(hay, list) { return reFor(list).test(hay); }
    function firstKey(map, hay) {
      for (var k in map) { var l = map[k].tokens || map[k]; if (hit(hay, l)) return k; }
      return null;
    }
    function sizeHit(sizeStr, targets) {
      if (!sizeStr) return false;
      var toks = sizeStr.split('|');
      for (var i = 0; i < toks.length; i++) {
        if (!toks[i]) continue;
        for (var j = 0; j < targets.length; j++) { if (toks[i].indexOf(targets[j]) > -1) return true; }
      }
      return false;
    }

    /* ---- parse intent ---- */
    // An explicit size typed into the query: "8x10", "8 x 10", "8'×10'", "8 by 10".
    function sizeLabel(tok) { var p = tok.split('x'); return p.length === 2 ? p[0] + "' × " + p[1] + "'" : tok; }
    var sizeMatch = terms.match(/(\d{1,2}(?:\.\d)?)['′"\s]*(?:x|×|by)['′"\s]*(\d{1,2}(?:\.\d)?)/);
    var sizeTok = sizeMatch ? (sizeMatch[1] + 'x' + sizeMatch[2]) : null;
    var intent = {
      color: firstKey(COLORS, terms),
      size: sizeTok,
      room: sizeTok ? null : firstKey(ROOMS, terms), // an exact typed size wins over a room word
      shape: firstKey(SHAPES, terms),
      material: firstKey(MATERIALS, terms),
      pattern: firstKey(PATTERNS, terms)
    };
    var dims = ['color', 'size', 'room', 'shape', 'material', 'pattern'].filter(function (d) { return intent[d]; });
    if (!dims.length) return; // no understood intent → leave the normal grid alone

    /* ---- score the result pool ---- */
    var W = { color: 3, size: 3, room: 3, shape: 2, material: 2, pattern: 2 };
    pool.forEach(function (it) {
      var sc = 0, m = {};
      if (intent.color && hit(it.hay, COLORS[intent.color])) { sc += W.color; m.color = 1; }
      if (intent.size && sizeHit(it.s, [intent.size])) { sc += W.size; m.size = 1; }
      if (intent.room && sizeHit(it.s, ROOMS[intent.room].sizes)) { sc += W.room; m.room = 1; }
      if (intent.shape && sizeHit(it.sh, SHAPES[intent.shape])) { sc += W.shape; m.shape = 1; }
      if (intent.material && hit(it.hay, MATERIALS[intent.material])) { sc += W.material; m.material = 1; }
      if (intent.pattern && hit(it.hay, PATTERNS[intent.pattern])) { sc += W.pattern; m.pattern = 1; }
      it._sc = sc; it._m = m;
      it._full = dims.every(function (d) { return m[d]; });
    });
    var ranked = pool.slice().sort(function (a, b) { return b._sc - a._sc; });
    var hero = ranked[0];
    if (!hero || hero._sc === 0) return; // nothing in this page matched → bail
    var likes = ranked.slice(1).filter(function (it) { return it._sc > 0; }).slice(0, 6);
    if (likes.length < 3) likes = ranked.slice(1, 7); // thin pool → fill with next best

    /* ---- copy ---- */
    function joinNice(a) {
      if (a.length === 1) return a[0];
      if (a.length === 2) return a[0] + ' and ' + a[1];
      return a.slice(0, -1).join(', ') + ' and ' + a[a.length - 1];
    }
    function bitsFor(m) {
      var b = [];
      if (m.color) b.push("it's " + COLOR_NAME[intent.color]);
      if (m.size) b.push('it comes in ' + sizeLabel(intent.size));
      if (m.room) b.push('it fits ' + ROOMS[intent.room].label + ' (' + ROOMS[intent.room].size + ')');
      if (m.shape) b.push("it's " + intent.shape);
      if (m.material) b.push("it's " + intent.material.replace('-', ' '));
      if (m.pattern) b.push("it's a " + intent.pattern + ' design');
      return b;
    }
    function cap(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }
    function roomName(k) { return cap(ROOMS[k].label.replace(/^an? /, '')); }
    function labelsFor(m) {
      var b = [];
      if (m.color) b.push(cap(COLOR_NAME[intent.color]));
      if (m.size) b.push(sizeLabel(intent.size));
      if (m.room) b.push(roomName(intent.room));
      if (m.shape) b.push(cap(intent.shape));
      if (m.material) b.push(cap(intent.material.replace('-', ' ')));
      if (m.pattern) b.push(cap(intent.pattern));
      return b;
    }
    // A rug that ticks every part of a multi-attribute query gets the standout gold
    // "Perfect match" badge; otherwise a translucent frosted-beige pill showing the
    // matched attribute(s) — with a colour dot when a colour matched, mirroring the
    // "we read your search" chip.
    function buildBadge(m, full) {
      var b = document.createElement('span');
      if (dims.length >= 2 && full) {
        b.className = 'smart-badge smart-badge--perfect';
        b.textContent = '✦ Perfect match';
        return b;
      }
      b.className = 'smart-badge smart-badge--attr';
      if (m.color) {
        var dot = document.createElement('span');
        dot.className = 'smart-badge__dot';
        dot.style.background = COLOR_HEX[intent.color];
        b.appendChild(dot);
      }
      b.appendChild(document.createTextNode(labelsFor(m).slice(0, 2).join(' · ') || 'Similar'));
      return b;
    }

    /* ---- DOM helpers ---- */
    function pcClone(url) {
      var src = swap.querySelector('.pc[href="' + url.replace(/"/g, '\\"') + '"]');
      return src ? document.importNode(src, true) : null;
    }
    function chip(label, hex) {
      var dot = hex ? '<span class="smart-chip__dot" style="background:' + hex + '"></span>' : '';
      return '<span class="smart-chip">' + dot + escapeHtml(label) + '</span>';
    }

    /* ---- build the smart section ---- */
    var sec = document.createElement('section');
    sec.className = 'smart';

    // "We read your search" chips
    var rc = [];
    if (intent.color) rc.push(chip(COLOR_NAME[intent.color].charAt(0).toUpperCase() + COLOR_NAME[intent.color].slice(1), COLOR_HEX[intent.color]));
    if (intent.size) rc.push(chip(sizeLabel(intent.size), null));
    if (intent.room) rc.push(chip(ROOMS[intent.room].label.replace(/^an? /, '').replace(/^./, function (c) { return c.toUpperCase(); }) + ' · ' + ROOMS[intent.room].size, null));
    if (intent.shape) rc.push(chip(intent.shape.charAt(0).toUpperCase() + intent.shape.slice(1), null));
    if (intent.material) rc.push(chip(intent.material.charAt(0).toUpperCase() + intent.material.slice(1), null));
    if (intent.pattern) rc.push(chip(intent.pattern.charAt(0).toUpperCase() + intent.pattern.slice(1), null));
    var read = document.createElement('div');
    read.className = 'smart__read';
    read.innerHTML = '<span class="smart__readlbl">We read your search</span>' + rc.join('');
    sec.appendChild(read);

    // "Your result" hero
    var heroPc = pcClone(hero.u);
    if (heroPc) {
      var heroBits = bitsFor(hero._m);
      var heading = hero._full ? 'Your result' : 'Your closest match';
      var lead = hero._full ? 'Spot on — ' : 'The closest we found — ';
      var block = document.createElement('div');
      block.className = 'smart__block';
      var why = document.createElement('div');
      why.className = 'smart-hero__why';
      why.innerHTML = '<span class="smart-hero__badge">✦ Matched for you</span>' +
        '<p class="smart-hero__txt">' + escapeHtml(lead + joinNice(heroBits)) + '.</p>' +
        '<a class="smart-hero__cta" href="' + escapeHtml(hero.u) + '">View this rug →</a>';
      var heroWrap = document.createElement('div');
      heroWrap.className = 'smart-hero';
      heroPc.classList.add('smart-hero__pc');
      heroWrap.appendChild(heroPc);
      heroWrap.appendChild(why);
      block.innerHTML = '<h2 class="smart__h">' + heading + ' <small>for “' + escapeHtml(terms) + '”</small></h2>';
      block.appendChild(heroWrap);
      sec.appendChild(block);
    }

    // "You may also like"
    var likeNodes = likes.map(function (it) {
      var pc = pcClone(it.u);
      if (!pc) return null;
      var wrap = document.createElement('div');
      wrap.className = 'smart-like';
      if (it._sc > 0) wrap.appendChild(buildBadge(it._m, it._full));
      wrap.appendChild(pc);
      return wrap;
    }).filter(Boolean);
    if (likeNodes.length) {
      var lblock = document.createElement('div');
      lblock.className = 'smart__block';
      lblock.innerHTML = '<h2 class="smart__h">You may also like</h2>';
      var grid = document.createElement('div');
      grid.className = 'grid grid--3 smart-likes';
      likeNodes.forEach(function (n) { grid.appendChild(n); });
      lblock.appendChild(grid);
      sec.appendChild(lblock);
    }

    // a heading so the full grid below reads as "everything"
    var allHead = document.createElement('h2');
    allHead.className = 'smart__h smart__h--all';
    allHead.textContent = 'All matches';

    swap.parentNode.insertBefore(sec, swap);
    var toolbar = swap.querySelector('.plp__toolbar');
    if (toolbar) toolbar.parentNode.insertBefore(allHead, toolbar);
  }

  /* ============================================================
     TRACK YOUR RUG — order / tracking / name lookup → a living journey map.
     Markup: sections/gmr-track-your-rug.liquid. Data: inline #gmr-track-data
     (emitted by gmr-track-data). Computes the rug's current position client-side
     from shipDate→eta (no API): on a US map, draws the FedEx leg from the Charlotte
     hub to the customer's city, flies a blinking rug marker to its current spot,
     fills a stage timeline / counters / event feed, and links to FedEx for
     authoritative status. Self-refreshes so the marker keeps creeping.
     ============================================================ */
  function initTrackRug() {
    var root = $('[data-trk]');
    if (!root) return;
    var dataEl = $('#gmr-track-data');
    var DATA;
    try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    /* US standard-parallel equirectangular into viewBox 0 0 800 460 — must match snippets/gmr-usmap.liquid */
    var US_LNG0 = -125, US_LAT0 = 49.5, US_SCALE = 16.5, US_KLNG = Math.cos(39 * Math.PI / 180), US_PADX = 20, US_PADY = 20;

    var form    = $('[data-trk-form]', root);
    var input   = $('[data-trk-input]', root);
    var secondWrap = $('[data-trk-second-wrap]', root);
    var secondInput = $('[data-trk-second]', root);
    var promptEl = $('[data-trk-prompt]', root);
    var results = $('[data-trk-results]', root);
    var mapwrap = $('[data-trk-mapwrap]', root);
    var svg     = $('[data-trk-svg]', root);
    var zoomBtn = $('[data-trk-zoom]', root);
    var FULL_VB = [0, 0, 800, 460];
    var gRoute  = $('[data-trk-route]', root);
    var gPoints = $('[data-trk-points]', root);
    var gMarker = $('[data-trk-marker]', root);
    var liveBadge = $('[data-trk-live]', root);
    var updatedEl = $('[data-trk-updated]', root);
    var journey = $('[data-trk-journey]', root);

    var timers = [];
    function clearTimers() { timers.forEach(function (t) { clearInterval(t); }); timers = []; }

    /* ---- cinematic auto-zoom: open on the full US map, then ease into the journey ---- */
    var curTarget = null, zoomedIn = false, vbRAF = null;
    function setVB(b) { svg.setAttribute('viewBox', b[0] + ' ' + b[1] + ' ' + b[2] + ' ' + b[3]); }
    function readVB() { var v = (svg.getAttribute('viewBox') || '0 0 800 460').split(/\s+/).map(Number); return v.length === 4 ? v : [0, 0, 800, 460]; }
    function animateVB(to, dur) {
      if (vbRAF) cancelAnimationFrame(vbRAF);
      var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (prefersReduced || !dur) { setVB(to); return; }
      var from = readVB(), t0 = null;
      function step(ts) { if (t0 === null) t0 = ts; var t = Math.min(1, (ts - t0) / dur), e = 1 - Math.pow(1 - t, 3);
        setVB([from[0] + (to[0] - from[0]) * e, from[1] + (to[1] - from[1]) * e, from[2] + (to[2] - from[2]) * e, from[3] + (to[3] - from[3]) * e]);
        if (t < 1) vbRAF = requestAnimationFrame(step); }
      vbRAF = requestAnimationFrame(step);
    }
    function targetVB(points) {
      var xs = points.map(function (p) { return p.x; }), ys = points.map(function (p) { return p.y; });
      var minX = Math.min.apply(null, xs), maxX = Math.max.apply(null, xs), minY = Math.min.apply(null, ys), maxY = Math.max.apply(null, ys);
      var ar = 800 / 460, pad = 70, w = (maxX - minX) + pad * 2, h = (maxY - minY) + pad * 2;
      if (w / h < ar) w = h * ar; else h = w / ar;
      if (w < 280) { w = 280; } h = w / ar;
      if (w > 800) { w = 800; h = 460; }
      var cx = (minX + maxX) / 2, cy = (minY + maxY) / 2, x = cx - w / 2, y = cy - h / 2;
      if (x < 0) x = 0; if (y < 0) y = 0; if (x + w > 800) x = 800 - w; if (y + h > 460) y = 460 - h;
      return [x, y, w, h];
    }
    function showZoom(on) { if (!zoomBtn) return; zoomBtn.hidden = false; zoomBtn.textContent = on ? 'Full map' : 'Zoom to rug'; }

    /* ---- pure helpers ---- */
    function esc(s) { var d = document.createElement('div'); d.textContent = (s == null ? '' : '' + s); return d.innerHTML; }
    function r1(n) { return Math.round(n * 10) / 10; }
    function clamp(n, lo, hi) { return Math.max(lo, Math.min(hi, n)); }
    function project(lng, lat) { return { x: (lng - US_LNG0) * US_SCALE * US_KLNG + US_PADX, y: (US_LAT0 - lat) * US_SCALE + US_PADY }; }
    function arcC(a, b, bow) {
      var mx = (a.x + b.x) / 2, my = (a.y + b.y) / 2, dx = b.x - a.x, dy = b.y - a.y, len = Math.hypot(dx, dy) || 1;
      var nx = -dy / len, ny = dx / len; if (ny > 0) { nx = -nx; ny = -ny; }
      return { x: mx + nx * len * bow, y: my + ny * len * bow };
    }
    function pathOver(pts) {
      var d = 'M' + r1(pts[0].x) + ' ' + r1(pts[0].y);
      for (var i = 1; i < pts.length; i++) { var c = arcC(pts[i - 1], pts[i], 0.16); d += ' Q' + r1(c.x) + ' ' + r1(c.y) + ' ' + r1(pts[i].x) + ' ' + r1(pts[i].y); }
      return d;
    }
    function miBetween(a, b) {
      var R = 3958.8, toR = Math.PI / 180;
      var dLat = (b.lat - a.lat) * toR, dLng = (b.lng - a.lng) * toR, la1 = a.lat * toR, la2 = b.lat * toR;
      var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(la1) * Math.cos(la2) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return 2 * R * Math.asin(Math.sqrt(h));
    }
    function commas(n) { return Math.round(n).toLocaleString('en-US'); }
    function asDate(s) { return new Date((s || '') + 'T00:00:00'); }
    function fmtDate(s) {
      try { return new Intl.DateTimeFormat(undefined, { weekday: 'short', month: 'short', day: 'numeric' }).format(asDate(s)); }
      catch (e) { return s; }
    }
    function relDaysNum(eta, now) { return Math.ceil((asDate(eta).getTime() - now) / 86400000); }
    function relDaysTxt(eta, now) {
      var d = relDaysNum(eta, now);
      if (d < 0) return 'Arriving any moment'; if (d === 0) return 'Arriving today'; if (d === 1) return 'Arriving tomorrow';
      return 'Arriving in ' + d + ' days';
    }
    function liveProgressOf(rec, now) {
      if (rec.status === 'delivered') return 1;
      var s = asDate(rec.shipDate).getTime(), e = asDate(rec.eta).getTime();
      if (!(e > s)) return 0;
      return clamp((now - s) / (e - s), 0, 1);
    }
    function stageOf(p, status) {
      if (status === 'delivered') return 4;
      if (p >= 1) return 4;
      if (p >= 0.85) return 3; /* out for delivery */
      if (p > 0) return 2;     /* in transit */
      return 1;                /* dispatched from Charlotte */
    }
    function maskTrk(t) { t = '' + t; return '•••• ' + t.slice(-4); }

    /* ---- lookup ---- */
    function detectQuery(raw) {
      var q = (raw || '').trim();
      if (!q) return { kind: 'empty' };
      if (q.indexOf('@') !== -1 && /\S+@\S+\.\S+/.test(q)) return { kind: 'email', value: q };
      var digits = q.replace(/[^0-9]/g, '');
      if (/^[\d\s]+$/.test(q) && digits.length >= 12) return { kind: 'tracking', value: digits };
      if (/^#?\d{1,6}$/.test(q)) return { kind: 'order', value: q.replace(/^#/, '') };
      return { kind: 'name', value: q.toLowerCase() };
    }
    function lookup(q) {
      var s = DATA.shipments || [];
      if (q.kind === 'tracking') return s.filter(function (rec) { return rec.trackingNumber === q.value; });
      if (q.kind === 'order') return s.filter(function (rec) { return rec.orderNumber === q.value; });
      if (q.kind === 'name') return s.filter(function (rec) { return (rec.customerName || '').toLowerCase().indexOf(q.value) !== -1; });
      return [];
    }

    /* ---- render: empty / disambiguation ---- */
    function showEmpty(msg, title) {
      clearTimers();
      mapwrap.hidden = true; journey.hidden = true; liveBadge.hidden = true;
      results.hidden = false;
      var lead = msg || 'Double-check the order number on your confirmation email, or paste the FedEx tracking number from your shipping notification.';
      results.innerHTML =
        '<div class="trk-empty">' +
          '<h2 class="trk-empty__h">' + esc(title || 'We couldn’t find that rug') + '</h2>' +
          '<p class="trk-empty__p">' + esc(lead) + ' Still stuck? ' +
          '<a href="/pages/contact">Contact us</a> and we’ll trace it for you.</p>' +
        '</div>';
    }
    function showDisambig(hits) {
      clearTimers();
      mapwrap.hidden = true; journey.hidden = true; liveBadge.hidden = true;
      results.hidden = false;
      var html = '<div class="trk-dis"><p class="trk-dis__h">We found a few orders — which one is yours?</p>';
      hits.forEach(function (rec, i) {
        html += '<button type="button" class="trk-dis__btn" data-pick="' + i + '">' +
          '<span><span class="trk-dis__nm">' + esc(rec.customerName) + '</span><br>' +
          '<span class="trk-dis__sub">Order #' + esc(rec.orderNumber) + ' · ' + esc(rec.rugName) + ' · ' + esc(maskTrk(rec.trackingNumber)) + '</span></span>' +
          '<span class="trk-dis__go" aria-hidden="true">→</span></button>';
      });
      html += '</div>';
      results.innerHTML = html;
      $all('[data-pick]', results).forEach(function (btn) {
        on(btn, 'click', function () { renderJourney(hits[parseInt(btn.getAttribute('data-pick'), 10)]); });
      });
    }

    /* ---- render: the living journey ---- */
    function renderJourney(rec) {
      clearTimers();

      var org = DATA.origin, dst = rec.destination;
      var pOrg = project(org.lng, org.lat), pDst = project(dst.lng, dst.lat);
      var routeD = pathOver([pOrg, pDst]);

      gRoute.innerHTML =
        '<path class="trk-live-remaining" d="' + routeD + '"></path>' +
        '<path class="trk-live-traveled" d="' + routeD + '"></path>';

      var travEl = gRoute.querySelector('.trk-live-traveled');
      var routeLen = travEl.getTotalLength();
      travEl.style.strokeDasharray = routeLen;
      travEl.style.strokeDashoffset = routeLen;

      /* hub + destination dots + labels */
      var destAnchor = pDst.x >= pOrg.x ? 'start' : 'end';
      var destLx = pDst.x + (destAnchor === 'start' ? 6 : -6);
      gPoints.innerHTML =
        '<circle class="trk-hub" cx="' + r1(pOrg.x) + '" cy="' + r1(pOrg.y) + '" r="3.2"></circle>' +
        '<text class="trk-lab" x="' + r1(pOrg.x - 6) + '" y="' + r1(pOrg.y + 12) + '" text-anchor="end">Charlotte, NC</text>' +
        '<circle class="trk-dest" cx="' + r1(pDst.x) + '" cy="' + r1(pDst.y) + '" r="3.6"></circle>' +
        '<text class="trk-lab" x="' + r1(destLx) + '" y="' + r1(pDst.y + 12) + '" text-anchor="' + destAnchor + '">' + esc(dst.label) + '</text>';

      /* the blinking rug marker */
      gMarker.innerHTML =
        '<g class="trk-mk">' +
          '<circle class="trk-halo" r="3"></circle>' +
          '<g class="trk-bob"><g transform="rotate(-12)">' +
            '<rect class="trk-rug__body" x="-7" y="-4" width="14" height="8" rx="1.4"></rect>' +
            '<path class="trk-rug__motif" d="M0 -2.3 L2.2 0 L0 2.3 L-2.2 0 Z"></path>' +
            '<line class="trk-rug__fringe" x1="-8.2" y1="-3" x2="-8.2" y2="3"></line>' +
            '<line class="trk-rug__fringe" x1="8.2" y1="-3" x2="8.2" y2="3"></line>' +
          '</g></g>' +
        '</g>';
      var mk = gMarker.querySelector('.trk-mk');

      var totalMi = miBetween(org, dst);

      mapwrap.hidden = false; liveBadge.hidden = false; journey.hidden = false; results.hidden = false;

      function placeMarker(f) {
        var pt = travEl.getPointAtLength(routeLen * clamp(f, 0, 1));
        mk.setAttribute('transform', 'translate(' + r1(pt.x) + ' ' + r1(pt.y) + ')');
      }
      function revealRoute(f) { travEl.style.strokeDashoffset = routeLen * (1 - clamp(f, 0, 1)); }

      var firstPaint = true;
      function paint(animateFlight) {
        var now = Date.now();
        var lp = liveProgressOf(rec, now);
        var stage = stageOf(lp, rec.status);

        if (animateFlight && !prefersReduced) {
          var s0 = null, dur = 2200;
          var stepFn = function (ts) {
            if (s0 === null) s0 = ts;
            var t = Math.min(1, (ts - s0) / dur), e = 1 - Math.pow(1 - t, 3), f = lp * e;
            placeMarker(f); revealRoute(f);
            if (t < 1) requestAnimationFrame(stepFn);
          };
          requestAnimationFrame(stepFn);
        } else {
          placeMarker(lp); revealRoute(lp);
        }

        paintSummary(rec, stage, now);
        journey.innerHTML = tlHTML(stage) + statsHTML(lp, totalMi, lp * totalMi, rec, now) + evHTML(rec, stage, now);
        animateStats(firstPaint);
        if (updatedEl) updatedEl.textContent = 'updated just now';
        firstPaint = false;
      }

      paint(true);

      /* keep it alive: re-interpolate position + countdown every 30s; tick the "updated" label */
      var since = 0;
      timers.push(setInterval(function () { paint(false); since = 0; }, 30000));
      timers.push(setInterval(function () {
        since += 10;
        if (updatedEl) updatedEl.textContent = since < 60 ? 'updated ' + since + 's ago' : 'updated ' + Math.floor(since / 60) + 'm ago';
      }, 10000));
    }

    /* ---- partial painters ---- */
    function paintSummary(rec, stage, now) {
      var delivered = stage === 4 && rec.status === 'delivered';
      var pillClass = delivered ? 'trk-pill trk-pill--done' : 'trk-pill';
      var pillTxt = delivered ? 'Delivered' : (stage >= 3 ? 'Out for delivery' : (stage >= 2 ? 'In transit' : 'Dispatched'));
      var relTxt = delivered ? 'Delivered' : relDaysTxt(rec.eta, now);
      var dateLab = (delivered ? 'on ' : 'by ') + fmtDate(rec.eta);
      results.innerHTML =
        '<div class="trk-sum">' +
          '<div class="trk-sum__main">' +
            '<h2 class="trk-sum__rug">' + esc(rec.rugName) + '</h2>' +
            '<p class="trk-sum__meta">Order <b>#' + esc(rec.orderNumber) + '</b> · ' + esc(rec.customerName) + ' · FedEx <b>' + esc(maskTrk(rec.trackingNumber)) + '</b> &nbsp;<span class="' + pillClass + '"><span class="trk-pill__dot"></span>' + pillTxt + '</span></p>' +
          '</div>' +
          '<div class="trk-sum__eta">' +
            '<span class="trk-sum__eta-lab">' + (delivered ? 'Delivered' : 'Estimated arrival') + '</span>' +
            '<span class="trk-sum__eta-rel">' + esc(relTxt) + '</span>' +
            '<span class="trk-sum__eta-date">' + esc(dateLab) + '</span>' +
          '</div>' +
        '</div>';
    }

    function tlHTML(stage) {
      var labels = ['Order packed', 'Dispatched · Charlotte', 'In transit', 'Out for delivery', 'Delivered'];
      var html = '<div class="trk-card trk-track-card"><div class="trk-track">';
      labels.forEach(function (lab, i) {
        var cls = 'trk-track__step';
        if (i <= stage) cls += ' is-done';
        if (i === stage) cls += ' is-current';
        html += '<div class="' + cls + '"><div class="trk-track__dot">' + (i < stage ? '✓' : '') + '</div><div class="trk-track__lab">' + lab + '</div></div>';
      });
      return html + '</div></div>';
    }

    function statsHTML(globalFrac, totalMi, traveledMi, rec, now) {
      var delivered = rec.status === 'delivered';
      var pct = Math.round(globalFrac * 100);
      var toGo = Math.max(0, totalMi - traveledMi);
      var days = delivered ? 0 : Math.max(0, relDaysNum(rec.eta, now));
      return '<div class="trk-card"><div class="trk-stats">' +
        '<div class="trk-stat"><div class="trk-stat__n" data-n="' + pct + '" data-fmt="pct">0<span class="trk-stat__u">%</span></div><div class="trk-stat__l">Journey complete</div></div>' +
        '<div class="trk-stat"><div class="trk-stat__n" data-n="' + Math.round(toGo) + '" data-fmt="mi">0</div><div class="trk-stat__l">Miles to go</div></div>' +
        '<div class="trk-stat"><div class="trk-stat__n" data-n="' + days + '" data-fmt="d">0</div><div class="trk-stat__l">' + (delivered ? 'Delivered' : 'Days to arrival') + '</div></div>' +
        '</div></div>';
    }

    function animateStats(animate) {
      $all('[data-n]', journey).forEach(function (el) {
        var target = parseInt(el.getAttribute('data-n'), 10) || 0, fmt = el.getAttribute('data-fmt');
        function setVal(v) {
          if (fmt === 'pct') el.innerHTML = v + '<span class="trk-stat__u">%</span>';
          else el.textContent = fmt === 'mi' ? commas(v) : v;
        }
        if (!animate || prefersReduced) { setVal(target); return; }
        var start = null;
        function tick(ts) { if (start === null) start = ts; var p = Math.min(1, (ts - start) / 800); setVal(Math.round(target * p)); if (p < 1) requestAnimationFrame(tick); }
        requestAnimationFrame(tick);
      });
    }

    function evHTML(rec, stage, now) {
      var steps = [
        { txt: 'Order packed at the GetMyRugs hub · Charlotte, NC', time: 'Ready to ship', on: true },
        { txt: 'Picked up by FedEx · Charlotte, NC', time: fmtDate(rec.shipDate), on: stage >= 1 },
        { txt: 'In transit toward ' + rec.destination.label, time: 'On the move', on: stage >= 2 },
        { txt: 'Out for delivery in ' + rec.destination.label, time: 'Almost there', on: stage >= 3 },
        { txt: 'Delivered · ' + rec.destination.label, time: fmtDate(rec.eta), on: stage >= 4 && rec.status === 'delivered' }
      ].filter(function (s) { return s.on; });
      steps.reverse();
      var html = '<div class="trk-card trk-feed">' +
        '<div class="trk-feed__h"><h3 class="trk-feed__title">Journey updates</h3>' +
        '<a class="trk-fedex" href="' + esc(rec.trackingUrl) + '" target="_blank" rel="noopener">View live FedEx status →</a></div>' +
        '<ul class="trk-ev">';
      steps.forEach(function (s, i) {
        html += '<li class="trk-ev__i' + (i === 0 ? ' is-on' : '') + '"><div class="trk-ev__rail"><span class="trk-ev__dot"></span><span class="trk-ev__line"></span></div>' +
          '<div class="trk-ev__body"><p class="trk-ev__txt">' + esc(s.txt) + '</p><p class="trk-ev__time">' + esc(s.time) + '</p></div></li>';
      });
      return html + '</ul></div>';
    }

    /* ---- dispatch ---- */
    /* ---- LIVE FedEx mode — real scan data from the Supabase function ----
       Returns the rug's actual FedEx scan path (geocoded), marker at the latest
       scan, real status / ETA / events. Falls back to renderJourney (estimate)
       when FedEx has nothing (e.g. the sample/demo numbers). */
    var TRACK_ENDPOINT = 'https://drpgsoiccmsbppgacljq.supabase.co/functions/v1/track';
    function fetchLive(num) {
      if (!num) return Promise.resolve(null);
      return fetch(TRACK_ENDPOINT + '?trk=' + encodeURIComponent(num))
        .then(function (r) { return r.json(); }).catch(function () { return null; });
    }
    function fetchOrder(order, email) {
      return fetch(TRACK_ENDPOINT + '?order=' + encodeURIComponent(order) + '&email=' + encodeURIComponent(email))
        .then(function (r) { return r.json(); }).catch(function () { return null; });
    }
    function liveStage(code) {
      if (code === 'DL') return 4;
      if (code === 'OD') return 3;
      if (['IT', 'DP', 'AR', 'IX', 'AF'].indexOf(code) !== -1) return 2;
      if (['PU', 'OC', 'PD', 'HL', 'PF'].indexOf(code) !== -1) return 1;
      return 2;
    }
    /* human label for a delivery stage (1..4) */
    function stageWord(stage) {
      return ['On its way', 'Picked up', 'In transit', 'Out for delivery', 'Delivered'][stage] || 'In transit';
    }
    /* Journey % follows the DELIVERY STAGE, not raw distance — so it only reaches
       100% once the rug is actually delivered. Picked up ≈15%, in transit scales
       30→80% by distance covered, out for delivery 90%, delivered 100%. */
    function journeyPct(data, frac) {
      if (data.delivered || data.statusCode === 'DL') return 100;
      var st = liveStage(data.statusCode);
      if (st >= 3) return 90;                         // out for delivery
      if (st <= 1) return 15;                          // picked up / at origin
      var f = clamp(frac == null ? 0.5 : frac, 0, 1);  // in transit
      return Math.round(30 + 50 * f);                  // 30 → 80%
    }
    function relFromTs(ts, now) {
      if (!ts) return '';
      var d = new Date(ts); if (isNaN(d.getTime())) return '';
      var ms = now - d.getTime(), days = Math.floor(ms / 86400000);
      if (ms < 0 || days > 14) { try { return new Intl.DateTimeFormat(undefined, { month: 'short', day: 'numeric', year: 'numeric' }).format(d); } catch (e) { return ('' + ts).slice(0, 10); } }
      var m = Math.round(ms / 60000);
      if (m < 1) return 'just now'; if (m < 60) return m + ' min ago';
      var h = Math.round(m / 60); if (h < 24) return h + 'h ago';
      return days + 'd ago';
    }
    function liveEvHTML(data, fedexUrl) {
      var now = Date.now(), evs = (data.events || []).slice(0, 8);
      var html = '<div class="trk-card trk-feed"><div class="trk-feed__h"><h3 class="trk-feed__title">Live FedEx updates</h3>' +
        '<a class="trk-fedex" href="' + esc(fedexUrl) + '" target="_blank" rel="noopener">Open on FedEx →</a></div><ul class="trk-ev">';
      evs.forEach(function (e, i) {
        var loc = [e.city, e.state].filter(Boolean).join(', ');
        html += '<li class="trk-ev__i' + (i === 0 ? ' is-on' : '') + '"><div class="trk-ev__rail"><span class="trk-ev__dot"></span><span class="trk-ev__line"></span></div>' +
          '<div class="trk-ev__body"><p class="trk-ev__txt">' + esc(e.desc || '') + (loc ? ' · ' + esc(loc) : '') + '</p><p class="trk-ev__time">' + esc(relFromTs(e.ts, now)) + '</p></div></li>';
      });
      return html + '</ul></div>';
    }
    function liveStatsHTML(data, pts, now) {
      var o = pts[0], c = pts[pts.length - 1];
      var dest = (data.destination && data.destination.lat != null) ? data.destination : null;
      var covered = miBetween({ lng: o.lng, lat: o.lat }, { lng: c.lng, lat: c.lat });
      var remain = (dest && !data.delivered) ? miBetween({ lng: c.lng, lat: c.lat }, { lng: dest.lng, lat: dest.lat }) : 0;
      var totalMi = Math.round(covered + remain);
      var frac = (covered + remain) > 0 ? covered / (covered + remain) : (dest ? 1 : 0.5);
      var pct = journeyPct(data, frac);
      /* derive the miles from the % so the numbers never contradict the bar */
      var coveredMi = Math.round(totalMi * pct / 100);
      var toGoMi = Math.max(0, totalMi - coveredMi);
      var etaText;
      if (data.delivered) etaText = 'Delivered';
      else {
        var dd = data.estimatedDelivery ? Math.ceil((new Date(data.estimatedDelivery).getTime() - now) / 86400000) : null;
        if (dd != null && dd > 1) etaText = dd + ' days to arrival';
        else if (dd === 1) etaText = 'Arrives tomorrow';
        else if (dd === 0) etaText = 'Arriving today';
        else etaText = stageWord(liveStage(data.statusCode));
      }
      return '<div class="trk-card trk-prog">' +
        '<div class="trk-prog__top">' +
          '<div><span class="trk-prog__pct" data-n="' + pct + '" data-fmt="pct">0</span><span class="trk-prog__lab">of the journey complete</span></div>' +
          '<div class="trk-prog__eta">' + esc(etaText) + '</div>' +
        '</div>' +
        '<div class="trk-prog__bar"><i style="width:' + pct + '%"></i></div>' +
        '<div class="trk-prog__nums">' +
          '<span><b data-n="' + coveredMi + '" data-fmt="mi">0</b> mi covered</span>' +
          '<span><b data-n="' + toGoMi + '" data-fmt="mi">0</b> mi to go</span>' +
          '<span><b data-n="' + totalMi + '" data-fmt="mi">0</b> mi total</span>' +
        '</div></div>';
    }
    function helloHTML(data) {
      if (!data.customerName && !data.rugImage) return '';
      var first = (data.customerName || '').split(' ')[0] || (data.customerName || '');
      var img = data.rugImage ? '<img class="trk-hello__img" src="' + esc(data.rugImage) + '" alt="' + esc(data.rugName || 'Your rug') + '" loading="lazy">' : '';
      var greet = first ? 'Welcome back, ' + esc(first) + ' 👋' : 'Welcome back 👋';
      return '<div class="trk-hello">' + img +
        '<div class="trk-hello__txt">' +
          '<p class="trk-hello__name">' + greet + '</p>' +
          '<p class="trk-hello__msg">Hope you’re doing well — here’s exactly where your rug is right now.</p>' +
          (data.rugName ? '<p class="trk-hello__rug">' + esc(data.rugName) + (data.orderNumber ? ' · Order #' + esc(data.orderNumber) : '') + '</p>' : '') +
        '</div></div>';
    }
    /* Pre-transit: FedEx has the label but no location scans yet (statusCode OC /
       "Label created"). The rug is real — found:true with name+order — so greet the
       customer and show the status card + FedEx feed; skip the map (nothing to plot).
       Without this, label-created shipments fell through to showEmpty() and read as
       "We couldn't find that rug" even though the lookup succeeded. */
    function renderPreTransit(data) {
      clearTimers();
      mapwrap.hidden = true; liveBadge.hidden = true; journey.hidden = false; results.hidden = false;
      if (updatedEl) updatedEl.textContent = 'live from FedEx';
      var now = Date.now();
      var rug = data.rugName || 'Your rug';
      var orderNo = data.orderNumber || '';
      var pillTxt = data.status || 'Preparing shipment';
      var etaDate = data.estimatedDelivery ? ('' + data.estimatedDelivery).slice(0, 10) : null;
      var etaFuture = etaDate && relDaysNum(etaDate, now) >= 0;
      results.innerHTML = helloHTML(data) + '<div class="trk-sum"><div class="trk-sum__main"><h2 class="trk-sum__rug">' + esc(rug) + '</h2>' +
        '<p class="trk-sum__meta">' + (orderNo ? 'Order <b>#' + esc(orderNo) + '</b> · ' : '') + 'FedEx <b>' + esc(maskTrk(data.trackingNumber)) + '</b> &nbsp;<span class="trk-pill"><span class="trk-pill__dot"></span>' + esc(pillTxt) + '</span></p></div>' +
        '<div class="trk-sum__eta"><span class="trk-sum__eta-lab">' + (etaFuture ? 'Estimated arrival' : 'Status') + '</span><span class="trk-sum__eta-rel">' + esc(etaFuture ? relDaysTxt(etaDate, now) : 'Preparing to ship') + '</span><span class="trk-sum__eta-date">' + (etaFuture ? esc('by ' + fmtDate(etaDate)) : 'Packed &amp; awaiting FedEx pickup') + '</span></div></div>';
      var fedexUrl = 'https://www.fedex.com/fedextrack/?trknbr=' + encodeURIComponent(data.trackingNumber);
      journey.innerHTML = tlHTML(liveStage(data.statusCode)) + liveEvHTML(data, fedexUrl);
    }
    /* Multi-package orders: the backend returns every shipment on the order as
       `shipments` (best/most-active one is the top-level payload). Chips let the
       customer flip between packages; each renders with the full map when it has
       scans, or the pre-transit card when it's still awaiting pickup. */
    var curShips = null;
    function renderShipment(data) {
      var evs = (data.events || []).filter(function (e) { return e.lat != null && e.lng != null; });
      if (evs.length) renderLive(data, null); else renderPreTransit(data);
      paintShipChips(data);
    }
    function paintShipChips(active) {
      if (!curShips || curShips.length < 2) return;
      var bar = document.createElement('div');
      bar.className = 'trk-ships';
      bar.innerHTML = '<span class="trk-ships__lab">This order shipped in ' + curShips.length + ' packages</span>';
      curShips.forEach(function (s) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'trk-ship' + (s.trackingNumber === active.trackingNumber ? ' is-on' : '');
        b.textContent = maskTrk(s.trackingNumber) + ' · ' + (s.delivered ? 'Delivered' : (s.statusCode === 'OC' ? 'Preparing' : stageWord(liveStage(s.statusCode))));
        on(b, 'click', function () { if (s.trackingNumber !== active.trackingNumber) renderShipment(s); });
        bar.appendChild(b);
      });
      results.insertBefore(bar, results.firstChild);
    }
    function renderLive(data, rec) {
      clearTimers();
      var now = Date.now();
      var evs = (data.events || []).filter(function (e) { return e.lat != null && e.lng != null; });
      var pts = [];
      // always anchor the path at OUR Charlotte pickup hub, then the actual FedEx scans
      var op = project(DATA.origin.lng, DATA.origin.lat);
      pts.push({ x: op.x, y: op.y, lng: DATA.origin.lng, lat: DATA.origin.lat, label: DATA.origin.label });
      evs.slice().reverse().forEach(function (e) {
        var p = project(e.lng, e.lat), last = pts[pts.length - 1];
        if (!last || Math.abs(last.x - p.x) > 0.6 || Math.abs(last.y - p.y) > 0.6) pts.push({ x: p.x, y: p.y, lng: e.lng, lat: e.lat, e: e });
      });
      if (pts.length < 2) { if (rec) return renderJourney(rec); if (data && data.found) return renderPreTransit(data); return showEmpty(); }
      var stage = liveStage(data.statusCode), firstPt = pts[0], lastPt = pts[pts.length - 1];
      var etaDate = data.estimatedDelivery ? ('' + data.estimatedDelivery).slice(0, 10) : null;

      // Charlotte → current = traveled (solid); current → destination = remaining (dotted)
      var dst = (data.destination && data.destination.lat != null) ? data.destination : null;
      var pDst = dst ? project(dst.lng, dst.lat) : null;
      var showDst = pDst && (Math.abs(pDst.x - lastPt.x) > 4 || Math.abs(pDst.y - lastPt.y) > 4);
      var travD = pathOver([{ x: firstPt.x, y: firstPt.y }, { x: lastPt.x, y: lastPt.y }]);
      var remD = showDst ? pathOver([{ x: lastPt.x, y: lastPt.y }, { x: pDst.x, y: pDst.y }]) : null;
      gRoute.innerHTML = (remD ? '<path class="trk-live-remaining" d="' + remD + '"></path>' : '') + '<path class="trk-live-traveled" d="' + travD + '"></path>';

      var origLabel = firstPt.label ? firstPt.label.split('·')[0].trim() : [firstPt.e.city, firstPt.e.state].filter(Boolean).join(', ');
      var curLabel = lastPt.e ? [lastPt.e.city, lastPt.e.state].filter(Boolean).join(', ') : (lastPt.label || '');
      var ph = '<circle class="trk-hub" cx="' + r1(firstPt.x) + '" cy="' + r1(firstPt.y) + '" r="3"></circle>';
      ph += '<text class="trk-lab" x="' + r1(firstPt.x) + '" y="' + r1(firstPt.y + 13) + '" text-anchor="middle">' + esc(origLabel) + '</text>';
      if (showDst) {
        ph += '<circle class="trk-dest" cx="' + r1(pDst.x) + '" cy="' + r1(pDst.y) + '" r="3.6"></circle>';
        ph += '<text class="trk-lab trk-lab--muted" x="' + r1(pDst.x) + '" y="' + r1(pDst.y + 13) + '" text-anchor="middle">' + esc([dst.city, dst.state].filter(Boolean).join(', ')) + '</text>';
      }
      ph += '<text class="trk-lab" x="' + r1(lastPt.x) + '" y="' + r1(lastPt.y - 9) + '" text-anchor="middle">' + esc(curLabel) + '</text>';
      gPoints.innerHTML = ph;

      gMarker.innerHTML = '<g class="trk-mk"><circle class="trk-halo" r="3"></circle><g class="trk-bob"><g transform="rotate(-12)"><rect class="trk-rug__body" x="-7" y="-4" width="14" height="8" rx="1.4"></rect><path class="trk-rug__motif" d="M0 -2.3 L2.2 0 L0 2.3 L-2.2 0 Z"></path><line class="trk-rug__fringe" x1="-8.2" y1="-3" x2="-8.2" y2="3"></line><line class="trk-rug__fringe" x1="8.2" y1="-3" x2="8.2" y2="3"></line></g></g></g>';
      var mk = gMarker.querySelector('.trk-mk');

      mapwrap.hidden = false; liveBadge.hidden = false; journey.hidden = false; results.hidden = false;
      if (updatedEl) updatedEl.textContent = 'live from FedEx';

      var tv = gRoute.querySelector('.trk-live-traveled'), L = tv.getTotalLength();
      tv.style.strokeDasharray = L;
      function place(t) { t = clamp(t, 0, 1); var pt = tv.getPointAtLength(L * t); mk.setAttribute('transform', 'translate(' + r1(pt.x) + ' ' + r1(pt.y) + ')'); tv.style.strokeDashoffset = L * (1 - t); }

      var focusPts = [firstPt, lastPt]; if (showDst) focusPts.push(pDst);
      curTarget = targetVB(focusPts);

      // open on the full US map → fly the rug Charlotte → current spot → ease-zoom into the journey
      setVB(FULL_VB);
      if (prefersReduced) { place(1); setVB(curTarget); zoomedIn = true; showZoom(true); }
      else {
        place(0);
        var s0 = null, dur = 2200;
        var fly = function (ts) {
          if (s0 === null) s0 = ts;
          var t = Math.min(1, (ts - s0) / dur), e = 1 - Math.pow(1 - t, 3);
          place(e);
          if (t < 1) requestAnimationFrame(fly);
          else { animateVB(curTarget, 1300); zoomedIn = true; showZoom(true); }
        };
        requestAnimationFrame(fly);
      }

      var rug = (rec && rec.rugName) || data.rugName || 'Your rug';
      var orderNo = (rec && rec.orderNumber) || data.orderNumber || '';
      var pill = data.delivered ? 'trk-pill trk-pill--done' : 'trk-pill';
      var pillTxt = data.delivered ? 'Delivered' : stageWord(liveStage(data.statusCode));
      var etaFuture = etaDate && relDaysNum(etaDate, now) >= 0;
      var rel = data.delivered ? 'Delivered' : (etaFuture ? relDaysTxt(etaDate, now) : pillTxt);
      var dateLab = (data.delivered || etaFuture) ? ((data.delivered ? 'on ' : 'by ') + fmtDate(etaDate)) : '';
      results.innerHTML = helloHTML(data) + '<div class="trk-sum"><div class="trk-sum__main"><h2 class="trk-sum__rug">' + esc(rug) + '</h2>' +
        '<p class="trk-sum__meta">' + (orderNo ? 'Order <b>#' + esc(orderNo) + '</b> · ' : '') + 'FedEx <b>' + esc(maskTrk(data.trackingNumber)) + '</b> &nbsp;<span class="' + pill + '"><span class="trk-pill__dot"></span>' + esc(pillTxt) + '</span></p></div>' +
        '<div class="trk-sum__eta"><span class="trk-sum__eta-lab">' + (data.delivered ? 'Delivered' : (etaFuture ? 'Estimated arrival' : 'Status')) + '</span><span class="trk-sum__eta-rel">' + esc(rel) + '</span><span class="trk-sum__eta-date">' + esc(dateLab) + '</span></div></div>';

      var fedexUrl = (rec && rec.trackingUrl) || ('https://www.fedex.com/fedextrack/?trknbr=' + encodeURIComponent(data.trackingNumber));
      journey.innerHTML = tlHTML(stage) + liveStatsHTML(data, pts, now) + liveEvHTML(data, fedexUrl);
      animateStats(true);
    }

    function setPrompt(msg) { if (promptEl) promptEl.textContent = msg; }
    function showSecond(mode) {
      if (!secondWrap || !secondInput) return;
      secondWrap.hidden = false;
      if (mode === 'order') {
        secondInput.type = 'text'; secondInput.placeholder = 'Your order number';
        secondInput.setAttribute('aria-label', 'Your order number');
      } else {
        secondInput.type = 'email'; secondInput.placeholder = 'Email on your order';
        secondInput.setAttribute('aria-label', 'Email on your order');
      }
    }
    function hideSecond() { if (secondWrap) secondWrap.hidden = true; if (secondInput) secondInput.value = ''; }

    /* one smart box: tracking# → instant; order#/email → ask for the matching
       second piece (never resolve an order by number alone — privacy). */
    function handle() {
      var v1 = (input.value || '').trim();
      var v2 = secondInput ? (secondInput.value || '').trim() : '';
      var q1 = detectQuery(v1);

      if (q1.kind === 'empty') {
        hideSecond();
        results.hidden = true; mapwrap.hidden = true; journey.hidden = true; liveBadge.hidden = true; clearTimers();
        setPrompt('Type your order number, the email on your order, or a FedEx tracking number.');
        return;
      }
      if (q1.kind === 'tracking') {
        hideSecond();
        fetchLive(q1.value).then(function (data) {
          curShips = null;
          if (data && data.found) renderShipment(data); else showEmpty();
        });
        return;
      }
      if (q1.kind === 'order') {
        var emailVal = (detectQuery(v2).kind === 'email') ? v2 : '';
        if (!emailVal) {
          showSecond('email');
          setPrompt('Almost there — enter the email on order #' + q1.value + ' to confirm it’s yours.');
          secondInput.focus();
          return;
        }
        fetchOrder(q1.value, emailVal).then(function (data) {
          curShips = (data && data.shipments && data.shipments.length > 1) ? data.shipments : null;
          if (data && data.found) renderShipment(data); else showEmpty(data && data.error && data.error.message);
        });
        return;
      }
      if (q1.kind === 'email') {
        var q2 = detectQuery(v2);
        var orderVal = (q2.kind === 'order') ? q2.value : '';
        if (!orderVal) {
          showSecond('order');
          setPrompt('Almost there — enter your order number to confirm it’s yours.');
          secondInput.focus();
          return;
        }
        fetchOrder(orderVal, q1.value).then(function (data) {
          curShips = (data && data.shipments && data.shipments.length > 1) ? data.shipments : null;
          if (data && data.found) renderShipment(data); else showEmpty(data && data.error && data.error.message);
        });
        return;
      }
      showEmpty('Enter your order number, the email on your order, or a FedEx tracking number.');
    }

    on(form, 'submit', function (e) { e.preventDefault(); handle(); });
    if (secondInput) on(secondInput, 'keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); handle(); } });
    on(zoomBtn, 'click', function () {
      if (!curTarget) return;
      zoomedIn = !zoomedIn;
      animateVB(zoomedIn ? curTarget : FULL_VB, 900);
      showZoom(zoomedIn);
    });

    /* deep-link: ?tracking= (FedEx number) or ?order=&email= */
    var qp = new URLSearchParams(location.search);
    var dlTrk = qp.get('tracking') || qp.get('trk') || '';
    var dlOrder = qp.get('order') || '';
    var dlEmail = qp.get('email') || '';
    if (dlTrk) { input.value = dlTrk; handle(); }
    else if (dlOrder) {
      input.value = dlOrder;
      if (dlEmail) { showSecond('email'); secondInput.value = dlEmail; }
      handle();
    }
  }

  /* ---------- boot ---------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
